webpackJsonprequire([1],{

/***/ 38:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(331);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/legacy/Stamp.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/legacy/Stamp.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 74:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _require = __webpack_require__(1057);

	var HTML5 = _require.HTML5;
	var createDragDropMixin = __webpack_require__(1065);

	module.exports = {
	  DragDropMixin: createDragDropMixin(HTML5),
	  ImagePreloaderMixin: __webpack_require__(1059),
	  DragLayerMixin: __webpack_require__(1058),
	  HorizontalDragAnchors: __webpack_require__(501),
	  VerticalDragAnchors: __webpack_require__(503),
	  NativeDragItemTypes: __webpack_require__(502),
	  DropEffects: __webpack_require__(355)
	};

/***/ },

/***/ 85:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	var DragItemTypes = keyMirror({
	  SECTION: null,
	  IMAGE: null
	});

	module.exports = DragItemTypes;

/***/ },

/***/ 127:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1),
	    PureRenderMixin = __webpack_require__(2),
	    TransitionEventsMixin = __webpack_require__(167);

	/**
	 * This is just like <img /> but with onTransitionEnd event
	 * that React doesn't support out of the box.
	 */
	var Img = React.createClass({
	  displayName: 'Img',

	  mixins: [TransitionEventsMixin, PureRenderMixin],

	  propTypes: {
	    onTransitionEnd: React.PropTypes.func.isRequired,
	    preventSave: React.PropTypes.bool.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      preventSave: true
	    };
	  },

	  render: function render() {
	    return React.createElement('img', _extends({}, this.props, {
	      onContextMenu: this.handleContextMenu,
	      onDragStart: this.handleDragStart }));
	  },

	  handleTransitionEnd: function handleTransitionEnd() {
	    this.props.onTransitionEnd();
	  },

	  handleContextMenu: function handleContextMenu(e) {
	    if (this.props.preventSave) {
	      e.preventDefault();
	    } else if (this.props.onContextMenu) {
	      this.props.onContextMenu(e);
	    }
	  },

	  handleDragStart: function handleDragStart(e) {
	    if (this.props.preventSave) {
	      e.preventDefault();
	    } else if (this.props.onDragStart) {
	      this.props.onDragStart(e);
	    }
	  } });

	module.exports = Img;

/***/ },

/***/ 130:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ResponsiveImageQueueMixin = __webpack_require__(86);
	var ViewportTestMixin = __webpack_require__(168);
	var ImageStore = __webpack_require__(146);
	var UserStore = __webpack_require__(5);
	var ImageUsageCounter = __webpack_require__(264);
	var ImageAttribution = __webpack_require__(263);
	var assign = __webpack_require__(15);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;var PropTypes = React.PropTypes;

	/**
	 * Provides an image queue for images inside the stamp, considering window width,
	 * whether lightbox is active and whether image is close to the viewport.
	 * Expects `getImage` to be defined and to return a valid `ImageMedia`.
	 */
	var StampImageMixin = {
	  mixins: [ResponsiveImageQueueMixin, ViewportTestMixin],

	  propTypes: {
	    lightboxState: PropTypes.oneOf(['active', 'leaving']),
	    isImageInLightbox: PropTypes.func.isRequired,
	    stamp: PropTypes.object.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return assign({
	      isAttributionVisible: false
	    }, this.getStateFromImageStore(this.props));
	  },

	  getStateFromImageStore: function getStateFromImageStore(props) {
	    var stampId = props.stamp.id,
	        inlineImage = this.getImage(props),
	        image = ImageStore.getInStamp(inlineImage.uuid, stampId),
	        sourceStamp,
	        sourceImage,
	        sourceUser;

	    if (image) {
	      sourceImage = ImageStore.getSourceImage(image);
	      sourceStamp = ImageStore.getSourceStamp(image, stampId);
	      sourceUser = UserStore.get(sourceStamp.user);
	    }

	    return { sourceImage: sourceImage, sourceStamp: sourceStamp, sourceUser: sourceUser };
	  },

	  canRenderAttribution: function canRenderAttribution() {
	    var _state = this.state;
	    var sourceStamp = _state.sourceStamp;
	    var sourceImage = _state.sourceImage;var stamp = this.props.stamp;

	    if (!sourceImage || !sourceStamp || !stamp) {
	      return false;
	    }

	    var hasSourceStamp = sourceStamp.id !== stamp.id,
	        hasOtherUsages = sourceImage && sourceImage.usageCount > 0;

	    return hasSourceStamp || hasOtherUsages;
	  },

	  componentDidMount: function componentDidMount() {
	    ImageStore.addChangeListener(this.handleImageStoreChange);
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.getImage(nextProps) !== this.getImage(this.props)) {
	      this.setState(this.getStateFromImageStore(nextProps));
	    }
	  },

	  handleImageStoreChange: function handleImageStoreChange() {
	    this.setState(this.getStateFromImageStore(this.props));
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.lightboxState !== this.props.lightboxState || prevState.isInViewport !== this.state.isInViewport) {

	      this.updateImageQueue();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    ImageStore.removeChangeListener(this.handleImageStoreChange);
	  },

	  getImageOptions: function getImageOptions() {
	    var image = this.getImage(this.props);
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: image,
	      sizes: {
	        thumb: true,
	        small: this.state.imageSize > 500,
	        normal: true,
	        retina: devicePixelRatio > 1.5 && this.state.isInViewport,
	        original: this.props.isImageInLightbox(image)
	      },
	      allowEmpty: this.props.allowEmpty
	    };
	  },

	  renderUsageCounter: function renderUsageCounter() {
	    var _state2 = this.state;
	    var sourceImage = _state2.sourceImage;
	    var isAttributionVisible = _state2.isAttributionVisible;

	    if (!sourceImage || isAttributionVisible) {
	      return;
	    }

	    if (sourceImage.usageCount > 0) {
	      return React.createElement(ImageUsageCounter, { counter: sourceImage.usageCount });
	    }
	  },

	  renderAttributionOnMobile: function renderAttributionOnMobile() {
	    if (!this.state.isAttributionVisible) {
	      return;
	    }

	    if (!this.canRenderAttribution()) {
	      return;
	    }

	    var stamp = this.props.stamp;var _state3 = this.state;
	    var sourceStamp = _state3.sourceStamp;
	    var sourceImage = _state3.sourceImage;
	    var sourceUser = _state3.sourceUser;

	    return React.createElement(ImageAttribution, { sourceStamp: sourceStamp,
	      sourceImage: sourceImage,
	      sourceUser: sourceUser,
	      stamp: stamp });
	  },

	  toggleAttributionOnMobile: function toggleAttributionOnMobile(e) {
	    if (!isMobile()) {
	      return;
	    }

	    e.stopPropagation();

	    var isAttributionVisible = this.state.isAttributionVisible;
	    this.setState({
	      isAttributionVisible: !isAttributionVisible
	    });
	  }
	};

	module.exports = StampImageMixin;

/***/ },

/***/ 137:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(898);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/legacy/Section.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/legacy/Section.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ResponsiveImageQueueMixin = __webpack_require__(86);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var gradient = __webpack_require__(123);var PropTypes = React.PropTypes;

	__webpack_require__(332);

	var BlurredBackground = React.createClass({
	  displayName: 'BlurredBackground',

	  mixins: [ResponsiveImageQueueMixin, PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    background: PropTypes.shape({
	      url: PropTypes.string.isRequired
	    }).isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 480,
	      'xs': 640,
	      'sm': 640,
	      'md': 640,
	      'lg': 640,
	      'xl': 640
	    };
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.background,
	      blur: 32,
	      sizes: {
	        small: true,
	        normal: true
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.background !== this.props.background) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var colors = this.props.background.colors,
	        hasLoadedImage = this.hasLoadedImage(),
	        style = {};

	    if (hasLoadedImage) {
	      style.backgroundImage = this.getBackgroundImageUrl();
	    } else {
	      style.backgroundImage = gradient('#' + colors.top, '#' + colors.bottom);
	    }

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: style },
	      this.renderLoaderImg()
	    );
	  }
	});

	module.exports = BlurredBackground;

/***/ },

/***/ 173:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PlayerTitle = __webpack_require__(251);
	var BlurredBackground = __webpack_require__(164);
	var PureRenderMixin = __webpack_require__(2);
	var supportsPositionSticky = __webpack_require__(300);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(335);

	var AudioContainer = React.createClass({
	  displayName: 'AudioContainer',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    background: PropTypes.object.isRequired,
	    title: PropTypes.string.isRequired,
	    username: PropTypes.string.isRequired,
	    duration: PropTypes.number.isRequired,
	    url: PropTypes.string.isRequired,
	    cover: PropTypes.node.isRequired,
	    trackList: PropTypes.node
	  },

	  className: 'stamp-AudioContainer',

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      supportsSticky: supportsPositionSticky()
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        'data-scroll-anchor': true },
	      React.createElement(
	        'div',
	        { className: 'stamp-AudioContainer-container' },
	        React.createElement(
	          'div',
	          { className: 'stamp-AudioContainer-bg' },
	          React.createElement(BlurredBackground, { background: this.props.background })
	        ),
	        React.createElement(
	          'div',
	          { className: 'stamp-AudioContainer-box' },
	          React.createElement(
	            'div',
	            { className: 'stamp-AudioContainer-player' },
	            this.props.cover
	          ),
	          React.createElement(
	            'div',
	            { className: 'stamp-AudioContainer-meta' },
	            React.createElement(PlayerTitle, { title: this.props.title,
	              username: this.props.username,
	              duration: this.props.duration,
	              linkUrl: this.props.url }),
	            this.props.trackList
	          )
	        )
	      )
	    );
	  }
	});

	module.exports = AudioContainer;

/***/ },

/***/ 174:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Img = __webpack_require__(127),
	    ImageCaption = __webpack_require__(175),
	    StampImageMixin = __webpack_require__(130),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(339);

	var GalleryImage = React.createClass({
	  displayName: 'GalleryImage',

	  mixins: [PureRenderMixin, StampImageMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    className: React.PropTypes.string.isRequired,
	    style: React.PropTypes.object,
	    caption: React.PropTypes.string,
	    image: React.PropTypes.object.isRequired,
	    imageStyle: React.PropTypes.object,
	    imageSizes: React.PropTypes.object,
	    onTransitionEnd: React.PropTypes.func.isRequired,
	    onClick: React.PropTypes.func.isRequired
	  },

	  getImage: function getImage(props) {
	    return props.image;
	  },

	  getImageSizes: function getImageSizes() {
	    return this.props.imageSizes;
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.props.className,
	        'data-scroll-anchor': true,
	        onClick: this.toggleAttributionOnMobile,
	        style: this.props.style },
	      React.createElement(
	        'div',
	        { className: 'stamp-GalleryImage' },
	        React.createElement(
	          'div',
	          { className: 'stamp-GalleryImage-imageWrapper' },
	          React.createElement(Img, { src: this.getImageSrcUrl(),
	            style: this.props.imageStyle,
	            onClick: this.handleImageClick,
	            onTransitionEnd: this.props.onTransitionEnd,
	            onLoad: this.handleImageLoad,
	            onError: this.handleImageError }),
	          this.renderUsageCounter(),
	          this.renderAttributionOnMobile()
	        ),
	        this.props.caption.length > 0 && React.createElement(ImageCaption, { caption: this.props.caption })
	      )
	    );
	  },

	  handleImageClick: function handleImageClick(e) {
	    this.props.onClick(this.props.image, e);
	  }
	});

	module.exports = GalleryImage;

/***/ },

/***/ 175:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ClassNameMixin = __webpack_require__(3),
	    FontTest = __webpack_require__(92),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(38);
	__webpack_require__(341);

	var ImageCaption = React.createClass({
	  displayName: 'ImageCaption',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'stamp-ImageCaption',

	  propTypes: {
	    caption: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    var caption = this.props.caption;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'stamp-ImageCaption-box' },
	        React.createElement(
	          FontTest,
	          { family: 'minion-pro-condensed',
	            test: caption },
	          React.createElement('div', { className: 'stamp-ImageCaption-text',
	            dangerouslySetInnerHTML: { __html: caption } })
	        )
	      )
	    );
	  }
	});

	module.exports = ImageCaption;

/***/ },

/***/ 200:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  VIDEO: {
	    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/39f44ce7-7a7c-471c-a4f1-3295cab5e5b9.png',
	    intendedScale: 2,
	    size: {
	      width: 1408,
	      height: 824
	    }
	  },

	  AUDIO: {
	    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/b7d351ee-721e-4d02-a716-864299929fe8.png',
	    intendedScale: 2,
	    size: {
	      width: 1408,
	      height: 824
	    }
	  },

	  TEXT: {
	    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/58a74f40-f364-4f12-bbe5-65d4a70b9070.png',
	    intendedScale: 2,
	    size: {
	      width: 1408,
	      height: 334
	    }
	  },

	  GALLERY: {
	    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/fea75e4d-af17-4134-8fae-ed874a6ca015.png',
	    intendedScale: 2,
	    size: {
	      width: 1408,
	      height: 824
	    }
	  },

	  POSTER: {
	    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/170cc9fe-138c-4605-8673-539c6c7c8fc6.png',
	    intendedScale: 2,
	    size: {
	      width: 1408,
	      height: 824
	    }
	  }
	};

/***/ },

/***/ 202:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  GRID: 'grid',
	  LIST: 'list'
	};

/***/ },

/***/ 203:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var CANVAS_IMAGE_DRAG = {
	  width: 128,
	  height: 128
	};

	var ImageSizes = {
	  EDITOR_GRABBAG_ITEM_DRAG: {
	    width: 64,
	    height: 64
	  },

	  EDITOR_GALLERY_IMAGE_DRAG: CANVAS_IMAGE_DRAG,

	  EDITOR_COVER_DRAG: CANVAS_IMAGE_DRAG,

	  EDITOR_POSTER_DRAG: CANVAS_IMAGE_DRAG
	};

	module.exports = ImageSizes;

/***/ },

/***/ 204:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var StampDraftStore = __webpack_require__(64);
	var DraftActionCreators = __webpack_require__(33);
	var _require = __webpack_require__(74);

	var VerticalDragAnchors = _require.VerticalDragAnchors;

	var DropEffects = _require.DropEffects;var PropTypes = React.PropTypes;

	var EditorSectionMixin = {
	  propTypes: {
	    uuid: PropTypes.string.isRequired
	  },

	  getSectionDragSource: function getSectionDragSource(previewUrl) {
	    return {
	      canDrag: function canDrag() {
	        return this.hasPreloadedImage(previewUrl);
	      },

	      beginDrag: function beginDrag() {
	        return {
	          effectsAllowed: [DropEffects.MOVE],
	          dragPreview: this.getPreloadedImage(previewUrl),
	          dragAnchors: {
	            vertical: VerticalDragAnchors.TOP
	          },
	          item: {
	            uuid: this.props.uuid
	          }
	        };
	      }
	    };
	  },

	  getSectionDropTarget: function getSectionDropTarget() {
	    return {
	      over: function over(item, e) {
	        var sectionNode = this.getDOMNode(),
	            sectionRect = sectionNode.getBoundingClientRect(),
	            sectionMidY = sectionRect.top + (sectionRect.bottom - sectionRect.top) / 2,
	            fromIndex = StampDraftStore.getSectionIndex(item.uuid),
	            isTooCloseFromAbove = e.clientY > sectionMidY && this.props.index === fromIndex - 1,
	            isTooCloseFromBelow = e.clientY < sectionMidY && this.props.index === fromIndex + 1,
	            draggedSectionId = item.uuid,
	            overSectionId = this.props.uuid;

	        if (!isTooCloseFromBelow && !isTooCloseFromAbove && draggedSectionId !== overSectionId) {
	          DraftActionCreators.moveSection(draggedSectionId, overSectionId);
	        }
	      }
	    };
	  }
	};

	module.exports = EditorSectionMixin;

/***/ },

/***/ 218:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var shallowEqual = __webpack_require__(46);

	/**
	 * A helper to avoid creating immutable objects
	 * if they don't differ from previous values.
	 */
	function firstIfShallowEqual(first, second) {
	  if (!first || !second) {
	    return second;
	  }

	  return shallowEqual(first, second) ? first : second;
	}

	module.exports = firstIfShallowEqual;

/***/ },

/***/ 222:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Promise = __webpack_require__(99)['default'];

	var getScrollY = __webpack_require__(82);

	/**
	 * Waits for elastic bounce to finish.
	 * Thanks to rAF calls, it doesn't cause unneccessary layout.
	 */
	function waitForElasticScroll() {
	  return new _Promise(function (resolve) {
	    window.requestAnimationFrame(function () {
	      var maxScrollY = document.body.scrollHeight - window.innerHeight;

	      function isReady() {
	        var scrollY = getScrollY();
	        return scrollY >= 0 && scrollY <= maxScrollY;
	      }

	      function resolveIfReady() {
	        if (isReady()) {
	          resolve();
	        } else {
	          window.requestAnimationFrame(resolveIfReady);
	        }
	      }

	      resolveIfReady();
	    });
	  });
	}

	module.exports = waitForElasticScroll;

/***/ },

/***/ 232:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(897);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/legacy/EditorMedia.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/legacy/EditorMedia.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 234:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A no-operation function which returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}

	module.exports = noop;


/***/ },

/***/ 249:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9);

	var LightboxActionCreators = {
	  showLightbox: function showLightbox(image, sectionType) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.ENTER_LIGHTBOX,
	      image: image,
	      sectionType: sectionType
	    });
	  },

	  hideLightbox: function hideLightbox() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.LEAVE_LIGHTBOX
	    });
	  } };

	module.exports = LightboxActionCreators;

/***/ },

/***/ 254:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  VIMEO: null,
	  SOUNDCLOUD: null
	});

/***/ },

/***/ 255:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    SmoothScrollMixin = __webpack_require__(259),
	    getScrollY = __webpack_require__(82);

	var ASSUMED_LINE_HEIGHT = 40,
	    ANIMATE_DURATION = 200;

	function getScrollAnchors(viewportHeight, el, id) {
	  var rect = el.getBoundingClientRect(),
	      rectCenter = (rect.bottom - rect.top) / 2,
	      type = el.getAttribute('data-scroll-anchor') || 'image',
	      viewportMiddle = viewportHeight / 2,
	      element;

	  element = {
	    id: id,
	    type: type
	  };

	  if (rectCenter > viewportMiddle) {
	    return [{ el: element, shift: rect.top }, { el: element, shift: rect.bottom - viewportHeight }];
	  } else {
	    return { el: element, shift: rect.top + rectCenter - viewportMiddle };
	  }
	}

	/**
	 * Provides keydown and keyup handlers that, when invoked, will mimic browser
	 * scrolling but the scroll will snap, when close enough, to the center of
	 * the next (or previous) child with `data-scroll-anchor` attribute.
	 *
	 * You can optionally specify scroll anchor type (`text` or `image`) as the
	 * value of `data-scroll-anchor` attribute. By default, `image` is assumed.
	 * This changes how much content we are allowed to skip when snapping. We may
	 * skip tall image's start and end, but we may not skip any part of the text.
	 *
	 * The calling code must explicitly subscribe to `keydown` and `keyup` events,
	 * check `isSpaceKeyEvent` and call `handleSpaceKeyUp` and `handleSpaceKeyDown`
	 * when appropriate. This allows the calling code to have more control over
	 * what happens.
	 */
	var AnchorScrollMixin = {
	  mixins: [SmoothScrollMixin],

	  isSpaceKeyEvent: function isSpaceKeyEvent(e) {
	    return e.keyCode === 32;
	  },

	  isSpaceKeyHeld: function isSpaceKeyHeld() {
	    return this._isSpaceKeyHeld;
	  },

	  handleSpaceKeyUp: function handleSpaceKeyUp() {
	    this._isSpaceKeyHeld = false;
	  },

	  handleSpaceKeyDown: function handleSpaceKeyDown(e) {
	    if (e.target !== document.body) {
	      return;
	    }

	    var shouldBailOut = this.isSpaceKeyHeld();
	    if (shouldBailOut) {
	      return;
	    }

	    this._isSpaceKeyHeld = true;

	    var isForward = !e.shiftKey,
	        candidateAnchorY = this._getCandidateAnchorY(isForward);

	    if (_.isNumber(candidateAnchorY)) {
	      e.preventDefault();
	      this.animateScroll(candidateAnchorY, ANIMATE_DURATION);
	      this._lastTargetY = candidateAnchorY;
	    }
	  },

	  _getCandidateAnchorY: function _getCandidateAnchorY(isForward) {
	    var vh = window.innerHeight,
	        scrollY = getScrollY(),
	        lastTargetY = this.isAnimatingScroll() ? this._lastTargetY : scrollY,
	        anchors = this._findScrollAnchors(vh),
	        maxCrossSectionShift = vh * 1.5,
	        maxInSectionShift = vh - ASSUMED_LINE_HEIGHT,
	        minPhotoShift = vh / 3,
	        minTextShift = ASSUMED_LINE_HEIGHT * 2,
	        prevAnchor,
	        anchor,
	        shift;

	    function getMinShift(anchor, prevAnchor) {
	      return prevAnchor && prevAnchor.el.type === 'text' ? minTextShift : minPhotoShift;
	    }

	    function getMaxShift(anchor, prevAnchor) {
	      return prevAnchor && prevAnchor.el.id === anchor.el.id ? maxInSectionShift : maxCrossSectionShift;
	    }

	    anchor = _.chain(anchors).each(function (anchor) {
	      anchor.shift += lastTargetY - scrollY;
	    }).sortBy(function (anchor) {
	      return isForward ? anchor.shift : -anchor.shift;
	    }).find(function (anchor) {
	      var isNext = isForward ? anchor.shift > getMinShift(anchor, prevAnchor) : anchor.shift < -getMinShift(anchor, prevAnchor);

	      if (!isNext) {
	        prevAnchor = anchor;
	      }

	      return isNext;
	    }).value();

	    if (!anchor) {
	      return;
	    }

	    shift = isForward ? Math.min(anchor.shift, getMaxShift(anchor, prevAnchor)) : Math.max(anchor.shift, -getMaxShift(anchor, prevAnchor));

	    if (Math.abs(shift) > getMinShift(anchor, prevAnchor)) {
	      return Math.round(lastTargetY + shift);
	    }
	  },

	  _findScrollAnchors: function _findScrollAnchors(viewportHeight) {
	    var el = this.getDOMNode(),
	        scrollAnchorEls = _.toArray(el.querySelectorAll('[data-scroll-anchor]'));

	    return _.chain(scrollAnchorEls).map(_.partial(getScrollAnchors, viewportHeight)).flatten().value();
	  }
	};

	module.exports = AnchorScrollMixin;

/***/ },

/***/ 257:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);
	var getScrollY = __webpack_require__(82);
	var SectionTypes = __webpack_require__(40);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	var isIE10 = _require.isIE10;
	var firstIfShallowEqual = __webpack_require__(218);

	var OFFSCREEN_FADING = {
	  isActive: false,
	  isVisible: false,
	  topOpacity: 0,
	  bottomOpacity: 0
	};

	function isPageVisible() {
	  var hidden = document.hidden;
	  if (!_.isBoolean(hidden)) {
	    hidden = false;
	  }

	  return !hidden;
	}

	function interpolate(val, points) {
	  if (points[0] === points[1]) {
	    return points[0];
	  }

	  var result = (val - points[0]) / (points[1] - points[0]),
	      precision = 1 / (window.safari ? 0.1 : 0.02);

	  result = Math.min(1, Math.max(0, result));
	  result = Math.round(result * precision) / precision;
	  return result;
	}

	/**
	 * Keeps track of fading for posters as user scrolls the window.
	 * Expects `getSectionNode(i)` to be defined.
	 */
	var FadingCalculatorMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      posterFadings: null
	    };
	  },

	  isFadingEnabled: function isFadingEnabled() {
	    // On IE10, we don't have pointer-events
	    // and fades make some buttons unclickable.
	    return !isIE10() && !isMobile();
	  },

	  /**
	   * Returns an object with following properties:
	   *
	   * - isActive: whether a poster is active at the moment
	   * - top: top fading opacity, 0 to 1
	   * - bottom: bottom fading opacity, 0 to 1
	   *
	   * @param {number} index Index of the poster.
	   */
	  getSectionFading: function getSectionFading(index) {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    var sections = this.state.sections || [],
	        fadings = this.state.posterFadings || [],
	        type = sections[index].type;

	    if (type === SectionTypes.POSTER || type === SectionTypes.COVER) {
	      return fadings[index] || OFFSCREEN_FADING;
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    this._sectionHeights = [];
	    this._updateSectionHeights();

	    window.addEventListener('scroll', this._updatePosterFadings);
	    window.addEventListener('visibilitychange', this._updateSectionHeights);
	    window.addEventListener('resize', this._updateSectionHeights);
	    this._updateHeightsInterval = setInterval(this._updateSectionHeights, 700);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    clearInterval(this._updateHeightsInterval);
	    window.removeEventListener('visibilitychange', this._updateSectionHeights);
	    window.removeEventListener('resize', this._updateSectionHeights);
	    window.removeEventListener('scroll', this._updatePosterFadings);
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    if (this.state.sections !== prevState.sections) {
	      this._updateSectionHeights();
	    }
	  },

	  _updateSectionHeights: function _updateSectionHeights() {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (!isPageVisible()) {
	      return;
	    }

	    var count = this.state.sections.length,
	        node,
	        offsetHeight,
	        didChange;

	    if (this._sectionHeights.length !== count) {
	      this._sectionHeights.length = count;
	      didChange = true;
	    }

	    for (var i = 0; i < count; i++) {
	      node = this.getSectionNode(i);
	      offsetHeight = node.offsetHeight;

	      if (offsetHeight !== this._sectionHeights[i]) {
	        this._sectionHeights[i] = offsetHeight;
	        didChange = true;
	      }
	    }

	    if (didChange) {
	      this._updatePosterFadings();
	    }
	  },

	  _updatePosterFadings: function _updatePosterFadings() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var scrollY = getScrollY(),
	        sectionHeights = this._sectionHeights,
	        boundingRects = this._getBoundingRects(sectionHeights, scrollY),
	        state = this._getFadingState(boundingRects);

	    this.setState(state);
	  },

	  /**
	   * Calculates active poster index and fading.
	   *
	   * @param {array<object>} boundingRects Bounding rects for each section.
	   */
	  _getFadingState: function _getFadingState(boundingRects) {
	    var prevPosterFadings = this.state.posterFadings,
	        viewportHeight = window.innerHeight,
	        sectionCount = this.state.sections.length,
	        visiblePosters = this._findVisiblePosters(boundingRects, viewportHeight),
	        activePoster = this._findActivePoster(visiblePosters, viewportHeight),
	        posterFadings = null;

	    if (visiblePosters.length) {
	      posterFadings = new Array(sectionCount);
	    }

	    for (var visibleIndex = 0; visibleIndex < visiblePosters.length; visibleIndex++) {
	      var poster = visiblePosters[visibleIndex],
	          posterIndex = poster.index,
	          rect = poster.rect,
	          fading;

	      if (!rect.height) {
	        continue;
	      }

	      fading = this._getVisiblePosterFading(posterIndex, rect, poster === activePoster, boundingRects, viewportHeight);

	      // Avoid updating object if all its values match the previous fading
	      // so that the component can benefit from reference equality check on fading.

	      if (prevPosterFadings) {
	        fading = firstIfShallowEqual(prevPosterFadings[posterIndex], fading);
	      }

	      posterFadings[posterIndex] = fading;
	    }

	    // If *all* values in array are the same, avoid changes.
	    posterFadings = firstIfShallowEqual(prevPosterFadings, posterFadings);

	    return {
	      posterFadings: posterFadings
	    };
	  },

	  _getVisiblePosterFading: function _getVisiblePosterFading(index, rect, isActive, boundingRects, viewportHeight) {
	    if (!rect.height) {
	      return;
	    }

	    var fading = {
	      isVisible: true,
	      isActive: isActive,
	      progress: this._getPosterProgress(rect, viewportHeight),
	      topOpacity: 0,
	      bottomOpacity: 0
	    };

	    if (isActive) {
	      var isTall = rect.height > viewportHeight,
	          isCover = this.state.sections[index].type === SectionTypes.COVER,
	          isBeforeInfo = this.state.sections[index + 1].type === SectionTypes.INFO,
	          posterDistances = this._getDistanceToPosters(index, boundingRects),
	          opacities;

	      opacities = isTall || isCover ? this._getTallPosterOpacities(rect, viewportHeight, posterDistances) : this._getShortPosterOpacities(rect, viewportHeight, posterDistances);

	      if (isBeforeInfo) {
	        opacities.bottom = 0;
	      }

	      fading.topOpacity = opacities.top;
	      fading.bottomOpacity = opacities.bottom;
	    }

	    return fading;
	  },

	  _getDistanceToPosters: function _getDistanceToPosters(index, boundingRects) {
	    var distanceToPrev = 0,
	        distanceToNext = 0,
	        sections = this.state.sections,
	        i;

	    for (i = index - 1; i >= 0; i--) {
	      if (sections[i].type === SectionTypes.POSTER) {
	        break;
	      }

	      distanceToPrev += boundingRects[i].height;
	    }

	    for (i = index + 1; i < boundingRects.length; i++) {
	      if (sections[i].type === SectionTypes.POSTER) {
	        break;
	      }

	      distanceToNext += boundingRects[i].height;
	    }

	    return {
	      next: distanceToNext,
	      prev: distanceToPrev
	    };
	  },

	  _getShortPosterOpacities: function _getShortPosterOpacities(rect, viewportHeight, posterDistances) {
	    var top = rect.top,
	        height = rect.height,
	        viewportMiddle = viewportHeight / 2,
	        isTooCloseToPrevPoster = posterDistances.prev > 0 && posterDistances.prev < viewportHeight,
	        isTooCloseToNextPoster = posterDistances.next > 0 && posterDistances.next < viewportHeight;

	    return {
	      top: interpolate(top, {
	        0: isTooCloseToPrevPoster ? viewportMiddle + posterDistances.prev / 4 : viewportHeight,

	        1: viewportHeight - height
	      }),
	      bottom: interpolate(top, {
	        1: 0,
	        0: isTooCloseToNextPoster ? viewportMiddle - (rect.height + posterDistances.next / 4) : -viewportMiddle
	      })
	    };
	  },

	  _getTallPosterOpacities: function _getTallPosterOpacities(rect, viewportHeight, posterDistances) {
	    var top = rect.top,
	        bottom = rect.bottom,
	        fadeInEarlier = posterDistances.prev > 0 && posterDistances.prev < viewportHeight,
	        fadeInTop,
	        fadeInDistance;

	    if (posterDistances.prev > 0) {
	      fadeInTop = viewportHeight / 2;
	      if (!fadeInEarlier) {
	        fadeInTop += viewportHeight / 4;
	      }

	      fadeInDistance = viewportHeight / 2;
	    } else {
	      fadeInTop = viewportHeight;
	      fadeInDistance = viewportHeight;
	    }
	    return {
	      top: interpolate(top, {
	        0: fadeInTop,
	        1: fadeInTop - fadeInDistance
	      }),
	      bottom: interpolate(bottom, {
	        1: viewportHeight,
	        0: viewportHeight / 2
	      })
	    };
	  },

	  _getPosterProgress: function _getPosterProgress(rect, viewportHeight) {
	    var viewportMiddle = viewportHeight / 2;

	    return interpolate(rect.top, {
	      0: viewportMiddle,
	      1: viewportMiddle - rect.height
	    });
	  },

	  /**
	   * Finds the single active poster, if any.
	   * Assumes an array of { index, section, rect }.
	   *
	   * To find the active poster, it takes all visible posters and finds
	   * the one that either intersects viewport middle, or has
	   * the minimal distance from its edge to the viewport middle.
	   *
	   * @param {array<object>} visiblePosters All posters at least partially visible now.
	   * @param {number} viewportHeight Viewport height.
	   */
	  _findActivePoster: function _findActivePoster(visiblePosters, viewportHeight) {
	    if (!visiblePosters.length) {
	      return;
	    }

	    var viewportMiddle = viewportHeight / 2;
	    return _.min(visiblePosters, function (poster) {
	      var rect = poster.rect;
	      if (rect.top <= viewportMiddle && rect.bottom >= viewportMiddle) {
	        return 0;
	      }

	      return Math.min(Math.abs(rect.top - viewportMiddle), Math.abs(rect.bottom - viewportMiddle));
	    });
	  },

	  /**
	   * Finds posters that at least partially intersect the viewport.
	   * For matching posters, returns { index, section, rect }.
	   *
	   * @param {array<object>} boundingRects Bounding rects for each section.
	   * @param {number} viewportHeight Viewport height.
	   */
	  _findVisiblePosters: function _findVisiblePosters(boundingRects, viewportHeight) {
	    var sections = this.state.sections,
	        visiblePosters = [],
	        section,
	        rect,
	        isPoster,
	        isCoverBeforePoster,
	        i;

	    for (i = 0; i < sections.length; i++) {
	      if (!boundingRects[i]) {
	        continue;
	      }

	      section = sections[i];
	      rect = boundingRects[i];

	      if (rect.bottom <= 0 || rect.top >= viewportHeight || rect.height === 0) {
	        continue;
	      }

	      isPoster = section.type === SectionTypes.POSTER;
	      isCoverBeforePoster = i === 0 && sections.length > 1 && sections[1].type === SectionTypes.POSTER;

	      if (isPoster || isCoverBeforePoster) {
	        visiblePosters.push({
	          index: i,
	          section: section,
	          rect: rect
	        });
	      }
	    }

	    return visiblePosters;
	  },

	  /**
	   * Makes a guess at section bounding rects based on their heights and scroll position.
	   *
	   * This method doesn't actually call `getBoundingClientRect` for performance
	   * reasons so it will break if there are margins between sections.
	   *
	   * @param {array<number>} sectionHeights Heights for each section.
	   * @param {number} scrollY Current scroll position.
	   */
	  _getBoundingRects: function _getBoundingRects(sectionHeights, scrollY) {
	    var accumulatedScrollY = 0,
	        boundingRects = new Array(sectionHeights.length),
	        height;

	    for (var i = 0; i < sectionHeights.length; i++) {
	      height = sectionHeights[i] || 0;

	      boundingRects[i] = {
	        top: accumulatedScrollY - scrollY,
	        bottom: accumulatedScrollY - scrollY + height,
	        height: height
	      };

	      accumulatedScrollY += height;
	    }

	    return boundingRects;
	  }
	};

	module.exports = FadingCalculatorMixin;

/***/ },

/***/ 258:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var update = __webpack_require__(49);
	var _ = __webpack_require__(4);
	var vendorPrefix = __webpack_require__(301);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	var isIE10 = _require.isIE10;
	var LightboxActionCreators = __webpack_require__(249);
	var KeyCodes = __webpack_require__(145);

	// Keep this synced with zindexes.less
	var LIGHTBOX_IMAGE_Z = 250;

	/**
	 * Manages lightbox state for a list of images.
	 *
	 * Provides methods to find out if image is currently in the lightbox,
	 * and what styles it needs in order to become visible in the viewport.
	 *
	 * Call `handleLightboxTransitionEnd` whenever lightbox transition ends.
	 *
	 * An easy way to do that would be to use `Image`s in place of `img`s
	 * and set `onTransitionEnd={this.handleLightboxTransitionEnd}` on them.
	 */
	var LightboxMixin = {
	  getInitialState: function getInitialState() {
	    return this.getInitialLightboxState();
	  },

	  getInitialLightboxState: function getInitialLightboxState() {
	    return {
	      lightbox: {
	        current: null,
	        previous: null
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var previousLightbox = prevState.lightbox.current,
	        hasChanged = !_.isEqual(previousLightbox, this.state.lightbox.current);

	    if (!hasChanged) {
	      return;
	    }

	    if (this.isInLightbox()) {
	      window.addEventListener('scroll', this.hideLightbox, false);
	      window.addEventListener('resize', this.hideLightbox, false);
	      window.addEventListener('keydown', this._handleEscapeKeyDown, false);
	    } else {
	      window.removeEventListener('scroll', this.hideLightbox, false);
	      window.removeEventListener('resize', this.hideLightbox, false);
	      window.removeEventListener('keydown', this._handleEscapeKeyDown, false);
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('scroll', this.hideLightbox, false);
	    window.removeEventListener('resize', this.hideLightbox, false);
	    window.removeEventListener('keydown', this._handleEscapeKeyDown, false);

	    if (this.isLightboxVisible()) {
	      LightboxActionCreators.hideLightbox();
	    }
	  },

	  /**
	   * Restores the lightbox to its original state.
	   */
	  resetLightbox: function resetLightbox() {
	    this.setState(this.getInitialLightboxState());

	    if (this.isLightboxVisible()) {
	      LightboxActionCreators.hideLightbox();
	    }
	  },

	  /**
	   * Call this method to let lightbox know the transition is over.
	   *
	   * An easy way to do that would be to use `Image`s in place of `img`s
	   * and set `onTransitionEnd={this.handleLightboxTransitionEnd}` on them.
	   */
	  handleLightboxTransitionEnd: function handleLightboxTransitionEnd() {
	    this._setLightboxState('previous', null);
	  },

	  /**
	   * Closes lightbox on Escape button.
	   */
	  _handleEscapeKeyDown: function _handleEscapeKeyDown(e) {
	    if (e.keyCode === KeyCodes.ESCAPE) {
	      this.hideLightbox();
	    }
	  },

	  /**
	   * Returns 'active' if lightbox is active, 'leaving' if it is being animated away, or false.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {String?}
	   */
	  getLightboxState: function getLightboxState(sectionIndex) {
	    if (this.isInLightbox(sectionIndex)) {
	      return 'active';
	    }

	    if (this.isLeavingLightbox(sectionIndex)) {
	      return 'leaving';
	    }
	  },

	  /**
	   * Returns true if lightbox is visible, false otherwise.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {Boolean}
	   */
	  isLightboxVisible: function isLightboxVisible(sectionIndex) {
	    return !!this.getLightboxState(sectionIndex);
	  },

	  /**
	   * Returns whether lightbox is currently active.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {Boolean}
	   */
	  isInLightbox: function isInLightbox(sectionIndex) {
	    var current = this.state.lightbox.current;
	    if (!current) {
	      return false;
	    }

	    return _.isUndefined(sectionIndex) || current.sectionIndex === sectionIndex;
	  },

	  /**
	   * Returns whether lightbox is currently being animated away.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {Boolean}
	   */
	  isLeavingLightbox: function isLeavingLightbox(sectionIndex) {
	    var previous = this.state.lightbox.previous;
	    if (!previous) {
	      return false;
	    }

	    return _.isUndefined(sectionIndex) || previous.sectionIndex === sectionIndex;
	  },

	  /**
	   * Returns whether a given image is displayed in lightbox.
	   *
	   * @param {ImageMedia} image
	   */
	  isImageInLightbox: function isImageInLightbox(image) {
	    return this.isInLightbox() && this.state.lightbox.current.image.uuid === image.uuid;
	  },

	  /**
	   * Returns whether image with given index is being animated away from the lightbox.
	   *
	   * @param {ImageMedia} image
	   */
	  isImageLeavingLightbox: function isImageLeavingLightbox(image) {
	    return this.isLeavingLightbox() && this.state.lightbox.previous.image.uuid === image.uuid;
	  },

	  /**
	   * If lightbox is active, closes it.
	   * Otherwise, shows lightbox for a given image.
	   *
	   * Provide `fromRect` so `getLightboxImageStyle` knows
	   * how to calculate the transform that animates image into view.
	   *
	   * @param {number} sectionIndex Section index.
	   * @param {SectionType} sectionType Section type.
	   * @param {ImageMedia} image Image, later to be provided in `getLightboxImageStyle`.
	   * @param {object} fromRect Current image position on the page.
	   * @param {number?} toHeight Target container height. Window height if unspecified.
	   */
	  toggleLightbox: function toggleLightbox(sectionIndex, sectionType, image, fromRect, toHeight) {
	    if (this.isInLightbox()) {
	      this.hideLightbox();
	    } else {
	      this.showLightbox(sectionIndex, sectionType, image, fromRect, toHeight);
	    }
	  },

	  isLightboxEnabled: function isLightboxEnabled() {
	    return !isMobile() && !isIE10() && window.matchMedia('(min-width: 992px)').matches;
	  },

	  /**
	   * Shows lightbox for a given image.
	   *
	   * Provide `fromRect` so `getLightboxImageStyle` knows
	   * how to calculate the transform that animates image into view.
	   *
	   * @param {number} sectionIndex Section index.
	   * @param {SectionType} sectionType Section type.
	   * @param {ImageMedia} image Image later to be queried via `getLightboxImageStyle`.
	   * @param {object} fromRect Current image position on the page.
	   * @param {number?} toHeight Target container height. Window height if unspecified.
	   */
	  showLightbox: function showLightbox(sectionIndex, sectionType, image, fromRect, toHeight) {
	    if (!this.isLightboxEnabled()) {
	      return;
	    }

	    this._setLightboxState('current', {
	      sectionIndex: sectionIndex,
	      sectionType: sectionType,
	      image: image,
	      fromRect: fromRect,
	      toHeight: toHeight || window.innerHeight
	    });

	    LightboxActionCreators.showLightbox(image, sectionType);
	  },

	  /**
	   * Hides lightbox.
	   */
	  hideLightbox: function hideLightbox() {
	    if (!this.isInLightbox()) {
	      return;
	    }

	    this._setLightboxState('current', null);

	    LightboxActionCreators.hideLightbox();
	  },

	  /**
	   * Gets CSS style that needs to be applied to
	   * any image in lightbox-enabled gallery, whether
	   * the image is active or not.
	   *
	   * @param {ImageMedia} image Image previously provided in `showLightbox`.
	   */
	  getLightboxImageStyle: function getLightboxImageStyle(image) {
	    var transform = this.getLightboxImageTransform(image),
	        style = {};

	    style[vendorPrefix.js + 'Transform'] = transform;

	    if (this.isImageInLightbox(image) || this.isImageLeavingLightbox(image)) {
	      style.position = 'relative';
	      style.zIndex = LIGHTBOX_IMAGE_Z;
	    }

	    return style;
	  },

	  /**
	   * Gets CSS transform that needs to be applied to
	   * any image in lightbox-enabled gallery, whether
	   * the image is active or not.
	   *
	   * Assumes that when lightbox is active, `state.lightbox.current.fromRect`
	   * matches image initial position just before lightbox was activated.
	   *
	   * @param {ImageMedia} image Image previously provided in `showLightbox`.
	   */
	  getLightboxImageTransform: function getLightboxImageTransform(image) {
	    if (!this.isImageInLightbox(image)) {
	      return 'translate(0, 0) scale(1)';
	    }

	    var origSize = image.size;var _state$lightbox$current = this.state.lightbox.current;
	    var fromRect = _state$lightbox$current.fromRect;

	    var toHeight = _state$lightbox$current.toHeight;
	    var toWidth = window.innerWidth;
	    var leftGap = 16;
	    var rightGap = 16;
	    var topGap = 16;
	    var bottomGap = 68;
	    var availableWidth = toWidth - (leftGap + rightGap);
	    var availableHeight = toHeight - (topGap + bottomGap);
	    var widthRatio = origSize.width / fromRect.width;
	    var scale;

	    if (origSize.width < availableWidth && origSize.height < availableHeight) {
	      scale = widthRatio;
	    } else if (origSize.width / origSize.height < availableWidth / availableHeight) {
	      scale = availableHeight / origSize.height * widthRatio;
	    } else {
	      scale = availableWidth / origSize.width * widthRatio;
	    }

	    var horizontalGapAdjustment = (rightGap - leftGap) / 2,
	        verticalGapAdjustment = (topGap - bottomGap) / 2,
	        left = (toWidth - fromRect.width) / 2 - fromRect.left + horizontalGapAdjustment,
	        top = (toHeight - fromRect.height) / 2 - fromRect.top + verticalGapAdjustment,
	        transform = 'translate(' + left + 'px, ' + top + 'px) scale(' + scale + ')';

	    return transform;
	  },

	  _setLightboxState: function _setLightboxState(key, value) {
	    var stateUpdate = {};

	    stateUpdate[key] = {
	      $set: value
	    };

	    if (key === 'current' && value === null) {
	      var current = this.state.lightbox.current;
	      stateUpdate['previous'] = {
	        $set: current
	      };
	    }

	    this._updateState({
	      lightbox: stateUpdate
	    });
	  },

	  _updateState: function _updateState(stateUpdate) {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.replaceState(update(this.state, stateUpdate));
	  }
	};

	module.exports = LightboxMixin;

/***/ },

/***/ 261:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var AnchorScrollMixin = __webpack_require__(255);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	/**
	 * Listens to `keydown` and `keyup` events and provides snapping
	 * on space press.
	 */
	var StampScrollMixin = {
	  mixins: [AnchorScrollMixin],

	  propTypes: {
	    isInViewer: React.PropTypes.bool.isRequired
	  },

	  componentDidMount: function componentDidMount() {
	    if (isMobile()) {
	      return;
	    }

	    window.addEventListener('keydown', this._handleKeyDown);
	    window.addEventListener('keyup', this._handleKeyUp);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (isMobile()) {
	      return;
	    }

	    window.removeEventListener('keydown', this._handleKeyDown);
	    window.removeEventListener('keyup', this._handleKeyUp);
	  },

	  _handleKeyDown: function _handleKeyDown(e) {
	    if (!this.isSpaceKeyEvent(e) || !this.isMounted()) {
	      return;
	    }

	    this.handleSpaceKeyDown(e);
	  },

	  _handleKeyUp: function _handleKeyUp(e) {
	    if (!this.isSpaceKeyEvent(e) || !this.isMounted()) {
	      return;
	    }

	    this.handleSpaceKeyUp(e);
	  }
	};

	module.exports = StampScrollMixin;

/***/ },

/***/ 264:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);var PropTypes = React.PropTypes;

	__webpack_require__(333);

	var ImageUsageCounter = React.createClass({
	  displayName: 'ImageUsageCounter',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    counter: PropTypes.number.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(Icon, { name: 'collect',
	        mode: 'stroke',
	        size: 'xsmall' }),
	      React.createElement(
	        'span',
	        { className: 'ImageUsageCounter-count' },
	        this.props.counter
	      )
	    );
	  }
	});

	module.exports = ImageUsageCounter;

/***/ },

/***/ 269:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var classSet = __webpack_require__(163);
	var PropTypes = React.PropTypes;
	var formatTime = __webpack_require__(136);
	var PureRenderMixin = __webpack_require__(2);

	__webpack_require__(334);

	var TrackList = React.createClass({
	  displayName: 'TrackList',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    tracks: PropTypes.array.isRequired,
	    activeTrackIndex: PropTypes.number.isRequired,
	    isPlaying: PropTypes.bool.isRequired,
	    onSelect: PropTypes.func.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.isPlaying && 'active'];
	  },

	  render: function render() {
	    return React.createElement(
	      'ul',
	      { className: 'TrackList' },
	      this.renderTracks()
	    );
	  },

	  renderTracks: function renderTracks() {
	    var _this = this;

	    var activeTrackIndex = this.props.activeTrackIndex;

	    return this.props.tracks.map(function (track, index) {
	      return React.createElement(
	        'li',
	        { className: classSet({
	            'TrackList-track': true,
	            'TrackList-track--active': index === activeTrackIndex
	          }),
	          onClick: _this.handleSelect.bind(_this, index),
	          key: index },
	        React.createElement(
	          'span',
	          { className: 'TrackList-trackTitle' },
	          track.title
	        ),
	        React.createElement(
	          'span',
	          { className: 'TrackList-trackDuration' },
	          formatTime(track.duration)
	        )
	      );
	    });
	  },

	  handleSelect: function handleSelect(index) {
	    this.props.onSelect(index);
	  }
	});

	module.exports = TrackList;

/***/ },

/***/ 274:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var PlayerStore = __webpack_require__(119);
	var PlayerActionCreators = __webpack_require__(84);
	var AudioCover = __webpack_require__(170);
	var TrackList = __webpack_require__(269);
	var PureRenderMixin = __webpack_require__(2);
	var DefaultAudioImage = __webpack_require__(144);
	var AudioContainer = __webpack_require__(173);
	var MediaTypes = __webpack_require__(70);var PropTypes = React.PropTypes;

	var AudioPlayList = React.createClass({
	  displayName: 'AudioPlayList',

	  mixins: [createStoreMixin(PlayerStore), PureRenderMixin],

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    url: PropTypes.string.isRequired,
	    tracks: PropTypes.array.isRequired,
	    title: PropTypes.string.isRequired,
	    background: PropTypes.object,
	    stamp: PropTypes.shape({
	      id: PropTypes.number
	    }).isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    var mediaId = this.props.uuid;

	    return {
	      isPlaying: PlayerStore.isPlaying(mediaId),
	      isPaused: PlayerStore.isPaused(mediaId),
	      activeTrackIndex: PlayerStore.getActiveTrackIndex(mediaId),
	      activeTrack: PlayerStore.getActiveTrack(mediaId),
	      currentTime: PlayerStore.getCurrentTime(mediaId),
	      artwork: PlayerStore.getArtwork(mediaId)
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    PlayerActionCreators.registerAudio(this.props.uuid, {
	      mediaType: MediaTypes.AUDIO_PLAYLIST,
	      tracks: this.props.tracks,
	      background: this.props.background,
	      stampId: this.props.stamp.id
	    });
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    PlayerActionCreators.unregisterAudio(this.props.uuid);
	  },

	  getBackground: function getBackground() {
	    return this.props.background || DefaultAudioImage;
	  },

	  getArtwork: function getArtwork() {
	    return this.state.artwork || DefaultAudioImage;
	  },

	  getTrackDuration: function getTrackDuration(track) {
	    return track && track.duration || 0;
	  },

	  renderCover: function renderCover() {
	    var _state = this.state;
	    var isPlaying = _state.isPlaying;
	    var activeTrack = _state.activeTrack;
	    var currentTime = _state.currentTime;
	    var isPaused = _state.isPaused;

	    return React.createElement(AudioCover, { uuid: this.props.uuid,
	      linkUrl: this.props.url,
	      colors: this.getBackground().colors,
	      artwork: this.getArtwork(),
	      duration: this.getTrackDuration(activeTrack),
	      currentTime: currentTime,
	      isPlaying: isPlaying,
	      isPaused: isPaused,
	      onBackward: this.handleBackward,
	      onForward: this.handleForward,
	      onPlay: this.togglePause,
	      onPause: this.togglePause,
	      alwaysShowControls: true });
	  },

	  renderTrackList: function renderTrackList() {
	    return React.createElement(TrackList, { tracks: this.props.tracks,
	      activeTrackIndex: this.state.activeTrackIndex,
	      isPlaying: this.state.isPlaying,
	      onSelect: this.toggleTrack });
	  },

	  render: function render() {
	    return React.createElement(AudioContainer, { title: this.props.title,
	      username: this.props.username,
	      duration: this.props.duration,
	      background: this.getBackground(),
	      url: this.props.url,
	      cover: this.renderCover(),
	      trackList: this.renderTrackList() });
	  },

	  togglePause: function togglePause() {
	    var mediaId = this.props.uuid;

	    if (this.state.isPlaying) {
	      PlayerActionCreators.pause(mediaId);
	    } else {
	      PlayerActionCreators.play(mediaId);
	    }
	  },

	  toggleTrack: function toggleTrack(index) {
	    if (this.state.activeTrackIndex === index) {
	      this.togglePause();
	    } else {
	      PlayerActionCreators.play(this.props.uuid, {
	        trackIndex: index,
	        currentTime: 0
	      });
	    }
	  },

	  handleBackward: function handleBackward() {
	    PlayerActionCreators.playPrevious(this.props.uuid);
	  },

	  handleForward: function handleForward() {
	    PlayerActionCreators.playNext(this.props.uuid);
	  }
	});

	module.exports = AudioPlayList;

/***/ },

/***/ 275:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var PlayerStore = __webpack_require__(119);
	var PlayerActionCreators = __webpack_require__(84);
	var AudioCover = __webpack_require__(170);
	var AudioContainer = __webpack_require__(173);
	var DefaultAudioImage = __webpack_require__(144);
	var PureRenderMixin = __webpack_require__(2);
	var MediaTypes = __webpack_require__(70);var PropTypes = React.PropTypes;

	var AudioTrack = React.createClass({
	  displayName: 'AudioTrack',

	  mixins: [createStoreMixin(PlayerStore), PureRenderMixin],

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    source: PropTypes.string,
	    background: PropTypes.object,
	    streamUrl: PropTypes.string,
	    url: PropTypes.string.isRequired,
	    stamp: PropTypes.shape({
	      id: PropTypes.number
	    }).isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    var mediaId = this.props.uuid;

	    return {
	      isPlaying: PlayerStore.isPlaying(mediaId),
	      isPaused: PlayerStore.isPaused(mediaId),
	      currentTime: PlayerStore.getCurrentTime(mediaId),
	      artwork: PlayerStore.getArtwork(mediaId)
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    PlayerActionCreators.registerAudio(this.props.uuid, {
	      mediaType: MediaTypes.AUDIO_PLAYLIST,
	      background: this.props.background,
	      tracks: [this.props],
	      trackIndex: 0,
	      stampId: this.props.stamp.id
	    });
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    PlayerActionCreators.unregisterAudio(this.props.uuid);
	  },

	  getArtwork: function getArtwork() {
	    return this.state.artwork || DefaultAudioImage;
	  },

	  getBackground: function getBackground() {
	    return this.props.background || DefaultAudioImage;
	  },

	  renderCover: function renderCover() {
	    var _state = this.state;
	    var isPlaying = _state.isPlaying;
	    var currentTime = _state.currentTime;
	    var isPaused = _state.isPaused;var _props = this.props;
	    var url = _props.url;
	    var duration = _props.duration;

	    return React.createElement(AudioCover, { uuid: this.props.uuid,
	      linkUrl: url,
	      artwork: this.getArtwork(),
	      colors: this.getBackground().colors,
	      duration: duration,
	      currentTime: currentTime,
	      isPlaying: isPlaying,
	      isPaused: isPaused,
	      onPlay: this.togglePause,
	      onPause: this.togglePause,
	      onBackward: this.handleBackward,
	      onForward: this.handleForward,
	      context: 'AudioTrack' });
	  },

	  render: function render() {
	    return React.createElement(AudioContainer, { title: this.props.title,
	      username: this.props.username,
	      duration: this.props.duration,
	      background: this.getBackground(),
	      url: this.props.url,
	      cover: this.renderCover() });
	  },

	  togglePause: function togglePause() {
	    var isPlaying = this.state.isPlaying,
	        mediaId = this.props.uuid;

	    if (isPlaying) {
	      PlayerActionCreators.pause(mediaId);
	    } else {
	      PlayerActionCreators.play(mediaId);
	    }
	  },

	  handleBackward: function handleBackward() {
	    PlayerActionCreators.playPrevious(this.props.uuid);
	  },

	  handleForward: function handleForward() {
	    PlayerActionCreators.playNext(this.props.uuid);
	  }
	});

	module.exports = AudioTrack;

/***/ },

/***/ 276:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ResponsiveImageQueueMixin = __webpack_require__(86),
	    PureRenderMixin = __webpack_require__(2),
	    Analytics = __webpack_require__(52),
	    AnalyticsEvents = __webpack_require__(55);

	__webpack_require__(38);
	__webpack_require__(336);

	var COVER = {
	  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/12/19/2014/be92ae37-d8d1-4d4b-afaf-0926d28a6e25.jpg',
	  size: {
	    width: 1024,
	    height: 1024
	  }
	};

	var BuyInItunes = React.createClass({
	  displayName: 'BuyInItunes',

	  mixins: [ResponsiveImageQueueMixin, PureRenderMixin],

	  getImageOptions: function getImageOptions() {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: COVER,
	      mode: 'scale_crop',
	      sizes: {
	        normal: true,
	        retina: devicePixelRatio > 1.5
	      }
	    };
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 400,
	      'xs': 560,
	      'sm': 192,
	      'md': 192,
	      'lg': 192,
	      'xl': 192
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'stamp-BuyInItunes',
	        'data-scroll-anchor': true },
	      React.createElement(
	        'div',
	        { className: 'stamp-BuyInItunes-box' },
	        React.createElement(
	          'div',
	          { className: 'stamp-BuyInItunes-label' },
	          'iTunes Store'
	        ),
	        this.renderLoaderImg(),
	        React.createElement(
	          'div',
	          { className: 'stamp-BuyInItunes-cover', style: { backgroundImage: this.getBackgroundImageUrl() } },
	          React.createElement('a', { className: 'stamp-BuyInItunes-coverLink',
	            href: 'https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4',
	            target: '_blank',
	            onClick: this.handleClick })
	        ),
	        React.createElement(
	          'div',
	          { className: 'stamp-BuyInItunes-meta' },
	          React.createElement(
	            'a',
	            { className: 'stamp-BuyInItunes-title Link Link--underlineHover',
	              href: 'https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4',
	              target: '_blank',
	              onClick: this.handleClick },
	            'Planetarium'
	          ),
	          React.createElement(
	            'div',
	            { className: 'stamp-BuyInItunes-artist' },
	            'Mujuice'
	          ),
	          React.createElement(
	            'a',
	            { className: 'Btn Btn--green Btn--medium Btn--fill stamp-BuyInItunes-button',
	              href: 'https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4',
	              target: '_blank',
	              onClick: this.handleClick },
	            'View in iTunes'
	          )
	        )
	      )
	    );
	  },

	  handleClick: function handleClick() {
	    Analytics.trackEvent(AnalyticsEvents.STAMP_ACTION_BUY_IN_ITUNES);
	  }
	});

	module.exports = BuyInItunes;
	/**
	 * Note: use <a> instead of <Link> and <Button>
	 * because our elements don't trigger onClick
	 * with target="_blank" and we don't want to special
	 * case them yet. If we later need this, we'll
	 * revisit this part.
	 */

/***/ },

/***/ 277:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var gradient = __webpack_require__(123);
	var StampImageMixin = __webpack_require__(130);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var Img = __webpack_require__(127);
	var Loader = __webpack_require__(43);
	var FontTest = __webpack_require__(92);
	var ZineLink = __webpack_require__(93);
	var SectionTypes = __webpack_require__(40);
	var getScrollY = __webpack_require__(82);
	var isBestOf2014Special = __webpack_require__(83);
	var waitForElasticScroll = __webpack_require__(222);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(337);

	function stopPropagation(e) {
	  e.stopPropagation();
	}

	var DEFAULT_BACKGROUND = {
	  colors: {
	    top: 'FFFFFF',
	    bottom: 'FFFFFF'
	  }
	};

	var Cover = React.createClass({
	  displayName: 'Cover',

	  mixins: [PureRenderMixin, StampImageMixin, ClassNameMixin],

	  className: 'stamp-Cover',

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    isInViewer: PropTypes.bool.isRequired,
	    isLoading: PropTypes.bool,
	    sectionIndex: PropTypes.number.isRequired,
	    isLightboxEnabled: PropTypes.func.isRequired,
	    primaryZine: PropTypes.object
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      allowEmpty: true
	    };
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 480,
	      'xs': 640,
	      'sm': 992,
	      'md': 1200,
	      'lg': 1440,
	      'xl': 1600
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      isAtTop: getScrollY() <= 0,
	      imageWrapperStyle: {}
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      clickable: this.shouldOpenLightboxOnClick()
	    };
	  },

	  getImage: function getImage(props) {
	    var stamp = props.stamp;
	    var background;

	    if (stamp.content) {
	      background = stamp.content.sections[0].background;
	    }

	    return background || stamp.thumbnail || DEFAULT_BACKGROUND;
	  },

	  shouldOpenLightboxOnClick: function shouldOpenLightboxOnClick() {
	    var isLightboxEnabled = this.props.isLightboxEnabled();
	    var image = this.getImage(this.props);var isAtTop = this.state.isAtTop;

	    return isLightboxEnabled && isAtTop && image !== DEFAULT_BACKGROUND;
	  },

	  preventClicksIfLightboxEnabled: function preventClicksIfLightboxEnabled() {
	    if (!this.shouldOpenLightboxOnClick()) {
	      return;
	    }

	    return {
	      onClick: stopPropagation,
	      style: {
	        cursor: 'default'
	      }
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this.deferUpdateWrapperStyle = window.setTimeout.bind(window, this.updateWrapperStyle, 0);

	    window.addEventListener('scroll', this.handleWindowScroll, false);
	    window.addEventListener('resize', this.updateWrapperStyle, false);
	    window.addEventListener('orientationchange', this.deferUpdateWrapperStyle, false);

	    this.updateWrapperStyle();
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleWindowScroll, false);
	    window.removeEventListener('resize', this.updateWrapperStyle, false);
	    window.removeEventListener('orientationchange', this.deferUpdateWrapperStyle, false);
	  },

	  updateWrapperStyle: function updateWrapperStyle() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var coverEl = this.getDOMNode(),
	        coverWidth = window.innerWidth,
	        coverHeight = coverEl.offsetHeight,
	        image = this.getImage(this.props),
	        originalSize = image.size || {},
	        imageHeight = Math.round(coverWidth * (originalSize.height / originalSize.width)) + 1,
	        widthScale = Math.max(1, coverHeight / imageHeight);

	    this.setState({
	      imageWrapperStyle: {
	        width: widthScale * 100 + '%',
	        left: (1 - widthScale) / 2 * 100 + '%'
	      }
	    });
	  },

	  handleWindowScroll: function handleWindowScroll() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var scrollY = getScrollY(),
	        isAtTop = scrollY <= 0;

	    this.setState({
	      isAtTop: isAtTop
	    });
	  },

	  render: function render() {
	    var _props = this.props;
	    var stamp = _props.stamp;
	    var primaryZine = _props.primaryZine;
	    var isLoading = _props.isLoading;
	    var subtitle = stamp.description;
	    var background = this.getImage(this.props);
	    var colors = background.colors;
	    var isDesktop = !isMobile();
	    var hasLoadedImage = this.hasLoadedImage();
	    var imageStyle = this.props.getLightboxImageStyle(background);
	    var style;

	    if (isDesktop || !hasLoadedImage) {
	      style = {
	        backgroundImage: gradient('#' + colors.top, '#' + colors.bottom)
	      };
	    }

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: style,
	        'data-lightbox': this.props.lightboxState,
	        'data-scroll-anchor': true,
	        onClick: this.handleClick },
	      React.createElement(
	        'div',
	        { className: 'stamp-Cover-imgWrapper',
	          style: this.state.imageWrapperStyle },
	        React.createElement(Img, { src: this.getImageSrcUrl(),
	          ref: 'image',
	          className: 'stamp-Cover-img',
	          style: imageStyle,
	          onTransitionEnd: this.handleImageTransitionEnd,
	          onLoad: this.handleImageLoad,
	          onError: this.handleImageError })
	      ),
	      isLoading && React.createElement(Loader, null),
	      !isLoading && React.createElement(
	        'div',
	        { className: 'stamp-Cover-box' },
	        isBestOf2014Special(primaryZine) && React.createElement(
	          ZineLink,
	          { zine: primaryZine,
	            className: 'stamp-Cover-bestOf2014',
	            underline: 'never',
	            showTitle: true },
	          'Best of 2014'
	        ),
	        React.createElement(
	          'h1',
	          _extends({ className: 'stamp-Cover-title'
	          }, this.preventClicksIfLightboxEnabled()),
	          stamp.title
	        ),
	        subtitle && React.createElement(
	          FontTest,
	          { family: 'minion-pro-condensed',
	            test: subtitle },
	          React.createElement('h3', _extends({ className: 'stamp-Cover-subtitle',
	            dangerouslySetInnerHTML: { __html: subtitle }
	          }, this.preventClicksIfLightboxEnabled()))
	        )
	      ),
	      this.renderUsageCounter(),
	      this.renderAttributionOnMobile()
	    );
	  },

	  handleClick: function handleClick(e) {
	    this.toggleAttributionOnMobile(e);

	    if (this.shouldOpenLightboxOnClick()) {
	      this.toggleLightbox();
	    }
	  },

	  handleImageTransitionEnd: function handleImageTransitionEnd() {
	    if (this.props.onImageTransitionEnd) {
	      this.props.onImageTransitionEnd();
	    }
	  },

	  toggleLightbox: function toggleLightbox() {
	    var _this = this;

	    waitForElasticScroll().then(function () {
	      if (!_this.isMounted()) {
	        return;
	      }

	      var boundingRect = _this.refs.image.getDOMNode().getBoundingClientRect(),
	          toHeight = _this.getDOMNode().offsetHeight,
	          background = _this.getImage(_this.props);

	      _this.props.toggleLightbox(_this.props.sectionIndex, SectionTypes.COVER, background, boundingRect, toHeight);
	    });
	  }
	});

	module.exports = Cover;

/***/ },

/***/ 278:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    TransitionEventsMixin = __webpack_require__(167),
	    PureRenderMixin = __webpack_require__(2),
	    ClassNameMixin = __webpack_require__(3);

	__webpack_require__(38);
	__webpack_require__(338);

	var Fade = React.createClass({
	  displayName: 'Fade',

	  mixins: [ClassNameMixin, TransitionEventsMixin, PureRenderMixin],

	  propTypes: {
	    color: React.PropTypes.string.isRequired,
	    opacity: React.PropTypes.number.isRequired,
	    isActive: React.PropTypes.bool.isRequired,
	    isVisible: React.PropTypes.bool.isRequired,
	    isLightboxVisible: React.PropTypes.bool.isRequired,
	    isTop: React.PropTypes.bool
	  },

	  className: 'stamp-Fade',

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.isTop && 'top'];
	  },

	  getInitialState: function getInitialState() {
	    return {
	      animateOpacity: false
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var lightboxChanged = newProps.isLightboxVisible !== this.props.isLightboxVisible,
	        activeChanged = newProps.isActive !== this.props.isActive,
	        visibleChanged = newProps.isVisible !== this.props.isVisible,
	        dOpacity = Math.abs(newProps.opacity - this.props.opacity);

	    if (lightboxChanged || activeChanged && !visibleChanged && dOpacity > 0) {
	      this.setState({
	        animateOpacity: true
	      });
	    }
	  },

	  handleTransitionEnd: function handleTransitionEnd() {
	    this.setState({
	      animateOpacity: false
	    });
	  },

	  render: function render() {
	    var opacity = this.getOpacity(),
	        style;

	    style = {
	      pointerEvents: opacity < 1 ? 'none' : '',
	      opacity: opacity,
	      backgroundColor: '#' + this.props.color
	    };

	    return React.createElement('div', { className: this.getClassName(),
	      'data-animate': this.state.animateOpacity,
	      style: style });
	  },

	  getOpacity: function getOpacity() {
	    if (this.props.isLightboxVisible) {
	      return 1;
	    }

	    // Chrome gets stuck at 0 opacity sometimes
	    return this.props.opacity || 0.00001;
	  }
	});

	module.exports = Fade;

/***/ },

/***/ 279:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    GalleryImage = __webpack_require__(174),
	    PureRenderMixin = __webpack_require__(2),
	    SectionTypes = __webpack_require__(40);

	__webpack_require__(38);
	__webpack_require__(340);

	var IMAGE_SIZES = {
	  'default': 480,
	  'xs': 512,
	  'sm': 512,
	  'md': 512,
	  'lg': 512,
	  'xl': 640
	};

	var ITEMS_IN_ROW = 2;

	var GridGallery = React.createClass({
	  displayName: 'GridGallery',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    images: React.PropTypes.array.isRequired,
	    sectionIndex: React.PropTypes.number.isRequired,
	    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
	    toggleLightbox: React.PropTypes.func.isRequired,
	    getLightboxImageStyle: React.PropTypes.func.isRequired,
	    isImageInLightbox: React.PropTypes.func.isRequired,
	    onImageTransitionEnd: React.PropTypes.func.isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return IMAGE_SIZES;
	  },

	  getRows: function getRows() {
	    var images = this.props.images;
	    var rows = [];

	    for (var i = 0; i < images.length; i += ITEMS_IN_ROW) {
	      rows.push(images.slice(i, i + ITEMS_IN_ROW).filter(Boolean));
	    }

	    return rows;
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'stamp-GridGallery',
	        'data-lightbox': this.props.lightboxState },
	      React.createElement(
	        'div',
	        { className: 'stamp-GridGallery-box' },
	        this.getRows().map(this.renderRow)
	      )
	    );
	  },

	  renderRow: function renderRow(row, index) {
	    return React.createElement(
	      'div',
	      { className: 'stamp-GridGallery-row', key: index },
	      row.map(this.renderImage)
	    );
	  },

	  renderImage: function renderImage(image, indexInRow, row) {
	    var imageStyle = this.props.getLightboxImageStyle(image),
	        caption = image.caption,
	        galleryStyle = {},
	        siblingImage = indexInRow === 0 ? row[1] : row[0];

	    galleryStyle.flex = 1;
	    galleryStyle.MozFlex = 1;
	    galleryStyle.WebkitFlex = 1;
	    galleryStyle.msFlex = 1;

	    if (siblingImage) {
	      galleryStyle.flex = siblingImage.size.height / siblingImage.size.width;
	      galleryStyle.MozFlex = siblingImage.size.height / siblingImage.size.width;
	      galleryStyle.WebkitFlex = siblingImage.size.height / siblingImage.size.width;
	      galleryStyle.msFlex = siblingImage.size.height / siblingImage.size.width;
	    }

	    return React.createElement(GalleryImage, { key: indexInRow,
	      className: 'stamp-GridGallery-item',
	      style: galleryStyle,
	      stamp: this.props.stamp,
	      image: image,
	      imageSizes: IMAGE_SIZES,
	      imageStyle: imageStyle,
	      caption: caption,
	      onClick: this.handleImageClick,
	      onTransitionEnd: this.props.onImageTransitionEnd,
	      isImageInLightbox: this.props.isImageInLightbox,
	      lightboxState: this.props.lightboxState });
	  },

	  handleImageClick: function handleImageClick(image, e) {
	    var boundingRect = e.target.getBoundingClientRect();
	    this.props.toggleLightbox(this.props.sectionIndex, SectionTypes.GALLERY, image, boundingRect);
	  }
	});

	module.exports = GridGallery;

/***/ },

/***/ 280:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ZineItem = __webpack_require__(273);
	var UserItem = __webpack_require__(272);
	var Container = __webpack_require__(81);
	var Link = __webpack_require__(21);
	var pluralize = __webpack_require__(98);
	var SidebarTypes = __webpack_require__(39);
	var SidebarActionCreators = __webpack_require__(29);
	var formatDate = __webpack_require__(135);
	var createAnalyticsContextMixin = __webpack_require__(169);
	var OffsetMonitor = __webpack_require__(128);
	var AnalyticsSources = __webpack_require__(34);
	var Button = __webpack_require__(13);
	var ScreenSizeMixin = __webpack_require__(71);
	var ShareTypes = __webpack_require__(113);
	var LikeButton = __webpack_require__(265);
	var ShareAddStamp = __webpack_require__(271);var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(342);

	var InfoPanel = React.createClass({
	  displayName: 'InfoPanel',

	  mixins: [PureRenderMixin, createAnalyticsContextMixin(AnalyticsSources.INFO_PANEL), ScreenSizeMixin],

	  propTypes: {
	    onOffsetTopChange: PropTypes.func,
	    stamp: PropTypes.object.isRequired,
	    user: PropTypes.object.isRequired,
	    primaryZine: PropTypes.object,
	    otherZines: PropTypes.array.isRequired,
	    isInViewer: PropTypes.bool.isRequired,
	    showFeedback: PropTypes.bool,
	    disableInfoPanel: PropTypes.bool
	  },

	  render: function render() {
	    var _props = this.props;
	    var stamp = _props.stamp;
	    var user = _props.user;
	    var primaryZine = _props.primaryZine;
	    var otherZines = _props.otherZines;
	    var isInViewer = _props.isInViewer;
	    var showFeedback = _props.showFeedback;
	    var disableInfoPanel = _props.disableInfoPanel;
	    var isMobile = this.state.isMobile;

	    var published = stamp.published ? new Date(stamp.published) : new Date();
	    var primaryServices = isMobile ? [] : [ShareTypes.FACEBOOK, ShareTypes.TWITTER];

	    return React.createElement(
	      OffsetMonitor,
	      { onOffsetTopChange: this.props.onOffsetTopChange },
	      React.createElement(
	        'div',
	        { className: 'InfoPanel',
	          'data-section': 'info',
	          'data-disabled': disableInfoPanel,
	          'data-scroll-anchor': true },
	        React.createElement(
	          Container,
	          { context: 'InfoPanel' },
	          React.createElement(
	            'div',
	            { className: 'InfoPanel-box' },
	            showFeedback && React.createElement(
	              'div',
	              { className: 'InfoPanel-section InfoPanel-section--feedback' },
	              React.createElement(
	                Button,
	                { color: 'green',
	                  onClick: this.handleFeedbackClick,
	                  active: true },
	                'Leave Feedback'
	              )
	            ),
	            !showFeedback && React.createElement(
	              'div',
	              { className: 'InfoPanel-section InfoPanel-section--buttons' },
	              React.createElement(
	                'div',
	                { className: 'InfoPanel-buttons' },
	                React.createElement(LikeButton, { size: 'xlarge',
	                  iconSize: 'medium',
	                  showCounter: true,
	                  showLikers: isInViewer,
	                  stamp: stamp,
	                  color: 'gray',
	                  fill: true,
	                  like: true }),
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-share' },
	                  React.createElement(ShareAddStamp, { size: 'medium',
	                    color: 'gray',
	                    stamp: stamp,
	                    primaryServices: primaryServices,
	                    showAddLabel: true,
	                    round: true })
	                )
	              )
	            )
	          )
	        ),
	        React.createElement(
	          Container,
	          { context: 'InfoPanel' },
	          React.createElement(
	            'div',
	            { className: 'InfoPanel-box' },
	            React.createElement(
	              'div',
	              { className: 'InfoPanel-section InfoPanel-section--userAndZine' },
	              React.createElement(
	                'div',
	                { className: 'InfoPanel-user' },
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-label utils--smallCaps' },
	                  'Posted By'
	                ),
	                React.createElement(UserItem, { user: user,
	                  vertical: true,
	                  context: 'InfoPanel',
	                  size: 'small',
	                  imageSize: 'large',
	                  card: true,
	                  showAbout: true,
	                  showLocation: true,
	                  showWebsite: true,
	                  showFollow: true }),
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-date' },
	                  'Posted on ',
	                  formatDate(published)
	                )
	              ),
	              primaryZine && React.createElement(
	                'div',
	                { className: 'InfoPanel-zine' },
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-label utils--smallCaps' },
	                  'In Collection'
	                ),
	                React.createElement(ZineItem, { zine: primaryZine,
	                  size: 'small',
	                  context: 'InfoPanel' }),
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-otherZines' },
	                  otherZines.length > 0 && React.createElement(
	                    'span',
	                    null,
	                    'Also in',
	                    ' ',
	                    React.createElement(
	                      Link,
	                      { onClick: this.handleOtherZinesClick,
	                        underline: 'hover',
	                        bold: true },
	                      otherZines.length,
	                      ' other ',
	                      pluralize(otherZines.length, 'collection', 'collections')
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  },

	  handleFeedbackClick: function handleFeedbackClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.LEAVE_DRAFT_FEEDBACK, {
	      draftUuid: this.props.stamp.uuid
	    });
	  },

	  handleOtherZinesClick: function handleOtherZinesClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.STAMP_OTHER_ZINES, {
	      stampId: this.props.stamp.id,
	      zineSlugs: this.props.otherZines.map(function (z) {
	        return z.slug;
	      })
	    });
	  }
	});

	module.exports = InfoPanel;

/***/ },

/***/ 281:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    PureRenderMixin = __webpack_require__(2),
	    ClassNameMixin = __webpack_require__(3),
	    SectionTypes = __webpack_require__(40);

	__webpack_require__(343);

	var LightboxOverlay = React.createClass({
	  displayName: 'LightboxOverlay',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    image: React.PropTypes.object.isRequired,
	    color: React.PropTypes.oneOf(['dark', 'light']).isRequired,
	    hideLightbox: React.PropTypes.func.isRequired,
	    isInLightbox: React.PropTypes.bool.isRequired,
	    sectionType: React.PropTypes.oneOf([SectionTypes.COVER, SectionTypes.GALLERY, SectionTypes.POSTER]).isRequired
	  },

	  className: 'stamp-LightboxOverlay',

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.sectionType];
	  },

	  componentDidMount: function componentDidMount() {
	    _.defer(this._triggerActiveTransition);
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    _.defer(this._triggerActiveTransition);
	  },

	  _triggerActiveTransition: function _triggerActiveTransition() {
	    if (this.isMounted()) {
	      this.getDOMNode().setAttribute('data-active', this.props.isInLightbox);
	    }
	  },

	  render: function render() {
	    return React.createElement('div', { className: this.getClassName(),
	      onClick: this.props.hideLightbox });
	  }
	});

	module.exports = LightboxOverlay;

/***/ },

/***/ 282:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    GalleryImage = __webpack_require__(174),
	    PureRenderMixin = __webpack_require__(2),
	    SectionTypes = __webpack_require__(40);

	__webpack_require__(38);
	__webpack_require__(344);

	var IMAGE_SIZES = {
	  'default': 480,
	  'xs': 640,
	  'sm': 992,
	  'md': 1024,
	  'lg': 1024,
	  'xl': 1280
	};

	var ListGallery = React.createClass({
	  displayName: 'ListGallery',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    images: React.PropTypes.array.isRequired,
	    sectionIndex: React.PropTypes.number.isRequired,
	    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
	    toggleLightbox: React.PropTypes.func.isRequired,
	    getLightboxImageStyle: React.PropTypes.func.isRequired,
	    isImageInLightbox: React.PropTypes.func.isRequired,
	    onImageTransitionEnd: React.PropTypes.func.isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return IMAGE_SIZES;
	  },

	  render: function render() {
	    var images = this.props.images;

	    return React.createElement(
	      'div',
	      { className: 'stamp-ListGallery',
	        'data-lightbox': this.props.lightboxState },
	      React.createElement(
	        'div',
	        { className: 'stamp-ListGallery-box' },
	        images.map(this.renderImage)
	      )
	    );
	  },

	  renderImage: function renderImage(image, index) {
	    var imageStyle = this.props.getLightboxImageStyle(image),
	        caption = image.caption;

	    return React.createElement(GalleryImage, { key: index,
	      stamp: this.props.stamp,
	      className: 'stamp-ListGallery-item',
	      caption: caption,
	      image: image,
	      imageSizes: IMAGE_SIZES,
	      imageStyle: imageStyle,
	      onClick: this.handleImageClick,
	      onTransitionEnd: this.props.onImageTransitionEnd,
	      isImageInLightbox: this.props.isImageInLightbox,
	      lightboxState: this.props.lightboxState });
	  },

	  handleImageClick: function handleImageClick(image, e) {
	    var boundingRect = e.target.getBoundingClientRect();
	    this.props.toggleLightbox(this.props.sectionIndex, SectionTypes.GALLERY, image, boundingRect);
	  }
	});

	module.exports = ListGallery;

/***/ },

/***/ 283:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    StampImageMixin = __webpack_require__(130),
	    Img = __webpack_require__(127),
	    ImageCaption = __webpack_require__(175),
	    PureRenderMixin = __webpack_require__(2),
	    SectionTypes = __webpack_require__(40),
	    gradient = __webpack_require__(123);

	__webpack_require__(38);
	__webpack_require__(345);

	var Poster = React.createClass({
	  displayName: 'Poster',

	  mixins: [StampImageMixin, PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    background: React.PropTypes.object.isRequired,
	    sectionIndex: React.PropTypes.number.isRequired,
	    isActive: React.PropTypes.bool.isRequired,
	    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
	    toggleLightbox: React.PropTypes.func.isRequired,
	    getLightboxImageStyle: React.PropTypes.func.isRequired,
	    onImageTransitionEnd: React.PropTypes.func.isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 480,
	      'xs': 640,
	      'sm': 992,
	      'md': 1200,
	      'lg': 1440,
	      'xl': 1600
	    };
	  },

	  getImage: function getImage(props) {
	    return props.background;
	  },

	  render: function render() {
	    var background = this.props.background;
	    var caption = background.caption;
	    var colors = background.colors;var _props = this.props;
	    var isActive = _props.isActive;

	    var lightboxState = _props.lightboxState;
	    var imageStyle = this.props.getLightboxImageStyle(background);
	    var style = {};

	    if (lightboxState || !this.hasLoadedImage()) {
	      style.backgroundImage = gradient('#' + colors.top, '#' + colors.bottom);
	    }

	    return React.createElement(
	      'div',
	      { className: 'stamp-Poster',
	        'data-active': isActive,
	        'data-lightbox': lightboxState,
	        'data-scroll-anchor': true,
	        style: style,
	        onClick: this.toggleAttributionOnMobile },
	      React.createElement(
	        'div',
	        { className: 'stamp-Poster-imageWrapper' },
	        React.createElement(Img, { className: 'stamp-Poster-img',
	          src: this.getImageSrcUrl(),
	          style: imageStyle,
	          onClick: this.handleImageClick,
	          onTransitionEnd: this.props.onImageTransitionEnd,
	          onLoad: this.handleImageLoad,
	          onError: this.handleImageError }),
	        this.renderUsageCounter(),
	        this.renderAttributionOnMobile()
	      ),
	      caption.length > 0 && React.createElement(ImageCaption, { caption: caption,
	        context: 'Poster' })
	    );
	  },

	  handleImageClick: function handleImageClick(e) {
	    var boundingRect = e.target.getBoundingClientRect(),
	        image = this.props.background;

	    this.props.toggleLightbox(this.props.sectionIndex, SectionTypes.POSTER, image, boundingRect);
	  }
	});

	module.exports = Poster;

/***/ },

/***/ 284:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var LightboxOverlay = __webpack_require__(281);
	var Fade = __webpack_require__(278);
	var FadingCalculatorMixin = __webpack_require__(257);
	var PureRenderMixin = __webpack_require__(2);
	var LightboxMixin = __webpack_require__(258);
	var StampScrollMixin = __webpack_require__(261);
	var BackColorMixin = __webpack_require__(56);
	var UserStore = __webpack_require__(5);
	var ZineStore = __webpack_require__(22);
	var createStoreMixin = __webpack_require__(8);
	var assign = __webpack_require__(15);
	var shallowEqual = __webpack_require__(46);
	var SectionTypes = __webpack_require__(40);
	var MediaTypes = __webpack_require__(70);
	var MediaSources = __webpack_require__(254);
	var GalleryLayouts = __webpack_require__(202);var PropTypes = React.PropTypes;

	var LightboxSections = [SectionTypes.GALLERY, SectionTypes.POSTER, SectionTypes.COVER];

	var SectionComponents = {};
	SectionComponents[SectionTypes.COVER] = __webpack_require__(277);
	SectionComponents[SectionTypes.POSTER] = __webpack_require__(283);
	SectionComponents['' + SectionTypes.GALLERY + ':' + GalleryLayouts.LIST] = __webpack_require__(282);
	SectionComponents['' + SectionTypes.GALLERY + ':' + GalleryLayouts.GRID] = __webpack_require__(279);
	SectionComponents[SectionTypes.TEXT] = __webpack_require__(285);
	SectionComponents[SectionTypes.INFO] = __webpack_require__(280);
	SectionComponents['' + SectionTypes.MEDIA + ':' + MediaTypes.AUDIO_TRACK + ':' + MediaSources.SOUNDCLOUD] = __webpack_require__(275);
	SectionComponents['' + SectionTypes.MEDIA + ':' + MediaTypes.AUDIO_PLAYLIST + ':' + MediaSources.SOUNDCLOUD] = __webpack_require__(274);
	SectionComponents['' + SectionTypes.MEDIA + ':' + MediaTypes.VIDEO + ':' + MediaSources.VIMEO] = __webpack_require__(286);
	SectionComponents[SectionTypes.BUY_IN_ITUNES] = __webpack_require__(276);

	var Stamp = React.createClass({
	  displayName: 'Stamp',

	  mixins: [createStoreMixin(UserStore, ZineStore), PureRenderMixin, FadingCalculatorMixin, LightboxMixin, BackColorMixin, StampScrollMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    nextUp: PropTypes.element,
	    primaryZine: PropTypes.object,
	    isInViewer: PropTypes.bool,
	    onInfoPanelOffsetTopChange: PropTypes.func,
	    showFeedback: PropTypes.bool,
	    disableInfoPanel: PropTypes.bool
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = props.stamp;
	    var primaryZine = props.primaryZine;
	    var isInViewer = props.isInViewer;
	    var disableInfoPanel = props.disableInfoPanel;
	    var user = UserStore.get(stamp.user);
	    var zines = (isInViewer ? stamp.zines : []).map(ZineStore.get);
	    var contentSections = stamp.content && stamp.content.sections.slice(1);
	    var handleInfoPanelOffsetTopChange = this.props.onInfoPanelOffsetTopChange;
	    var isLoading = !contentSections;
	    var sections;

	    sections = [{
	      key: stamp.id + '-cover',
	      type: SectionTypes.COVER,
	      stamp: stamp,
	      isLoading: isLoading,
	      primaryZine: primaryZine
	    }];

	    if (!isLoading) {
	      sections = sections.concat(contentSections.map(function (section, i) {
	        return assign({
	          key: stamp.id + '-' + i
	        }, section);
	      }));

	      sections.push({
	        key: stamp.id + '-info',
	        type: SectionTypes.INFO,
	        stamp: stamp,
	        user: user,
	        primaryZine: primaryZine,
	        otherZines: _.without(zines, primaryZine),
	        onOffsetTopChange: handleInfoPanelOffsetTopChange,
	        showFeedback: this.props.showFeedback,
	        disableInfoPanel: disableInfoPanel
	      });
	    }

	    return {
	      sections: sections
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!shallowEqual(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }

	    if (nextProps.stamp.id !== this.props.stamp.id) {
	      this.resetLightbox();
	    }
	  },

	  render: function render() {
	    var sections = this.state.sections,
	        content = sections.map(this.renderSection);

	    content.push(this.renderLightboxOverlay(sections));

	    return React.createElement(
	      'div',
	      { className: 'stamp-Stamp' },
	      _.compact(_.flatten(content)),
	      sections.length > 1 && this.props.nextUp
	    );
	  },

	  renderSection: function renderSection(section, index, sections) {
	    var fading = this.getSectionFading(index),
	        props = this.getSectionProps(section, index, fading),
	        ComponentType,
	        component;

	    ComponentType = SectionComponents[section.type] || SectionComponents[section.type + ':' + section.layout] || SectionComponents[section.type + ':' + section.mediaType + ':' + section.mediaSource];

	    component = React.createElement(ComponentType, props);

	    return fading ? this.wrapInFades(component, index, sections, fading) : component;
	  },

	  getSectionNode: function getSectionNode(index) {
	    return this.refs['section-' + index].getDOMNode();
	  },

	  getSectionProps: function getSectionProps(section, index, fading) {
	    var type = section.type,
	        props;

	    props = assign({
	      sectionIndex: index,
	      isInViewer: !!this.props.isInViewer,
	      ref: 'section-' + index,
	      stamp: this.props.stamp
	    }, section);

	    delete props.type;

	    if (LightboxSections.indexOf(type) > -1) {
	      assign(props, this.getLightboxProps(index));
	    }

	    if (type === SectionTypes.POSTER) {
	      assign(props, {
	        isActive: fading && fading.isActive || false
	      });
	    }

	    return props;
	  },

	  getLightboxProps: function getLightboxProps(index) {
	    return {
	      lightboxState: this.getLightboxState(index),
	      getLightboxImageStyle: this.getLightboxImageStyle,
	      toggleLightbox: this.toggleLightbox,
	      isImageInLightbox: this.isImageInLightbox,
	      onImageTransitionEnd: this.handleLightboxTransitionEnd,
	      isLightboxEnabled: this.isLightboxEnabled
	    };
	  },

	  wrapInFades: function wrapInFades(component, index, sections, fading) {
	    var isLightboxVisible = this.isLightboxVisible(index),
	        isInViewer = this.props.isInViewer,
	        isLastContentSection = index === sections.length - 2,
	        image = sections[index].background || this.props.stamp.thumbnail || {},
	        colors = image.colors || { top: 'FFFFFF', bottom: 'FFFFFF' },
	        topFade,
	        bottomFade;

	    if (index > 0) {
	      topFade = React.createElement(Fade, { key: index + '-top',
	        color: colors.top,
	        isLightboxVisible: isLightboxVisible,
	        isActive: fading.isActive,
	        isVisible: fading.isVisible,
	        opacity: fading.topOpacity,
	        isTop: true });
	    }

	    // Prevent last fade expanding the container beyond the last section in editor.
	    if (isInViewer || isLightboxVisible || !isLastContentSection) {
	      bottomFade = React.createElement(Fade, { key: index + '-bottom',
	        color: colors.bottom,
	        isLightboxVisible: isLightboxVisible,
	        isActive: fading.isActive,
	        isVisible: fading.isVisible,
	        opacity: fading.bottomOpacity });
	    }

	    return [topFade, component, bottomFade];
	  },

	  renderLightboxOverlay: function renderLightboxOverlay(sections) {
	    if (!this.isFadingEnabled() || !this.getLightboxState()) {
	      return;
	    }

	    var lightbox = this.state.lightbox.current || this.state.lightbox.previous,
	        sectionIndex = lightbox.sectionIndex,
	        sectionType = sections[sectionIndex].type,
	        image = lightbox.image,
	        colors = image.colors,
	        textColor = 'dark',
	        overlayColorStop;

	    if (sectionType === SectionTypes.POSTER) {
	      overlayColorStop = this.getGradientColorStop(colors, this.getSectionFading(sectionIndex).progress);
	      textColor = this.getTextColor(overlayColorStop);
	    } else if (sectionType === SectionTypes.COVER) {
	      overlayColorStop = this.getGradientColorStop(colors, 0.5);
	      textColor = this.getTextColor(overlayColorStop);
	    }

	    return React.createElement(LightboxOverlay, { key: 'overlay',
	      stamp: this.props.stamp,
	      image: image,
	      color: textColor,
	      isInLightbox: this.isInLightbox(sectionIndex),
	      isInViewer: this.props.isInViewer,
	      hideLightbox: this.hideLightbox,
	      sectionType: sectionType });
	  },

	  getGradientColorStop: function getGradientColorStop(colors, progress) {
	    var topRGB = this.parseColor(colors.top),
	        bottomRGB = this.parseColor(colors.bottom);

	    return _.zip(topRGB, bottomRGB).map(function (zipped) {
	      var top = zipped[0],
	          bottom = zipped[1],
	          current = Math.round(top + (bottom - top) * progress);

	      return current.toString(16);
	    }).join('');
	  }
	});

	module.exports = Stamp;

/***/ },

/***/ 285:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    FontTest = __webpack_require__(92),
	    enforcePElements = __webpack_require__(297);

	__webpack_require__(38);
	__webpack_require__(346);

	var Text = React.createClass({
	  displayName: 'Text',

	  propTypes: {
	    text: React.PropTypes.string.isRequired },

	  shouldComponentUpdate: function shouldComponentUpdate() {
	    return false;
	  },

	  render: function render() {
	    var html = enforcePElements(this.props.text);

	    return React.createElement(
	      'div',
	      { className: 'stamp-Text',
	        'data-scroll-anchor': 'text' },
	      React.createElement(
	        FontTest,
	        { family: 'minion-pro-condensed',
	          test: html },
	        React.createElement('div', { className: 'stamp-Text-box',
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    );
	  }
	});

	module.exports = Text;

/***/ },

/***/ 286:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var ClassNameMixin = __webpack_require__(3);
	var PlayerActionCreators = __webpack_require__(84);
	var PlayerStore = __webpack_require__(119);
	var PureRenderMixin = __webpack_require__(2);
	var BlurredBackground = __webpack_require__(164);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var Loader = __webpack_require__(43);
	var formatTime = __webpack_require__(136);
	var ResponsiveImageQueueMixin = __webpack_require__(86);
	var ViewportTestMixin = __webpack_require__(168);
	var MediaTypes = __webpack_require__(70);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(347);

	var IMAGE_SIZES = {
	  'default': 480,
	  'xs': 640,
	  'sm': 992,
	  'md': 1024,
	  'lg': 1024,
	  'xl': 1280
	};

	var Video = React.createClass({
	  displayName: 'Video',

	  mixins: [createStoreMixin(PlayerStore), ResponsiveImageQueueMixin, ViewportTestMixin, ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    uuid: PropTypes.string.isRequired,
	    sourceId: PropTypes.number.isRequired,
	    width: PropTypes.number.isRequired,
	    height: PropTypes.number.isRequired,
	    background: PropTypes.shape({
	      url: PropTypes.string.isRequired,
	      size: PropTypes.object.isRequired,
	      colors: PropTypes.object.isRequired
	    }).isRequired
	  },

	  className: 'stamp-Video',

	  getMediaId: function getMediaId() {
	    return this.props.uuid;
	  },

	  getEmbedMaxHeight: function getEmbedMaxHeight() {
	    var height = this.props.height < 960 / this.props.width * this.props.height ? this.props.height : 960 / this.props.width * this.props.height;

	    return height < 540 ? 540 : height;
	  },

	  getInitialState: function getInitialState() {
	    return {
	      hasPressedPlay: false,
	      isLoaded: false
	    };
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      isPlaying: PlayerStore.isPlaying(this.getMediaId())
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _state = this.state;
	    var hasPressedPlay = _state.hasPressedPlay;
	    var isLoaded = _state.isLoaded;
	    var isReady = hasPressedPlay && (isLoaded || isMobile());

	    return [hasPressedPlay && 'pressedPlay', isReady && 'ready'];
	  },

	  getContentWindow: function getContentWindow() {
	    return this.refs.iframe.getDOMNode().contentWindow;
	  },

	  getImageSizes: function getImageSizes() {
	    return IMAGE_SIZES;
	  },

	  getImageOptions: function getImageOptions() {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: this.props.background,
	      sizes: {
	        thumb: true,
	        small: this.state.imageSize > 500,
	        normal: true,
	        retina: devicePixelRatio > 1.5 && this.state.isInViewport
	      }
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    window.addEventListener('message', this.handleIframeMessage);
	  },

	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (this.state.isPlaying && !nextState.isPlaying) {
	      this.postMessage('pause');
	    } else if (!this.state.isPlaying && nextState.isPlaying) {
	      this.postMessage('play');
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.isInViewport !== this.state.isInViewport) {
	      this.updateImageQueue();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this.pause();
	    window.removeEventListener('message', this.handleIframeMessage);
	    this.clearIdleTimeout();
	  },

	  render: function render() {
	    var src = 'https://player.vimeo.com/video/' + this.props.sourceId,
	        height = this.getEmbedMaxHeight();

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        onClick: this.handlePlayClick,
	        'data-scroll-anchor': true },
	      React.createElement('div', { className: 'stamp-Video-bg',
	        style: {
	          backgroundImage: this.getBackgroundImageUrl()
	        } }),
	      React.createElement(
	        'div',
	        { className: 'stamp-Video-blurredBg' },
	        React.createElement(BlurredBackground, { background: this.props.background })
	      ),
	      this.renderLoaderImg(),
	      React.createElement(
	        'div',
	        { className: 'stamp-Video-box' },
	        React.createElement(
	          'div',
	          { className: 'stamp-Video-embed',
	            style: {
	              paddingBottom: height * 100 / 960 + '%'
	            } },
	          React.createElement('iframe', { src: src,
	            frameBorder: '0',
	            webkitAllowFullScreen: true,
	            mozAllowFullscreen: true,
	            allowFullScreen: true,
	            ref: 'iframe' }),
	          !this.state.isLoaded && React.createElement(
	            'div',
	            { className: 'stamp-Video-play' },
	            this.state.hasPressedPlay ? !isMobile() && React.createElement(Loader, { absoluteCenter: true }) : React.createElement(
	              Button,
	              { absoluteCenter: true,
	                context: 'Video',
	                onClick: this.handlePlayClick,
	                size: 'xxxlarge',
	                color: 'black',
	                overlay: true,
	                round: true },
	              React.createElement(Icon, { name: 'play',
	                mode: 'stroke',
	                size: 'large' }),
	              React.createElement(
	                'div',
	                { className: 'stamp-Video-duration utils--hideOnMobile' },
	                formatTime(this.props.duration)
	              )
	            )
	          )
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'stamp-Video-meta' },
	        React.createElement(
	          'div',
	          { className: 'stamp-Video-title' },
	          this.props.title
	        ),
	        React.createElement(
	          'div',
	          { className: 'stamp-Video-author' },
	          this.props.username
	        )
	      )
	    );
	  },

	  handlePlayClick: function handlePlayClick(e) {
	    e.stopPropagation();

	    this.setState({
	      hasPressedPlay: true
	    });

	    if (!this.state.isLoaded) {
	      this.play();
	      this.setIdleTimeout();
	      return;
	    }

	    if (this.state.isPlaying) {
	      this.pause();
	    } else {
	      this.play();
	    }
	  },

	  setIdleTimeout: function setIdleTimeout() {
	    if (!this.idleTimeout) {
	      this.idleTimeout = setTimeout(this.handleVideoIdle, 5000);
	    }
	  },

	  clearIdleTimeout: function clearIdleTimeout() {
	    if (this.idleTimeout) {
	      clearTimeout(this.idleTimeout);
	    }
	  },

	  handleVideoIdle: function handleVideoIdle() {
	    // Go ahead and show iframe if user waited too long
	    this.setState({
	      isLoaded: true
	    });
	  },

	  handleIframeMessage: function handleIframeMessage(e) {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (e.source !== this.getContentWindow()) {
	      return;
	    }

	    var data = null;
	    try {
	      data = JSON.parse(e.data);
	    } catch (err) {
	      // For some reason, this happens from time to time
	      return;
	    }

	    switch (data.event) {
	      case 'ready':
	        this.postMessage('addEventListener', 'play');
	        this.postMessage('addEventListener', 'playProgress');
	        this.postMessage('addEventListener', 'pause');
	        this.postMessage('addEventListener', 'finish');
	        break;

	      case 'play':
	        this.play();
	        break;

	      case 'playProgress':
	        this.handleVideoProgress(data.data);
	        break;

	      case 'pause':
	      case 'finish':
	        this.pause();
	        break;
	    }
	  },

	  handleVideoProgress: function handleVideoProgress(data) {
	    var _this = this;

	    if (!this.state.isLoaded) {
	      this.setState({ isLoaded: true });
	    }

	    // We want to rewind instead of showing related videos.
	    // It's too late to do this in `finish` handler or when `data.progress` is 1.
	    if (data.duration - data.seconds > 0.3) {
	      return;
	    }

	    this.rewind();

	    // Prevents play button stuck in "playing" state in Firefox:
	    requestAnimationFrame(function () {
	      _this.postMessage('pause');
	    });
	  },

	  rewind: function rewind() {
	    // This works better than sending `unload` because it doesn't flicker.
	    this.postMessage('seekTo', 0);
	    this.postMessage('pause');
	  },

	  play: function play() {
	    PlayerActionCreators.play(this.getMediaId(), {
	      mediaType: MediaTypes.VIDEO,
	      stampId: this.props.stamp.id
	    });
	  },

	  pause: function pause() {
	    PlayerActionCreators.pause(this.getMediaId());
	  },

	  postMessage: function postMessage(action, value) {
	    var data = {
	      method: action,
	      value: value
	    };

	    var message = JSON.stringify(data),
	        contentWindow = this.getContentWindow(),
	        url = 'https://player.vimeo.com/video/' + this.props.sourceId;

	    contentWindow.postMessage(message, url);
	  }
	});

	module.exports = Video;

/***/ },

/***/ 297:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// This code is almost identical to Scribe source code,
	// except that we added a few more known block tags.

	// See https://github.com/guardian/scribe/blob/master/src/plugins/core/formatters/html/enforce-p-elements.js

	var _ = __webpack_require__(4);

	var blockElementNames = ['P', 'DIV', 'BLOCKQUOTE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI'];

	function isBlockElement(node) {
	  return _.contains(blockElementNames, node.nodeName);
	}

	/**
	 * Wrap consecutive inline elements and text nodes in a P element.
	 */
	function wrapChildNodes(parentNode) {
	  var groups = Array.prototype.reduce.call(parentNode.childNodes, function (accumulator, binChildNode) {
	    function startNewGroup() {
	      var newGroup = [binChildNode];
	      accumulator.push(newGroup);
	    }

	    var group = _.last(accumulator);
	    if (!group) {
	      startNewGroup();
	    } else {
	      var isBlockGroup = isBlockElement(group[0]);
	      if (isBlockGroup === isBlockElement(binChildNode)) {
	        group.push(binChildNode);
	      } else {
	        startNewGroup();
	      }
	    }

	    return accumulator;
	  }, []);

	  var consecutiveInlineElementsAndTextNodes = groups.filter(function (group) {
	    var isBlockGroup = isBlockElement(group[0]);
	    return !isBlockGroup;
	  });

	  consecutiveInlineElementsAndTextNodes.forEach(function (nodes) {
	    var pElement = document.createElement('p');
	    nodes[0].parentNode.insertBefore(pElement, nodes[0]);
	    nodes.forEach(function (node) {
	      pElement.appendChild(node);
	    });
	  });

	  parentNode._isWrapped = true;
	}

	function enforcePElements(html) {
	  var bin = document.createElement('div');
	  bin.innerHTML = html;

	  // Only wrap immediate children--unlike Scribe,
	  // we don't care about <blockquote> contents.

	  wrapChildNodes(bin);

	  return bin.innerHTML;
	}

	module.exports = enforcePElements;

/***/ },

/***/ 300:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var memoize = _require.memoize;

	var supportsPositionSticky = memoize(function () {
	    // https://github.com/phistuck/Modernizr/commit/3fb7217f5f8274e2f11fe6cfeda7cfaf9948a1f5
	    var prop = 'position:',
	        value = 'sticky',
	        el = document.createElement('test'),
	        style = el.style;

	    style.cssText = prop + ['-webkit-', '-moz-', '-ms-', '-o-', ''].join(value + ';' + prop) + value + ';';
	    return style.position.indexOf(value) !== -1;
	});

	module.exports = supportsPositionSticky;

/***/ },

/***/ 301:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var prefix = (function () {
	  var styles = window.getComputedStyle(document.documentElement, ''),
	      pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1],
	      dom = 'WebKit|Moz|MS|O'.match(new RegExp('(' + pre + ')', 'i'))[1];
	  return {
	    dom: dom,
	    lowercase: pre,
	    css: '-' + pre + '-',
	    js: pre === 'ms' ? 'ms' : pre[0].toUpperCase() + pre.substr(1)
	  };
	})();

	module.exports = prefix;

/***/ },

/***/ 315:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".BlurredBackground{width:100%;height:100%;background-repeat:no-repeat;background-position:center;background-size:cover}", ""]);

/***/ },

/***/ 316:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".ImageUsageCounter{z-index:202;position:absolute;bottom:1rem;left:1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 .5rem;border-radius:2px;height:1.5rem;background-color:rgba(0,0,0,.5);color:#fff;opacity:.65;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1);-webkit-transition-delay:.5s;transition-delay:.5s;pointer-events:none}.ImageUsageCounter-count{margin-left:.5rem;font-weight:700;font-size:.875rem}[data-lightbox=active] .ImageUsageCounter{opacity:0;-webkit-transition-delay:0s;transition-delay:0s}", ""]);

/***/ },

/***/ 317:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".TrackList{margin-top:1.5em;padding-top:1.5em;border-top:1px solid rgba(255,255,255,.15)}.TrackList-track{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#fff;cursor:pointer}.TrackList-track:after{position:absolute;content:\"\";top:-.25rem;right:-1rem;bottom:-.25rem;left:-1rem;background-color:#fff;opacity:0;border-radius:1000px;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1)}.TrackList-track:hover:after{opacity:.1}.TrackList-track~.TrackList-track{margin-top:1rem}.TrackList-track.TrackList-track--active{color:#000}.TrackList-track.TrackList-track--active .TrackList-trackTitle{position:relative;opacity:1}.TrackList-track.TrackList-track--active .TrackList-trackDuration{opacity:1}.TrackList-track.TrackList-track--active:after{opacity:.95}.TrackList-trackTitle{z-index:1;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;overflow:hidden;font-size:1rem;white-space:nowrap;text-overflow:ellipsis;opacity:.8}@media only screen and (min-width:40em){.TrackList-trackTitle{font-size:1.125rem}}@media only screen and (min-width:75em){.TrackList-trackTitle{font-size:1.25rem}}.TrackList-trackDuration{z-index:1;-ms-flex-negative:0;flex-shrink:0;margin-left:1rem;font-size:1rem;opacity:.5}@media only screen and (min-width:40em){.TrackList-trackDuration{font-size:1.125rem}}@media only screen and (min-width:75em){.TrackList-trackDuration{font-size:1.25rem}}", ""]);

/***/ },

/***/ 318:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-AudioContainer{position:relative}.stamp-AudioContainer-bg{position:absolute;top:0;left:0;width:100%;height:100%}.stamp-AudioContainer-bg:before{position:absolute;content:'';top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.3);box-shadow:inset 0 1px 0 rgba(0,0,0,.1),inset 0 -1px 0 rgba(0,0,0,.1)}@media only screen and (min-width:40em){.stamp-AudioContainer-box{display:-webkit-box;display:-ms-flexbox;display:flex}}.stamp-AudioContainer-player{-ms-flex-negative:0;flex-shrink:0}.stamp-AudioContainer-meta{position:relative;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:1.5rem 1rem}@media only screen and (min-width:40em){.stamp-AudioContainer-meta{padding:0 0 0 2.5em;background-color:transparent;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}", ""]);

/***/ },

/***/ 319:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-BuyInItunes{background-color:#763188!important}.stamp-BuyInItunes-box{position:relative;padding:1.75rem;border-radius:2px;background-color:#fff;box-shadow:0 4px 24px rgba(0,0,0,.15),0 0 0 1px rgba(0,0,0,.05)}@media only screen and (min-width:40em){.stamp-BuyInItunes-box{display:-webkit-box;display:-ms-flexbox;display:flex;max-width:46rem!important}}.stamp-BuyInItunes-label{display:none;position:absolute;top:-2rem;left:0;color:#fff;font-weight:700;font-size:.875rem;opacity:.75}@media only screen and (min-width:62em){.stamp-BuyInItunes-label{display:block}}.stamp-BuyInItunes-cover{-ms-flex-negative:0;flex-shrink:0;position:relative;width:100%;padding-bottom:100%;height:0;border-radius:2px;background-size:cover;background-repeat:no-repeat;background-position:center;background-color:#797b80}@media only screen and (min-width:40em){.stamp-BuyInItunes-cover{width:12rem;height:12rem;padding-bottom:0}}.stamp-BuyInItunes-coverLink{position:absolute;top:0;right:0;bottom:0;left:0}.stamp-BuyInItunes-meta{position:relative;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:1.5rem;color:#2e2f33}@media only screen and (min-width:40em){.stamp-BuyInItunes-meta{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-top:0;margin-left:1.5rem;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.stamp-BuyInItunes-title,.stamp-BuyInItunes-artist{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%}.stamp-BuyInItunes-button{margin-top:2rem}.stamp-BuyInItunes-title{margin-bottom:.25rem;font-weight:700;font-size:1.5rem}@media only screen and (min-width:40em){.stamp-BuyInItunes-title{font-size:1.75rem}}.stamp-BuyInItunes-author{opacity:.75;font-size:1.125rem}", ""]);

/***/ },

/***/ 320:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Cover{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:24rem;color:#fff;background-color:#2e2f33;background-position:center;background-size:cover}@media only screen and (min-width:40em){.stamp-Cover{min-height:100vh}}.stamp-Cover:before{z-index:201;position:absolute;top:0;right:0;bottom:0;left:0;content:'';background-color:rgba(0,0,0,.35);pointer-events:none;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1)}.stamp-Cover[data-lightbox=active]:before{opacity:0}.stamp-Cover--clickable{cursor:auto}@media only screen and (min-width:62em){.stamp-Cover--clickable{cursor:zoom-in}}@media only screen and (min-width:62em){[data-lightbox=active] .stamp-Cover{cursor:zoom-out}}.App--ie .stamp-Cover{height:100vh}.stamp-Cover-imgWrapper{position:absolute;left:0;top:0;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:0}.stamp-Cover-img{width:100%;-webkit-transition:-webkit-transform .5s cubic-bezier(.175,.885,.32,1) 0s;transition:transform .5s cubic-bezier(.175,.885,.32,1) 0s}.stamp-Cover-box{z-index:202;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;word-wrap:break-word;-webkit-transition:opacity .1s linear;transition:opacity .1s linear}@media only screen and (min-width:40em){.stamp-Cover-box{margin:4.5rem auto 3rem}}.stamp-Cover-bestOf2014{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:.75rem;padding:0 .75rem;height:1.5rem;border-radius:1000px;background-color:#60f991;color:#000;font-size:.75rem;font-weight:700;text-transform:uppercase;letter-spacing:.0625em;opacity:.9;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1)}.stamp-Cover-bestOf2014:hover{opacity:1}@media only screen and (min-width:40em){.stamp-Cover-bestOf2014{margin-bottom:1.75rem;padding:0 1.75rem;height:2rem;font-size:.875rem}}.stamp-Cover-title{font-size:2.25rem;line-height:1}@media only screen and (min-width:40em){.stamp-Cover-title{font-size:3.75rem}}@media only screen and (min-width:75em){.stamp-Cover-title{font-size:4.6875rem}}.stamp-Cover-subtitle{margin-top:.5em;max-width:46rem;font-family:minion-pro-condensed,serif;font-size:1.25rem;font-weight:400;line-height:1.2;opacity:.75}@media only screen and (min-width:40em){.stamp-Cover-subtitle{font-size:1.75rem}}.stamp-Cover[data-lightbox=active] .stamp-Cover-box,.stamp-Cover[data-lightbox=active] .stamp-Cover-bestOf2014{opacity:0}", ""]);

/***/ },

/***/ 321:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Fade{position:absolute;left:0;z-index:203;display:none;width:100%;height:100vh;-webkit-transition:none;transition:none;-webkit-transform:translate(0,0);transform:translate(0,0);will-change:transform,opacity}.stamp-Fade[data-animate=true]{-webkit-transition:opacity .1s linear;transition:opacity .1s linear}@media only screen and (min-width:62em){.stamp-Fade{display:block}}.stamp-Fade--top{-webkit-transform:translate(0,-100%);transform:translate(0,-100%)}", ""]);

/***/ },

/***/ 322:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-GalleryImage{width:100%;max-width:100%}.stamp-GalleryImage-imageWrapper{position:relative}.stamp-GalleryImage-imageWrapper img{width:100%;max-width:100%;vertical-align:bottom;-webkit-transition:-webkit-transform .5s cubic-bezier(.175,.885,.32,1);transition:transform .5s cubic-bezier(.175,.885,.32,1);will-change:transform;cursor:normal}@media only screen and (min-width:62em){.stamp-GalleryImage-imageWrapper img{cursor:zoom-in}}@media only screen and (min-width:62em){[data-lightbox=active] img{cursor:zoom-out}}", ""]);

/***/ },

/***/ 323:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-GridGallery-row{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media only screen and (min-width:40em){.stamp-GridGallery-row{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.stamp-GridGallery-row~.stamp-GridGallery-row{margin-top:1rem}@media only screen and (min-width:40em){.stamp-GridGallery-row~.stamp-GridGallery-row{margin-top:1.5%}}.stamp-GridGallery-item{position:relative;vertical-align:top}@media(max-width:40em){.stamp-GridGallery-item~.stamp-GridGallery-item{margin-top:1rem}}@media only screen and (min-width:40em){.stamp-GridGallery-item{margin:0}.stamp-GridGallery-item:nth-child(even){padding-left:.75%}.stamp-GridGallery-item:nth-child(odd){padding-right:.75%}.stamp-GridGallery-item:only-child{padding:0}}.stamp-GridGallery-item.stamp-GridGallery-item--lightbox{position:relative;z-index:1}", ""]);

/***/ },

/***/ 324:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-ImageCaption{padding:.75em 0;color:#797b80}.stamp-ImageCaption-text{margin:0 auto;text-align:center;font-family:minion-pro-condensed,serif;font-style:italic;font-size:1.125rem;white-space:normal;word-wrap:break-word;pointer-events:auto}.stamp-ImageCaption.stamp-ImageCaption--isInPoster{padding-bottom:1.75rem;background-color:#fff;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1);-webkit-transition-delay:.5s;transition-delay:.5s}@media only screen and (min-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster{position:absolute;bottom:0;right:0;left:0;padding:8rem 0 3.5rem;color:#fff;background-color:transparent;background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.5),transparent);background-image:linear-gradient(to top,rgba(0,0,0,.5),transparent)}}@media(max-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box{padding-left:.75rem;padding-right:.75rem}}@media only screen and (min-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box{position:relative;padding-top:1.75rem}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:before,.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:after{position:absolute;left:0;right:0;content:\"\";display:block;margin:0 auto;width:4rem;height:1px;background-color:currentColor;opacity:.5}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:before{top:0;opacity:.5}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:after{top:-3px;opacity:.5}}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-text{line-height:1.3}@media only screen and (min-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-text{font-size:1.5rem}}[data-lightbox=active] .stamp-ImageCaption.stamp-ImageCaption--isInPoster{opacity:0;-webkit-transition:opacity 0s cubic-bezier(.175,.885,.32,1);transition:opacity 0s cubic-bezier(.175,.885,.32,1);-webkit-transition-delay:0s;transition-delay:0s}", ""]);

/***/ },

/***/ 325:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".InfoPanel{background-color:#fff;color:#2e2f33;padding-bottom:1.25rem}.InfoPanel[data-disabled=true]{pointer-events:none}.InfoPanel-box{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0 auto;width:100%;max-width:46rem}.InfoPanel-label{width:100%;margin-bottom:.75rem;text-align:center;color:#797b80}.InfoPanel-section{padding:1.75rem 0}@media only screen and (min-width:40em){.InfoPanel-section{padding:3.5rem 0}}.InfoPanel-section.InfoPanel-section--buttons{border-top:1px solid #e8e8e8;border-bottom:1px solid #e8e8e8}.InfoPanel-section.InfoPanel-section--userAndZine{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}@media only screen and (min-width:40em){.InfoPanel-section.InfoPanel-section--userAndZine{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.InfoPanel-section.InfoPanel-section--feedback{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.InfoPanel-zine{position:relative;margin-top:.75rem}@media only screen and (min-width:40em){.InfoPanel-zine{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:0;margin-left:3.5rem}}.InfoPanel-otherZines,.InfoPanel-date{height:1.75rem;margin-top:.75rem;font-size:.875rem;color:#797b80;text-align:center}.InfoPanel-user{position:relative;margin-bottom:.75rem}@media only screen and (min-width:40em){.InfoPanel-user{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:0}}.InfoPanel-buttons{position:relative;-ms-flex-item-align:stretch;align-self:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.InfoPanel-share{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

/***/ },

/***/ 326:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-LightboxOverlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.95);opacity:0;-webkit-transition:opacity .1s linear;transition:opacity .1s linear;will-change:opacity;pointer-events:none;z-index:204}.stamp-LightboxOverlay[data-active=true]{opacity:1;pointer-events:auto;cursor:zoom-out}.stamp-LightboxOverlay.stamp-LightboxOverlay--poster,.stamp-LightboxOverlay.stamp-LightboxOverlay--cover{background-color:transparent}", ""]);

/***/ },

/***/ 327:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-ListGallery-item{position:relative;margin-bottom:1rem;text-align:center}.stamp-ListGallery-item:last-child{margin-bottom:0}@media only screen and (min-width:40em){.stamp-ListGallery-item{margin-bottom:2rem}}@media only screen and (min-width:62em){.stamp-ListGallery-item{margin-bottom:2rem}}@media only screen and (min-width:75em){.stamp-ListGallery-item{margin-bottom:3rem}}@media only screen and (min-width:100em){.stamp-ListGallery-item{margin-bottom:4rem}}", ""]);

/***/ },

/***/ 328:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Poster{position:relative;line-height:0}.stamp-Poster[data-active=false]{-moz-user-select:none}@media only screen and (min-width:62em){.stamp-Poster[data-active=false]{pointer-events:none}}.stamp-Poster-imageWrapper{position:relative}.stamp-Poster-img{width:100%;vertical-align:bottom;cursor:auto;-webkit-transition:-webkit-transform .5s cubic-bezier(.175,.885,.32,1);transition:transform .5s cubic-bezier(.175,.885,.32,1);will-change:transform}@media only screen and (min-width:62em){.stamp-Poster-img{cursor:zoom-in}}@media only screen and (min-width:62em){[data-lightbox=active] .stamp-Poster-img{cursor:zoom-out}}", ""]);

/***/ },

/***/ 329:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Text{font-family:minion-pro-condensed,serif;color:#2e2f33}.stamp-Text-box{word-wrap:break-word}.stamp-Text-box>*:first-child{margin-top:0}.stamp-Text-box>*:last-child{margin-bottom:0}.stamp-Text-box p{margin:1.5em auto;max-width:46rem;font-size:1.125rem}@media only screen and (min-width:40em){.stamp-Text-box p{font-size:1.5rem}}.stamp-Text-box h3{margin:0 auto 1.5em;max-width:46rem;font-size:1.5rem;text-align:center}@media only screen and (min-width:40em){.stamp-Text-box h3{font-size:2.25rem}}.stamp-Text-box blockquote,.stamp-Text-box blockquote p,.stamp-Text-box blockquote span{max-width:none;color:#797b80;font-size:1.25rem;font-style:italic;text-align:center}@media only screen and (min-width:40em){.stamp-Text-box blockquote,.stamp-Text-box blockquote p,.stamp-Text-box blockquote span{font-size:1.75rem}}@media only screen and (min-width:62em){.stamp-Text-box blockquote,.stamp-Text-box blockquote p,.stamp-Text-box blockquote span{font-size:2.25rem}}.stamp-Text-box blockquote p,.stamp-Text-box blockquote p p,.stamp-Text-box blockquote span p,.stamp-Text-box blockquote span,.stamp-Text-box blockquote p span,.stamp-Text-box blockquote span span{margin:0}.stamp-Text-box blockquote{margin:2em auto}.stamp-Text-box blockquote:before{display:block;margin:0 auto .5em}.stamp-Text-box blockquote:after{display:block;margin:.5em auto 0}.stamp-Text-box blockquote+blockquote:before{display:none}", ""]);

/***/ },

/***/ 330:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Video{position:relative;background-color:#000;cursor:pointer}.stamp-Video-box{color:#fff;overflow:hidden}.stamp-Video-bg,.stamp-Video-blurredBg{position:absolute;top:0;left:0;width:100%;height:100%}.stamp-Video-bg:before,.stamp-Video-blurredBg:before{position:absolute;content:'';top:0;right:0;bottom:0;left:0;background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.4),transparent);background-image:linear-gradient(to top,rgba(0,0,0,.4),transparent)}.stamp-Video-bg{background-repeat:no-repeat;background-position:center;background-size:cover}.stamp-Video-blurredBg{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;will-change:opacity;opacity:0}.stamp-Video-embed{position:relative}.stamp-Video-embed img{max-width:100%;vertical-align:bottom;opacity:0}.stamp-Video-embed iframe{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;pointer-events:none;-webkit-transform:scale(.75);transform:scale(.75);will-change:transform;-webkit-transition:opacity .5s ease-out,-webkit-transform 1s cubic-bezier(.175,.885,.32,1);transition:opacity .5s ease-out,transform 1s cubic-bezier(.175,.885,.32,1)}.stamp-Video-duration{position:absolute;bottom:1rem;margin:0 .5rem;left:0;right:0;text-align:center;font-size:.875rem}.stamp-Video-meta{position:relative;width:100%;padding:.75rem;z-index:1;text-align:center;-webkit-transition:opacity .25s ease-out;transition:opacity .25s ease-out;color:#fff;background-color:rgba(0,0,0,.5)}@media only screen and (min-width:40em){.stamp-Video-meta{padding:1.75rem}}@media only screen and (min-width:62em){.stamp-Video-meta{position:absolute;bottom:0;background-color:transparent}}.stamp-Video-title,.stamp-Video-author{max-width:46rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:0 auto}.stamp-Video-title{margin-bottom:.5rem;font-weight:700;font-size:1.25rem}@media only screen and (min-width:40em){.stamp-Video-title{font-size:1.75rem}}@media only screen and (min-width:75em){.stamp-Video-title{font-size:2.25rem}}.stamp-Video-author{opacity:.75}@media only screen and (min-width:40em){.stamp-Video-author{font-size:1.125rem}}.stamp-Video--pressedPlay .stamp-Video-blurredBg{opacity:1}.stamp-Video--ready{cursor:default}.stamp-Video--ready .stamp-Video-embed iframe{-webkit-transform:scale(1);transform:scale(1);opacity:1;pointer-events:auto}@media only screen and (min-width:62em){.stamp-Video--ready .stamp-Video-meta{opacity:0;pointer-events:none}}", ""]);

/***/ },

/***/ 331:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-Poster,.stamp-Video,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{z-index:200}.stamp-Cover+.stamp-Poster,.stamp-Poster+.stamp-Poster{margin-top:1rem}@media only screen and (min-width:62em){.stamp-Cover+.stamp-Poster,.stamp-Poster+.stamp-Poster{margin-top:0}}.stamp-ListGallery[data-lightbox=active],.stamp-GridGallery[data-lightbox=active],.stamp-Poster[data-lightbox=active],.stamp-ListGallery[data-lightbox=leaving],.stamp-GridGallery[data-lightbox=leaving],.stamp-Poster[data-lightbox=leaving]{z-index:auto}.stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{position:relative;padding:1.25rem .75rem;background-color:#fff}@media only screen and (min-width:40em){.stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{padding:2.75rem 1.75rem}.stamp-Cover.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Text.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-ListGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-GridGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-AudioContainer.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Info.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-BuyInItunes.stamp-AudioContainer--supportsSticky .AudioCover{position:-webkit-sticky;position:sticky;top:2.75rem}}@media only screen and (min-width:62em){.stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{padding:5rem 3.5rem}.stamp-Cover.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Text.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-ListGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-GridGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-AudioContainer.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Info.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-BuyInItunes.stamp-AudioContainer--supportsSticky .AudioCover{position:-webkit-sticky;position:sticky;top:5rem}}.stamp-Cover-box,.stamp-Text-box,.stamp-ListGallery-box,.stamp-AudioContainer-box,.stamp-Video-box,.stamp-GridGallery-box,.stamp-ImageCaption-box,.stamp-BuyInItunes-box{position:relative;margin:0 auto}.stamp-Cover-box,.stamp-ListGallery-box,.stamp-Video-box,.stamp-AudioContainer-box,.stamp-GridGallery-box,.stamp-Text-box,.stamp-BuyInItunes-box{max-width:100%}@media only screen and (min-width:40em){.stamp-Cover-box,.stamp-ListGallery-box,.stamp-Video-box,.stamp-AudioContainer-box,.stamp-GridGallery-box,.stamp-Text-box,.stamp-BuyInItunes-box{max-width:46rem}}@media only screen and (min-width:75em){.stamp-Cover-box,.stamp-ListGallery-box,.stamp-Video-box,.stamp-AudioContainer-box,.stamp-GridGallery-box,.stamp-Text-box,.stamp-BuyInItunes-box{max-width:56rem}}@media only screen and (min-width:40em){.stamp-ImageCaption-box{max-width:46rem}}.stamp-ListGallery+.stamp-Text,.stamp-GridGallery+.stamp-Text,.stamp-Text+.stamp-ListGallery,.stamp-Text+.stamp-GridGallery{padding-top:0}.stamp-ListGallery+.stamp-ListGallery:before,.stamp-GridGallery+.stamp-GridGallery:before,.stamp-ListGallery+.stamp-GridGallery:before,.stamp-GridGallery+.stamp-ListGallery:before,.stamp-Text+.stamp-Text:before,.stamp-ListGallery+.stamp-ListGallery:after,.stamp-GridGallery+.stamp-GridGallery:after,.stamp-ListGallery+.stamp-GridGallery:after,.stamp-GridGallery+.stamp-ListGallery:after,.stamp-Text+.stamp-Text:after{position:absolute;left:0;right:0;content:\"\";display:block;margin:0 auto;width:4rem;height:1px;background-color:rgba(121,123,128,.5)}.stamp-ListGallery+.stamp-ListGallery:before,.stamp-GridGallery+.stamp-GridGallery:before,.stamp-ListGallery+.stamp-GridGallery:before,.stamp-GridGallery+.stamp-ListGallery:before,.stamp-Text+.stamp-Text:before{top:0}.stamp-ListGallery+.stamp-ListGallery:after,.stamp-GridGallery+.stamp-GridGallery:after,.stamp-ListGallery+.stamp-GridGallery:after,.stamp-GridGallery+.stamp-ListGallery:after,.stamp-Text+.stamp-Text:after{top:-3px}", ""]);

/***/ },

/***/ 332:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(315);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/atoms/BlurredBackground.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/atoms/BlurredBackground.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 333:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(316);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/ImageUsageCounter.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/ImageUsageCounter.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 334:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(317);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/TrackList.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/TrackList.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 335:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/AudioContainer.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/AudioContainer.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 336:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(319);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/BuyInItunes.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/BuyInItunes.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 337:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(320);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Cover.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Cover.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 338:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(321);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Fade.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Fade.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 339:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GalleryImage.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GalleryImage.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 340:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(323);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GridGallery.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GridGallery.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 341:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(324);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ImageCaption.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ImageCaption.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 342:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(325);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/InfoPanel.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/InfoPanel.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 343:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(326);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/LightboxOverlay.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/LightboxOverlay.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 344:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(327);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ListGallery.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ListGallery.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 345:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(328);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Poster.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Poster.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 346:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(329);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Text.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Text.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 347:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(330);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Video.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Video.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 354:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var keyMirror = __webpack_require__(24);

	var DragDropActionTypes = keyMirror({
	  DRAG_START: null,
	  DRAG_END: null,
	  DRAG: null,
	  DROP: null
	});

	module.exports = DragDropActionTypes;

/***/ },

/***/ 355:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DropEffects = {
	  COPY: "copy",
	  MOVE: "move",
	  LINK: "link"
	};

	module.exports = DropEffects;

/***/ },

/***/ 356:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var Dispatcher = __webpack_require__(479).Dispatcher,
	    assign = __webpack_require__(15);

	var DragDropDispatcher = assign(new Dispatcher(), {
	  handleAction: function handleAction(action) {
	    this.dispatch({
	      action: action
	    });
	  }
	});

	module.exports = DragDropDispatcher;

/***/ },

/***/ 357:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DragDropDispatcher = __webpack_require__(356),
	    DragDropActionTypes = __webpack_require__(354),
	    createStore = __webpack_require__(505);

	var _initialOffsetFromContainer = null,
	    _initialOffsetFromClient = null,
	    _currentOffsetFromClient = null;

	var DragOffsetStore = createStore({
	  getInitialOffsetFromContainer: function getInitialOffsetFromContainer() {
	    return _initialOffsetFromContainer;
	  },

	  getInitialOffsetFromClient: function getInitialOffsetFromClient() {
	    return _initialOffsetFromClient;
	  },

	  getCurrentOffsetFromClient: function getCurrentOffsetFromClient() {
	    return _currentOffsetFromClient;
	  }
	});

	DragOffsetStore.dispatchToken = DragDropDispatcher.register(function (payload) {
	  var action = payload.action;


	  switch (action.type) {
	    case DragDropActionTypes.DRAG_START:
	      _initialOffsetFromContainer = action.offsetFromContainer;
	      _initialOffsetFromClient = action.offsetFromClient;
	      _currentOffsetFromClient = action.offsetFromClient;
	      DragOffsetStore.emitChange();
	      break;

	    case DragDropActionTypes.DRAG:
	      _currentOffsetFromClient = action.offsetFromClient;
	      DragOffsetStore.emitChange();
	      break;

	    case DragDropActionTypes.DRAG_END:
	      _currentOffsetFromClient = null;
	      _currentOffsetFromClient = null;
	      DragOffsetStore.emitChange();
	  }
	});

	module.exports = DragOffsetStore;

/***/ },

/***/ 358:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DragDropDispatcher = __webpack_require__(356),
	    DragDropActionTypes = __webpack_require__(354),
	    DragOffsetStore = __webpack_require__(357),
	    createStore = __webpack_require__(505);

	var _draggedItem = null,
	    _draggedItemType = null,
	    _effectsAllowed = null,
	    _dropEffect = null;

	var DragOperationStore = createStore({
	  isDragging: function isDragging() {
	    return !!_draggedItem;
	  },

	  getEffectsAllowed: function getEffectsAllowed() {
	    return _effectsAllowed;
	  },

	  getDropEffect: function getDropEffect() {
	    return _dropEffect;
	  },

	  getDraggedItem: function getDraggedItem() {
	    return _draggedItem;
	  },

	  getDraggedItemType: function getDraggedItemType() {
	    return _draggedItemType;
	  }
	});

	DragOperationStore.dispatchToken = DragDropDispatcher.register(function (payload) {
	  DragDropDispatcher.waitFor([DragOffsetStore.dispatchToken]);

	  var action = payload.action;


	  switch (action.type) {
	    case DragDropActionTypes.DRAG_START:
	      _dropEffect = null;
	      _draggedItem = action.item;
	      _draggedItemType = action.itemType;
	      _effectsAllowed = action.effectsAllowed;
	      DragOperationStore.emitChange();
	      break;

	    case DragDropActionTypes.DROP:
	      _dropEffect = action.dropEffect;
	      DragOperationStore.emitChange();
	      break;

	    case DragDropActionTypes.DRAG_END:
	      _draggedItem = null;
	      _draggedItemType = null;
	      _effectsAllowed = null;
	      _dropEffect = null;
	      DragOperationStore.emitChange();
	      break;
	  }
	});

	module.exports = DragOperationStore;

/***/ },

/***/ 359:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	function isSafari() {
	  return !!window.safari;
	}

	module.exports = isSafari;

/***/ },

/***/ 389:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9);

	var GrabbagActionCreators = {
	  addGrabbagItem: function addGrabbagItem(filePath) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.ADD_GRABBAG_ITEM,
	      filePath: filePath
	    });
	  },

	  updateGrabbagItem: function updateGrabbagItem(filePath, data) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.UPDATE_GRABBAG_ITEM,
	      filePath: filePath,
	      data: data
	    });
	  },

	  deleteGrabbagItem: function deleteGrabbagItem(filePathOrItemId) {
	    var filePath, itemId;

	    if (typeof filePathOrItemId === 'string') {
	      itemId = filePathOrItemId;
	    } else {
	      filePath = filePathOrItemId;
	    }

	    AppDispatcher.handleViewAction({
	      type: ActionTypes.DELETE_GRABBAG_ITEM,
	      filePath: filePath,
	      itemId: itemId
	    });
	  }
	};

	module.exports = GrabbagActionCreators;

/***/ },

/***/ 401:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ContentEditable = __webpack_require__(250);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);var PropTypes = React.PropTypes;

	__webpack_require__(923);

	var ImageCaption = React.createClass({
	  displayName: 'ImageCaption',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    onChange: PropTypes.func.isRequired,
	    text: PropTypes.string.isRequired
	  },

	  className: 'editor-ImageCaption',

	  getInitialState: function getInitialState() {
	    return {
	      isCaptionActive: false
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.state.isCaptionActive && 'active', !this.props.text && 'empty'];
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      this.props.children,
	      React.createElement(ContentEditable, { className: 'editor-ImageCaption-input',
	        text: this.props.text,
	        placeholder: 'Add optional caption',
	        onChange: this.props.onChange,
	        onFocus: this.handeCaptionFocus,
	        onBlur: this.handeCaptionBlur,
	        onMouseDown: this.handleMouseDown,
	        editable: true })
	    );
	  },

	  handleMouseDown: function handleMouseDown(e) {
	    if (!this.state.isCaptionActive) {
	      e.preventDefault();
	      e.target.focus();
	    }
	  },

	  handeCaptionFocus: function handeCaptionFocus() {
	    this.setState({ isCaptionActive: true });
	  },

	  handeCaptionBlur: function handeCaptionBlur() {
	    this.setState({ isCaptionActive: false });
	  }
	});

	module.exports = ImageCaption;

/***/ },

/***/ 480:
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(487),
	    baseUniq = __webpack_require__(491);

	/**
	 * Creates an array of unique values, in order, of the provided arrays using
	 * `SameValueZero` for equality comparisons.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([1, 2], [4, 2], [2, 1]);
	 * // => [1, 2, 4]
	 */
	function union() {
	  return baseUniq(baseFlatten(arguments, false, true));
	}

	module.exports = union;


/***/ },

/***/ 491:
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(488),
	    cacheIndexOf = __webpack_require__(492),
	    createCache = __webpack_require__(493);

	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= 200,
	      seen = isLarge ? createCache() : null,
	      result = [];

	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;

	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}

	module.exports = baseUniq;


/***/ },

/***/ 494:
/***/ function(module, exports, __webpack_require__) {

	var isIndex = __webpack_require__(350),
	    isLength = __webpack_require__(88),
	    isObject = __webpack_require__(104);

	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number') {
	    var length = object.length,
	        prereq = isLength(length) && isIndex(index, length);
	  } else {
	    prereq = type == 'string' && index in object;
	  }
	  if (prereq) {
	    var other = object[index];
	    return value === value ? value === other : other !== other;
	  }
	  return false;
	}

	module.exports = isIterateeCall;


/***/ },

/***/ 500:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DragDropDispatcher = __webpack_require__(356),
	    DragDropActionTypes = __webpack_require__(354);

	var DragDropActionCreators = {
	  startDragging: function startDragging(itemType, item, effectsAllowed, offsetFromClient, offsetFromContainer) {
	    DragDropDispatcher.handleAction({
	      type: DragDropActionTypes.DRAG_START,
	      itemType: itemType,
	      item: item,
	      effectsAllowed: effectsAllowed,
	      offsetFromClient: offsetFromClient,
	      offsetFromContainer: offsetFromContainer
	    });
	  },

	  drag: function drag(offsetFromClient) {
	    DragDropDispatcher.handleAction({
	      type: DragDropActionTypes.DRAG,
	      offsetFromClient: offsetFromClient
	    });
	  },

	  recordDrop: function recordDrop(dropEffect) {
	    DragDropDispatcher.handleAction({
	      type: DragDropActionTypes.DROP,
	      dropEffect: dropEffect
	    });
	  },

	  endDragging: function endDragging() {
	    DragDropDispatcher.handleAction({
	      type: DragDropActionTypes.DRAG_END
	    });
	  }
	};

	module.exports = DragDropActionCreators;

/***/ },

/***/ 501:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var keyMirror = __webpack_require__(24);

	var HorizontalDragAnchors = keyMirror({
	  LEFT: null,
	  CENTER: null,
	  RIGHT: null
	});

	module.exports = HorizontalDragAnchors;

/***/ },

/***/ 502:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var keyMirror = __webpack_require__(24);

	var NativeDragItemTypes = {
	  FILE: "__NATIVE_FILE__"
	};

	module.exports = NativeDragItemTypes;

/***/ },

/***/ 503:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var keyMirror = __webpack_require__(24);

	var VerticalDragAnchors = keyMirror({
	  TOP: null,
	  CENTER: null,
	  BOTTOM: null
	});

	module.exports = VerticalDragAnchors;

/***/ },

/***/ 504:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _prototypeProperties = function (child, staticProps, instanceProps) { if (staticProps) Object.defineProperties(child, staticProps); if (instanceProps) Object.defineProperties(child.prototype, instanceProps); };

	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

	var union = __webpack_require__(480),
	    without = __webpack_require__(996);

	var EnterLeaveMonitor = (function () {
	  function EnterLeaveMonitor() {
	    _classCallCheck(this, EnterLeaveMonitor);

	    this._entered = [];
	  }

	  _prototypeProperties(EnterLeaveMonitor, null, {
	    enter: {
	      value: function enter(enteringNode) {
	        this._entered = union(this._entered.filter(function (node) {
	          return document.body.contains(node) && (!node.contains || node.contains(enteringNode));
	        }), [enteringNode]);

	        return this._entered.length === 1;
	      },
	      writable: true,
	      configurable: true
	    },
	    leave: {
	      value: function leave(leavingNode) {
	        this._entered = without(this._entered.filter(function (node) {
	          return document.body.contains(node);
	        }), leavingNode);

	        return this._entered.length === 0;
	      },
	      writable: true,
	      configurable: true
	    },
	    reset: {
	      value: function reset() {
	        this._entered = [];
	      },
	      writable: true,
	      configurable: true
	    }
	  });

	  return EnterLeaveMonitor;
	})();

	module.exports = EnterLeaveMonitor;

/***/ },

/***/ 505:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var EventEmitter = __webpack_require__(473).EventEmitter,
	    assign = __webpack_require__(15),
	    CHANGE_EVENT = "change";

	function createStore(spec) {
	  var store = assign({
	    emitChange: function emitChange() {
	      this.emit(CHANGE_EVENT);
	    },

	    addChangeListener: function addChangeListener(callback) {
	      this.on(CHANGE_EVENT, callback);
	    },

	    removeChangeListener: function removeChangeListener(callback) {
	      this.removeListener(CHANGE_EVENT, callback);
	    }
	  }, spec, EventEmitter.prototype);

	  store.setMaxListeners(0);

	  return store;
	}

	module.exports = createStore;

/***/ },

/***/ 506:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	function isFileDragDropEvent(e) {
	  if (!e.dataTransfer) {
	    return false;
	  }

	  var types = Array.prototype.slice.call(e.dataTransfer.types);
	  return types.indexOf("Files") !== -1;
	}

	module.exports = isFileDragDropEvent;

/***/ },

/***/ 557:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var ActionTypes = __webpack_require__(9);
	var AppDispatcher = __webpack_require__(6);
	var ImageUploader = __webpack_require__(295);
	var AlertActionCreators = __webpack_require__(32);
	var getThumbnailUrl = __webpack_require__(37);
	var _require = __webpack_require__(186);

	var camelizeKeys = _require.camelizeKeys;
	var _require2 = __webpack_require__(122);

	var post = _require2.post;
	var createTokenSource = __webpack_require__(455);

	var tokenSources = {},
	    CANCEL_REASON = {};

	function uploadMediaThumbnail(sectionId, thumbnailUrl) {
	  if (tokenSources[sectionId]) {
	    tokenSources[sectionId].cancel(CANCEL_REASON);
	  }

	  tokenSources[sectionId] = createTokenSource();

	  AppDispatcher.handleViewAction({
	    type: ActionTypes.UPLOAD_MEDIA_THUMBNAIL,
	    sectionId: sectionId,
	    thumbnailUrl: thumbnailUrl
	  });

	  ImageUploader.uploadFromUrl(thumbnailUrl, tokenSources[sectionId].token).then(function (image) {
	    AppDispatcher.handleServerAction({
	      type: ActionTypes.UPLOAD_MEDIA_THUMBNAIL_SUCCESS,
	      image: image,
	      sectionId: sectionId
	    });
	  })['catch'](function (err) {
	    if (err === CANCEL_REASON) {
	      return;
	    }

	    AppDispatcher.handleServerAction({
	      type: ActionTypes.UPLOAD_MEDIA_THUMBNAIL_ERROR,
	      sectionId: sectionId,
	      error: err
	    });
	  });
	}

	var MediaActionCreators = {
	  requestMediaData: function requestMediaData(sectionId, url) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.REQUEST_MEDIA_DATA,
	      sectionId: sectionId
	    });

	    post('/api/media', { url: url }, this.handleMediaData.bind(this), sectionId);
	  },

	  handleMediaData: function handleMediaData(err, response, sectionId) {
	    var data, uploadUrl;

	    if (response) {
	      data = camelizeKeys(response);

	      if (data.background) {
	        // Upload thumbnail to our server, clear external URL out of data
	        uploadUrl = getThumbnailUrl(data.background, {
	          width: 1024,
	          height: 1024
	        });

	        data.background = null;
	      }
	    }

	    AppDispatcher.handleServerAction({
	      type: err ? ActionTypes.REQUEST_MEDIA_DATA_ERROR : ActionTypes.REQUEST_MEDIA_DATA_SUCCESS,
	      data: data,
	      sectionId: sectionId
	    });

	    if (err) {
	      var alertId = err.body;
	      AlertActionCreators.showAlert(alertId);
	    } else if (uploadUrl) {
	      uploadMediaThumbnail(sectionId, uploadUrl);
	    }
	  }
	};

	module.exports = MediaActionCreators;

/***/ },

/***/ 639:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  DraftPage: __webpack_require__(742),
	  DraftPreviewPage: __webpack_require__(743),
	  DraftComposePage: __webpack_require__(741)
	};

/***/ },

/***/ 658:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _Object$keys = __webpack_require__(304)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var DragItemTypes = __webpack_require__(85);
	var SectionTypes = __webpack_require__(40);
	var MediaTypes = __webpack_require__(70);
	var PureRenderMixin = __webpack_require__(2);
	var _require = __webpack_require__(74);

	var DragDropMixin = _require.DragDropMixin;var PropTypes = React.PropTypes;

	__webpack_require__(917);

	var BUTTONS = {
	  'poster': {
	    title: 'Fullscreen',
	    icon: 'poster',
	    sectionType: SectionTypes.POSTER
	  },
	  'gallery': {
	    title: 'Set',
	    icon: 'set',
	    sectionType: SectionTypes.GALLERY
	  },
	  'text': {
	    title: 'Text',
	    icon: 'text',
	    sectionType: SectionTypes.TEXT
	  },
	  'audio': {
	    title: 'Audio',
	    icon: 'audio',
	    sectionType: SectionTypes.MEDIA,
	    options: {
	      mediaType: MediaTypes.AUDIO_TRACK
	    }
	  },
	  'video': {
	    title: 'Video',
	    icon: 'video',
	    sectionType: SectionTypes.MEDIA,
	    options: {
	      mediaType: MediaTypes.VIDEO
	    }
	  }
	};

	var AddSectionButton = React.createClass({
	  displayName: 'AddSectionButton',

	  mixins: [ClassNameMixin, DragDropMixin, PureRenderMixin],

	  className: 'editor-AddSectionButton',

	  propTypes: {
	    isLast: PropTypes.bool.isRequired,
	    type: PropTypes.oneOf(_Object$keys(BUTTONS)).isRequired,
	    onClick: PropTypes.func.isRequired,
	    onDrop: PropTypes.func
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _getDropState = this.getDropState(DragItemTypes.IMAGE);

	    var isDragging = _getDropState.isDragging;
	    var isLast = this.props.isLast;

	    return [isDragging && 'drop', isLast && 'last'];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(DragItemTypes.IMAGE, {
	      dropTarget: {
	        canDrop: function canDrop() {
	          return !!this.props.onDrop;
	        },

	        acceptDrop: function acceptDrop(item) {
	          var sectionType = BUTTONS[this.props.type].sectionType,
	              options;

	          switch (sectionType) {
	            case SectionTypes.POSTER:
	              options = { background: item.image };
	              break;
	            case SectionTypes.GALLERY:
	              options = { images: [item.image] };
	              break;
	          }
	          this.props.onDrop(sectionType, options);
	        }
	      }
	    });
	  },

	  render: function render() {
	    var _props = this.props;
	    var type = _props.type;
	    var isLast = _props.isLast;
	    var _getDropState2 = this.getDropState(DragItemTypes.IMAGE);

	    var isDragging = _getDropState2.isDragging;
	    var isHovering = _getDropState2.isHovering;

	    return React.createElement(
	      'div',
	      _extends({ className: this.getClassName(),
	        'data-hint': isDragging,
	        'data-hover': isHovering
	      }, this.dropTargetFor(DragItemTypes.IMAGE)),
	      isDragging && React.createElement(Icon, { name: BUTTONS[type].icon,
	        size: isLast ? 'medium' : 'small',
	        mode: 'stroke' }),
	      !isDragging && React.createElement(
	        Button,
	        { size: isLast ? 'xlarge' : 'medium',
	          onClick: this.handleClick,
	          color: 'green',
	          fill: true,
	          round: !isDragging },
	        React.createElement(Icon, { name: BUTTONS[type].icon,
	          size: isLast ? 'medium' : 'small',
	          mode: 'stroke' })
	      ),
	      (isDragging || isLast) && React.createElement(
	        'span',
	        { className: 'editor-AddSectionButton-label' },
	        BUTTONS[type].title
	      )
	    );
	  },

	  handleClick: function handleClick() {
	    var _BUTTONS$props$type = BUTTONS[this.props.type];
	    var sectionType = _BUTTONS$props$type.sectionType;
	    var options = _BUTTONS$props$type.options;

	    this.props.onClick(sectionType, options);
	  }
	});

	module.exports = AddSectionButton;

/***/ },

/***/ 659:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var DraftActionCreators = __webpack_require__(33);
	var AddSectionButton = __webpack_require__(658);
	var PureRenderMixin = __webpack_require__(2);
	var DragItemTypes = __webpack_require__(85);
	var noop = __webpack_require__(220);
	var _require = __webpack_require__(74);

	var DragDropMixin = _require.DragDropMixin;var PropTypes = React.PropTypes;

	__webpack_require__(918);

	var AddSectionControl = React.createClass({
	  displayName: 'AddSectionControl',

	  mixins: [ClassNameMixin, DragDropMixin, PureRenderMixin],

	  className: 'editor-AddSectionControl',

	  propTypes: {
	    afterSectionId: PropTypes.string.isRequired,
	    isLast: PropTypes.bool
	  },

	  getInitialState: function getInitialState() {
	    return {
	      expanded: false,
	      expandedDrop: false
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.isLast && 'last'];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    var timeout;

	    registerType(DragItemTypes.IMAGE, {
	      dropTarget: {
	        getDropEffect: function getDropEffect() {
	          return null;
	        },

	        enter: function enter() {
	          var _this = this;

	          clearTimeout(timeout);
	          timeout = setTimeout(function () {
	            _this.setState({
	              expandedDrop: true
	            });
	          }, 100);
	        },

	        leave: function leave() {
	          clearTimeout(timeout);
	          this.setState({
	            expandedDrop: false
	          });
	        },

	        acceptDrop: function acceptDrop() {
	          this.setState({
	            expandedDrop: false
	          });
	        }
	      }
	    });
	  },

	  componentDidMount: function componentDidMount() {
	    document.body.addEventListener('click', this.handleBodyClick);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    document.body.removeEventListener('click', this.handleBodyClick);
	  },

	  render: function render() {
	    var _state = this.state;
	    var expanded = _state.expanded;
	    var expandedDrop = _state.expandedDrop;
	    var _getDropState = this.getDropState(DragItemTypes.IMAGE);

	    var isDragging = _getDropState.isDragging;

	    if (isDragging && this.props.isLast) {
	      expandedDrop = true;
	    }

	    return React.createElement(
	      'div',
	      _extends({ className: this.getClassName(),
	        'data-hint': isDragging
	      }, this.dropTargetFor(DragItemTypes.IMAGE)),
	      !expanded && !expandedDrop && this.renderPlusButton(),
	      expanded && !expandedDrop && this.renderSectionAddButtons(),
	      expandedDrop && this.renderSectionDropButtons()
	    );
	  },

	  renderPlusButton: function renderPlusButton() {
	    var isLast = this.props.isLast;

	    return React.createElement(
	      'div',
	      { className: 'editor-AddSectionControl-placeholder',
	        onClick: this.handleExpandClick },
	      React.createElement(
	        'div',
	        { className: 'editor-AddSectionControl-plus' },
	        React.createElement(
	          Button,
	          { onClick: this.handleExpandClick,
	            color: isLast ? 'green' : 'gray',
	            size: isLast ? 'xlarge' : 'small',
	            fill: isLast,
	            round: true },
	          React.createElement(Icon, { name: 'plus',
	            size: isLast ? 'medium' : 'xsmall',
	            mode: 'stroke' })
	        )
	      )
	    );
	  },

	  renderSectionAddButtons: function renderSectionAddButtons() {
	    var _this2 = this;

	    var isLast = this.props.isLast;

	    return ['text', 'poster', 'gallery', 'audio', 'video'].map(function (type) {
	      return React.createElement(AddSectionButton, { key: type,
	        type: type,
	        isLast: isLast,
	        onClick: _this2.handleSectionAddClick });
	    });
	  },

	  renderSectionDropButtons: function renderSectionDropButtons() {
	    var _this3 = this;

	    var isLast = this.props.isLast;

	    return ['poster', 'gallery'].map(function (type) {
	      return React.createElement(AddSectionButton, { key: type,
	        type: type,
	        isLast: isLast,
	        onClick: noop,
	        onDrop: _this3.handleSectionDrop });
	    });
	  },

	  handleBodyClick: function handleBodyClick() {
	    this.setState({
	      expanded: false
	    });
	  },

	  handleExpandClick: function handleExpandClick() {
	    this.setState({
	      expanded: true
	    });
	  },

	  handleSectionAddClick: function handleSectionAddClick(sectionType, options) {
	    this.setState({
	      expanded: false
	    });

	    DraftActionCreators.addSection(sectionType, this.props.afterSectionId, options);
	  },

	  handleSectionDrop: function handleSectionDrop(sectionType, options) {
	    this.setState({
	      expandedDrop: false
	    });

	    DraftActionCreators.addSection(sectionType, this.props.afterSectionId, options);
	  }
	});

	module.exports = AddSectionControl;

/***/ },

/***/ 660:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var _require = __webpack_require__(4);

	var flatten = _require.flatten;
	var findWhere = _require.findWhere;

	var pick = _require.pick;
	var ClassNameMixin = __webpack_require__(3);
	var EditorCover = __webpack_require__(663);
	var EditorGallery = __webpack_require__(664);
	var EditorPoster = __webpack_require__(667);
	var EditorText = __webpack_require__(668);
	var EditorMedia = __webpack_require__(666);
	var AddSectionControl = __webpack_require__(659);
	var AlertActionCreators = __webpack_require__(32);
	var AlertTypes = __webpack_require__(48);
	var DraftActionCreators = __webpack_require__(33);
	var Loader = __webpack_require__(43);
	var PureRenderMixin = __webpack_require__(2);
	var DragItemTypes = __webpack_require__(85);
	var SectionTypes = __webpack_require__(40);
	var getScrollY = __webpack_require__(82);
	var StampDraftStore = __webpack_require__(64);
	var _require2 = __webpack_require__(74);

	var DragDropMixin = _require2.DragDropMixin;var PropTypes = React.PropTypes;

	__webpack_require__(919);

	var Canvas = React.createClass({
	  displayName: 'Canvas',

	  mixins: [ClassNameMixin, DragDropMixin, PureRenderMixin],

	  className: 'editor-Canvas',

	  propTypes: {
	    draft: PropTypes.object
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    var imageThreshold = Math.max(120, window.innerHeight / 4),
	        sectionThreshold = Math.max(140, window.innerHeight / 4),
	        currentDY = 0,
	        frame;

	    function makeScrollingHandler(threshold) {
	      function getScrollDY(clientY) {
	        var speed;
	        if (clientY < threshold) {
	          // -1 to 0 as we move from 0 to threshold
	          speed = -1 + clientY / threshold;
	        } else if (clientY > window.innerHeight - threshold) {
	          // 0 to 1 as we move from (innerHeight - threshold) to innerHeight
	          speed = 1 - (window.innerHeight - clientY) / threshold;
	        } else {
	          speed = 0;
	        }

	        return Math.round(speed * 10);
	      }

	      function tick() {
	        if (!currentDY) {
	          frame = null;
	          return;
	        }

	        window.scrollTo(0, getScrollY() + currentDY);
	        frame = window.requestAnimationFrame(tick);
	      }

	      function queueScroll(dy) {
	        currentDY = dy;

	        if (!frame) {
	          frame = window.requestAnimationFrame(tick);
	        }
	      }

	      function cancelScroll() {
	        window.cancelAnimationFrame(frame);
	        frame = null;
	        currentDY = 0;
	      }

	      return {
	        dropTarget: {
	          enter: cancelScroll,
	          leave: cancelScroll,
	          acceptDrop: cancelScroll,

	          getDropEffect: function getDropEffect() {
	            return null;
	          },

	          over: function over(item, e) {
	            queueScroll(getScrollDY(e.clientY));
	          }
	        }
	      };
	    }

	    registerType(DragItemTypes.SECTION, makeScrollingHandler(sectionThreshold));
	    registerType(DragItemTypes.IMAGE, makeScrollingHandler(imageThreshold));
	  },

	  getSections: function getSections() {
	    return this.props.draft.content.sections;
	  },

	  render: function render() {
	    var draft = this.props.draft;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        _extends({ className: 'editor-Canvas-sections'
	        }, this.dropTargetFor(DragItemTypes.SECTION, DragItemTypes.IMAGE)),
	        draft ? flatten(this.getSections().map(this.renderSectionWithAddControl)) : React.createElement(Loader, { absoluteCenter: true })
	      )
	    );
	  },

	  renderSectionWithAddControl: function renderSectionWithAddControl(section, index) {
	    return [this.renderSection(section, index), React.createElement(AddSectionControl, { key: 'add-' + section.uuid,
	      afterSectionId: section.uuid,
	      isLast: index === this.getSections().length - 1 })];
	  },

	  renderSection: function renderSection(section, index) {
	    var props = this.getSectionProps(section, index);

	    switch (section.type) {
	      case SectionTypes.COVER:
	        return React.createElement(EditorCover, _extends({}, pick(props, 'index', 'uuid', 'key'), {
	          background: section.background,
	          title: section.title,
	          subtitle: section.subtitle }));
	      case SectionTypes.GALLERY:
	        return React.createElement(EditorGallery, _extends({}, props, {
	          images: section.images,
	          layout: section.layout }));
	      case SectionTypes.POSTER:
	        return React.createElement(EditorPoster, _extends({}, props, {
	          background: section.background,
	          caption: section.caption }));
	      case SectionTypes.TEXT:
	        return React.createElement(EditorText, _extends({}, props, {
	          text: section.text }));
	      case SectionTypes.MEDIA:
	        return React.createElement(EditorMedia, _extends({}, props, {
	          section: section }));
	    }
	  },

	  getSectionProps: function getSectionProps(section, index) {
	    var uuid = section.uuid,
	        isNew = StampDraftStore.isLastAddedItem();

	    return {
	      key: uuid,
	      uuid: uuid,
	      index: index,
	      isNew: isNew,
	      onDeleteClick: this.handleDeleteClick
	    };
	  },

	  handleDeleteClick: function handleDeleteClick(sectionKey, needConfirm) {
	    var section = findWhere(this.getSections(), { uuid: sectionKey });

	    if (needConfirm) {
	      AlertActionCreators.showAlert(AlertTypes.EDITOR_DELETE_SECTION, {
	        sectionId: section.uuid,
	        sectionType: section.type
	      });
	    } else {
	      DraftActionCreators.deleteSection(section.uuid);
	    }
	  }
	});

	module.exports = Canvas;

/***/ },

/***/ 661:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var PureRenderMixin = __webpack_require__(2);
	var Loader = __webpack_require__(43);
	var createFlexibleImageQueueMixin = __webpack_require__(96);
	var EditorAudioCover = __webpack_require__(662);var PropTypes = React.PropTypes;

	__webpack_require__(137);
	__webpack_require__(232);

	var EditorAudio = React.createClass({
	  displayName: 'EditorAudio',

	  mixins: [ClassNameMixin, PureRenderMixin, createFlexibleImageQueueMixin(1)],

	  propTypes: {
	    url: PropTypes.string.isRequired,
	    title: PropTypes.string.isRequired,
	    username: PropTypes.string.isRequired,
	    duration: PropTypes.number.isRequired,
	    tracks: PropTypes.arrayOf(PropTypes.object),
	    background: PropTypes.shape({
	      url: PropTypes.string.isRequired
	    }),
	    artwork: PropTypes.shape({
	      url: PropTypes.string.isRequired
	    }),
	    isBackgroundReady: PropTypes.bool.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.isBackgroundReady && 'ready'];
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.background,
	      mode: 'scale_crop',
	      blur: 20,
	      sizes: {
	        small: true,
	        normal: true
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.background !== this.props.background) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var isReady = this.props.isBackgroundReady;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      !isReady && React.createElement(Loader, { absoluteCenter: true }),
	      isReady && this.renderBackground(),
	      isReady && this.renderPlayer()
	    );
	  },

	  renderBackground: function renderBackground() {
	    var background = this.props.background;
	    var style;

	    if (background) {
	      style = {
	        backgroundImage: this.getBackgroundImageUrl()
	      };
	    }

	    return React.createElement(
	      'div',
	      { className: 'editor-Section-background', style: style },
	      this.renderLoaderImg()
	    );
	  },

	  renderPlayer: function renderPlayer() {
	    var _props = this.props;
	    var title = _props.title;
	    var username = _props.username;
	    var duration = _props.duration;
	    var tracks = _props.tracks;
	    var artwork = _props.artwork;

	    return React.createElement(
	      'div',
	      { className: 'EditorMedia-wrapper' },
	      React.createElement(EditorAudioCover, { tracks: tracks,
	        duration: duration,
	        artwork: artwork }),
	      React.createElement(
	        'div',
	        { className: 'EditorMedia-info' },
	        React.createElement(
	          'div',
	          { className: 'EditorMedia-title' },
	          title
	        ),
	        React.createElement(
	          'div',
	          { className: 'EditorMedia-author' },
	          username
	        )
	      )
	    );
	  }
	});

	module.exports = EditorAudio;

/***/ },

/***/ 662:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Icon = __webpack_require__(10);
	var pluralize = __webpack_require__(98);
	var formatTime = __webpack_require__(136);
	var PureRenderMixin = __webpack_require__(2);
	var createFlexibleImageQueueMixin = __webpack_require__(96);var PropTypes = React.PropTypes;

	__webpack_require__(232);

	var EditorAudioCover = React.createClass({
	  displayName: 'EditorAudioCover',

	  mixins: [PureRenderMixin, createFlexibleImageQueueMixin(1)],

	  propTypes: {
	    duration: PropTypes.number.isRequired,
	    tracks: PropTypes.arrayOf(PropTypes.object),
	    artwork: PropTypes.shape({
	      url: PropTypes.string.isRequired
	    }).isRequired
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.artwork,
	      mode: 'scale_crop',
	      sizes: {
	        thumb: true,
	        normal: true,
	        retina: window.devicePixelRatio > 1.5
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.artwork !== this.props.artwork) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var _props = this.props;
	    var duration = _props.duration;
	    var tracks = _props.tracks;

	    return React.createElement(
	      'div',
	      { className: 'EditorMedia-cover',
	        style: {
	          backgroundImage: this.getBackgroundImageUrl()
	        } },
	      this.renderLoaderImg(),
	      React.createElement(
	        'div',
	        { className: 'EditorMedia-badge' },
	        React.createElement(Icon, { className: 'EditorMedia-icon',
	          name: 'audio',
	          size: 'large',
	          mode: 'stroke' }),
	        React.createElement(
	          'div',
	          { className: 'EditorMedia-duration' },
	          formatTime(duration),
	          tracks && React.createElement(
	            'div',
	            { className: 'EditorMedia-trackCount' },
	            tracks.length + ' ' + pluralize(tracks.length, 'track', 'tracks')
	          )
	        )
	      )
	    );
	  }
	});

	module.exports = EditorAudioCover;

/***/ },

/***/ 663:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var getThumbnailUrl = __webpack_require__(37);
	var DraftActionCreators = __webpack_require__(33);
	var ContentEditable = __webpack_require__(250);
	var PureRenderMixin = __webpack_require__(2);
	var DragItemTypes = __webpack_require__(85);
	var ImageSizes = __webpack_require__(203);
	var createFlexibleImageQueueMixin = __webpack_require__(96);
	var _require = __webpack_require__(74);

	var DragDropMixin = _require.DragDropMixin;
	var ImagePreloaderMixin = _require.ImagePreloaderMixin;

	var DropEffects = _require.DropEffects;var PropTypes = React.PropTypes;

	__webpack_require__(137);

	var EditorCover = React.createClass({
	  displayName: 'EditorCover',

	  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, createFlexibleImageQueueMixin(1)],

	  className: 'editor-Section editor-Section--cover',

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    title: PropTypes.string.isRequired,
	    subtitle: PropTypes.string.isRequired,
	    background: PropTypes.object
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.background,
	      mode: 'scale_crop',
	      sizes: {
	        thumb: true,
	        normal: true,
	        retina: window.devicePixelRatio > 1.5
	      }
	    };
	  },

	  getBackgroundDragPreviewUrl: function getBackgroundDragPreviewUrl() {
	    if (!this.props.background) {
	      return;
	    }

	    var background = this.props.background,
	        scale = this.getDragImageScale();

	    return getThumbnailUrl(background, {
	      mode: 'preview',
	      width: Math.round(ImageSizes.EDITOR_COVER_DRAG.width * scale),
	      height: Math.round(ImageSizes.EDITOR_COVER_DRAG.height * scale)
	    });
	  },

	  getImageUrlsToPreload: function getImageUrlsToPreload() {
	    return [this.getBackgroundDragPreviewUrl()];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(DragItemTypes.IMAGE, {
	      dragSource: {
	        canDrag: function canDrag() {
	          return this.props.background && this.hasPreloadedImage(this.getBackgroundDragPreviewUrl());
	        },

	        beginDrag: function beginDrag() {
	          return {
	            effectsAllowed: [DropEffects.MOVE],
	            dragPreview: this.getPreloadedImage(this.getBackgroundDragPreviewUrl()),
	            item: {
	              image: this.props.background
	            }
	          };
	        },

	        endDrag: function endDrag(dropEffect) {
	          if (dropEffect === DropEffects.MOVE && this.props.background !== null) {
	            DraftActionCreators.updateSection(this.props.uuid, {
	              background: null
	            });
	          }
	        }
	      },

	      dropTarget: {
	        acceptDrop: function acceptDrop(item) {
	          if (this.props.background !== item.image) {
	            DraftActionCreators.updateSection(this.props.uuid, {
	              background: item.image
	            });
	          }
	        }
	      }
	    });
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.background !== this.props.background) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var backgroundStyle = {},
	        dropImageState = this.getDropState(DragItemTypes.IMAGE),
	        dragImageState = this.getDragState(DragItemTypes.IMAGE),
	        showBackground = this.props.background && !dragImageState.isDragging,
	        dragSource = this.state.isBackgroundDraggingDisabled ? {} : this.dragSourceFor(DragItemTypes.IMAGE);

	    if (showBackground) {
	      backgroundStyle.backgroundImage = this.getBackgroundImageUrl();
	    }

	    return React.createElement(
	      'div',
	      _extends({ className: this.getClassName(),
	        'data-state': showBackground ? 'background' : 'empty',
	        'data-hint': dropImageState.isDragging,
	        'data-hover': dropImageState.isHovering
	      }, this.dropTargetFor(DragItemTypes.IMAGE), dragSource),
	      this.renderLoaderImg(),
	      React.createElement(
	        'div',
	        { className: 'editor-Section-topBar' },
	        React.createElement(
	          'div',
	          { className: 'editor-Section-type' },
	          React.createElement(Icon, { name: 'poster', size: 'small', mode: 'stroke' }),
	          React.createElement(
	            'span',
	            { className: 'editor-Section-typeTitle' },
	            'Cover'
	          )
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'editor-SectionHint' },
	        React.createElement(
	          'div',
	          { className: 'editor-SectionHint-box' },
	          React.createElement(Icon, { name: 'image', size: 'medium', mode: 'stroke' }),
	          React.createElement('p', { className: 'editor-SectionHint-message utils--smallCaps' })
	        )
	      ),
	      showBackground && React.createElement('div', _extends({ className: 'editor-Section-background',
	        style: backgroundStyle
	      }, dragSource)),
	      React.createElement(
	        'div',
	        { className: 'editor-Section-wrapperBox' },
	        showBackground && React.createElement(
	          'div',
	          { className: 'editor-Section-deleteBackground',
	            title: 'Remove background image' },
	          React.createElement(Icon, { name: 'cross', size: 'xsmall', mode: 'stroke', onClick: this.removeBackground })
	        ),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-hgroup' },
	          React.createElement(ContentEditable, { className: 'editor-Section-title',
	            component: 'h1',
	            placeholder: 'Title',
	            text: this.props.title,
	            onChange: this.handleTitleChange,
	            maxLength: 80,
	            editable: true,
	            onMouseEnter: this.handleEditableEnter,
	            onMouseLeave: this.handleEditableLeave }),
	          React.createElement(ContentEditable, { className: 'editor-Section-subtitle',
	            component: 'h2',
	            placeholder: 'Subtitle (optional)',
	            text: this.props.subtitle,
	            onChange: this.handleSubtitleChange,
	            maxLength: 140,
	            editable: true,
	            onMouseEnter: this.handleEditableEnter,
	            onMouseLeave: this.handleEditableLeave })
	        )
	      )
	    );
	  },

	  handleEditableEnter: function handleEditableEnter() {
	    // This fix removes conflict between contentEditable and draggable elements in some browsers
	    // (I'm not pointing fingers but it was IE)
	    // Without this fix, draggable element can prevent focusing in contentEditable.

	    this.setState({ isBackgroundDraggingDisabled: true });
	  },

	  handleEditableLeave: function handleEditableLeave() {
	    this.setState({ isBackgroundDraggingDisabled: false });
	  },

	  handleTitleChange: function handleTitleChange(textContent) {
	    if (this.props.title === textContent) {
	      return;
	    }

	    DraftActionCreators.updateSection(this.props.uuid, {
	      title: textContent
	    });
	  },

	  handleSubtitleChange: function handleSubtitleChange(textContent) {
	    if (this.props.subtitle === textContent) {
	      return;
	    }

	    DraftActionCreators.updateSection(this.props.uuid, {
	      subtitle: textContent
	    });
	  },

	  removeBackground: function removeBackground() {
	    if (this.props.background === null) {
	      return;
	    }

	    DraftActionCreators.updateSection(this.props.uuid, {
	      background: null
	    });
	  }
	});

	module.exports = EditorCover;

/***/ },

/***/ 664:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var EditorGalleryImage = __webpack_require__(665);
	var GalleryLayouts = __webpack_require__(202);
	var DraftActionCreators = __webpack_require__(33);
	var EditorSectionMixin = __webpack_require__(204);
	var PureRenderMixin = __webpack_require__(2);
	var DragItemTypes = __webpack_require__(85);
	var StampDraftStore = __webpack_require__(64);
	var EditorDragImages = __webpack_require__(200);
	var getThumbnailUrl = __webpack_require__(37);
	var _require = __webpack_require__(74);

	var DragDropMixin = _require.DragDropMixin;

	var ImagePreloaderMixin = _require.ImagePreloaderMixin;var PropTypes = React.PropTypes;

	__webpack_require__(137);

	var MAX_IMAGES = 10;

	var EditorGallery = React.createClass({
	  displayName: 'EditorGallery',

	  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, EditorSectionMixin],

	  className: 'editor-Section editor-Section--gallery',

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    images: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
	    layout: PropTypes.string.isRequired,
	    onDeleteClick: PropTypes.func.isRequired,
	    isNew: PropTypes.bool
	  },

	  isEmpty: function isEmpty() {
	    return !this.props.images.length;
	  },

	  getGalleryState: function getGalleryState() {
	    if (this.isEmpty()) {
	      return 'empty';
	    } else if (this.props.images.length >= MAX_IMAGES) {
	      return 'full';
	    } else {
	      return 'images';
	    }
	  },

	  getSectionDragPreviewUrl: function getSectionDragPreviewUrl() {
	    var scale = this.getDragImageScale(),
	        image = EditorDragImages.GALLERY;

	    return getThumbnailUrl(image, {
	      mode: 'preview',
	      width: Math.round(image.size.width / image.intendedScale * scale),
	      height: Math.round(image.size.height / image.intendedScale * scale)
	    });
	  },

	  getImageUrlsToPreload: function getImageUrlsToPreload() {
	    return [this.getSectionDragPreviewUrl()];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(DragItemTypes.SECTION, {
	      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
	      dropTarget: this.getSectionDropTarget()
	    });

	    registerType(DragItemTypes.IMAGE, {
	      dropTarget: {
	        getDropEffect: function getDropEffect(allowedEffects) {
	          if (this.props.images.length >= MAX_IMAGES) {
	            return null;
	          } else {
	            return allowedEffects[0];
	          }
	        },

	        canDrop: function canDrop(item) {
	          return item.galleryId !== this.props.uuid;
	        },

	        acceptDrop: function acceptDrop(item) {
	          if (this.props.images.length < MAX_IMAGES) {
	            DraftActionCreators.addGalleryImage(this.props.uuid, item.image);
	          }
	        }
	      }
	    });
	  },

	  componentDidMount: function componentDidMount() {
	    if (this.props.isNew) {
	      this.getDOMNode().scrollIntoViewIfNeeded();

	      DraftActionCreators.resetLastAddedItem();
	    }
	  },

	  render: function render() {
	    var sectionDragState = this.getDragState(DragItemTypes.SECTION),
	        imageDropState = this.getDropState(DragItemTypes.IMAGE);

	    return React.createElement(
	      'div',
	      _extends({ className: this.getClassName(),
	        'data-state': this.getGalleryState(),
	        'data-hover': imageDropState.isHovering,
	        'data-hint': imageDropState.isDragging,
	        'data-dragging': sectionDragState.isDragging
	      }, this.dropTargetFor(DragItemTypes.IMAGE, DragItemTypes.SECTION)),
	      React.createElement(
	        'div',
	        _extends({ className: 'editor-Section-topBar'
	        }, this.dragSourceFor(DragItemTypes.SECTION)),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-type' },
	          React.createElement(Icon, { name: 'set', size: 'small', mode: 'stroke' }),
	          React.createElement(
	            'span',
	            { className: 'editor-Section-typeTitle' },
	            'Set'
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-options' },
	          React.createElement(
	            'a',
	            { className: 'editor-Section-layoutSwitch',
	              title: 'Display as List',
	              'data-active': this.props.layout === 'list',
	              onClick: this.handleListClick },
	            React.createElement(Icon, { name: 'list', size: 'small', mode: 'stroke' }),
	            React.createElement(
	              'span',
	              { className: 'editor-Section-layoutTitle' },
	              'List'
	            )
	          ),
	          React.createElement(
	            'a',
	            { className: 'editor-Section-layoutSwitch',
	              title: 'Display as Grid',
	              'data-active': this.props.layout === 'grid',
	              onClick: this.handleGridClick },
	            React.createElement(Icon, { name: 'grid', size: 'small', mode: 'stroke' }),
	            React.createElement(
	              'span',
	              { className: 'editor-Section-layoutTitle' },
	              'Grid'
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-delete',
	            onClick: this.handleDeleteClick },
	          React.createElement(Icon, { name: 'cross', size: 'xsmall', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'editor-SectionHint' },
	        React.createElement(
	          'div',
	          { className: 'editor-SectionHint-box' },
	          React.createElement('p', { className: 'editor-SectionHint-message utils--smallCaps' })
	        )
	      ),
	      !this.isEmpty() && React.createElement(
	        'div',
	        { className: 'editor-Section-images' },
	        this.props.images.map(this.renderGalleryItem)
	      )
	    );
	  },

	  renderGalleryItem: function renderGalleryItem(image) {
	    var isNew = StampDraftStore.isLastAddedItem(image.uuid);

	    return React.createElement(EditorGalleryImage, { key: image.uuid,
	      image: image,
	      isNew: isNew,
	      galleryId: this.props.uuid,
	      onDeleteClick: this.handleImageDeleteClick,
	      onDropToOtherSection: this.handleImageDropToOtherSection });
	  },

	  handleListClick: function handleListClick() {
	    DraftActionCreators.updateSection(this.props.uuid, {
	      layout: GalleryLayouts.LIST
	    });
	  },

	  handleGridClick: function handleGridClick() {
	    DraftActionCreators.updateSection(this.props.uuid, {
	      layout: GalleryLayouts.GRID
	    });
	  },

	  handleImageDeleteClick: function handleImageDeleteClick(imageKey) {
	    DraftActionCreators.deleteGalleryImage(this.props.uuid, imageKey);
	  },

	  handleImageDropToOtherSection: function handleImageDropToOtherSection(imageKey) {
	    if (this.props.images.length > 1) {
	      DraftActionCreators.deleteGalleryImage(this.props.uuid, imageKey);
	    } else {
	      DraftActionCreators.deleteSection(this.props.uuid);
	    }
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    this.props.onDeleteClick(this.props.uuid, this.props.images.length > 0);
	  }
	});

	module.exports = EditorGallery;

/***/ },

/***/ 665:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var getThumbnailUrl = __webpack_require__(37);
	var DragItemTypes = __webpack_require__(85);
	var DraftActionCreators = __webpack_require__(33);
	var PureRenderMixin = __webpack_require__(2);
	var ImageCaption = __webpack_require__(401);
	var ImageSizes = __webpack_require__(203);
	var createFlexibleImageQueueMixin = __webpack_require__(96);
	var update = __webpack_require__(49);
	var _require = __webpack_require__(74);

	var DragDropMixin = _require.DragDropMixin;
	var ImagePreloaderMixin = _require.ImagePreloaderMixin;

	var DropEffects = _require.DropEffects;var PropTypes = React.PropTypes;

	__webpack_require__(920);

	var EditorGalleryImage = React.createClass({
	  displayName: 'EditorGalleryImage',

	  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, createFlexibleImageQueueMixin(1)],

	  className: 'editor-GalleryImage',

	  propTypes: {
	    galleryId: PropTypes.any.isRequired,
	    image: PropTypes.object.isRequired,
	    isNew: PropTypes.bool,
	    onDeleteClick: PropTypes.func.isRequired,
	    onDropToOtherSection: PropTypes.func.isRequired
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.image,
	      mode: 'scale_crop',
	      sizes: {
	        thumb: true,
	        normal: true,
	        retina: window.devicePixelRatio > 1.5
	      }
	    };
	  },

	  getImageDragPreviewUrl: function getImageDragPreviewUrl() {
	    var image = this.props.image,
	        scale = this.getDragImageScale();

	    return getThumbnailUrl(image, {
	      mode: 'preview',
	      width: Math.round(ImageSizes.EDITOR_GALLERY_IMAGE_DRAG.width * scale),
	      height: Math.round(ImageSizes.EDITOR_GALLERY_IMAGE_DRAG.height * scale)
	    });
	  },

	  getImageUrlsToPreload: function getImageUrlsToPreload() {
	    return [this.getImageDragPreviewUrl()];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(DragItemTypes.IMAGE, {
	      dragSource: {
	        canDrag: function canDrag() {
	          return this.hasPreloadedImage(this.getImageDragPreviewUrl());
	        },

	        beginDrag: function beginDrag() {
	          return {
	            effectsAllowed: [DropEffects.MOVE],
	            dragPreview: this.getPreloadedImage(this.getImageDragPreviewUrl()),
	            item: {
	              image: this.props.image,
	              galleryId: this.props.galleryId
	            }
	          };
	        },

	        endDrag: function endDrag(dropEffect) {
	          if (dropEffect === DropEffects.MOVE) {
	            this.props.onDropToOtherSection(this.props.image.uuid);
	          }
	        }
	      },

	      dropTarget: {
	        canDrop: function canDrop(item) {
	          return item.galleryId === this.props.galleryId;
	        },

	        over: function over(item) {
	          var draggedImageId = item.image.uuid,
	              overImageId = this.props.image.uuid;

	          if (draggedImageId === overImageId) {
	            return;
	          }

	          DraftActionCreators.moveGalleryImage(this.props.galleryId, draggedImageId, overImageId);
	        }
	      }
	    });
	  },

	  componentDidMount: function componentDidMount() {
	    if (this.props.isNew) {
	      this.getDOMNode().scrollIntoViewIfNeeded();
	      DraftActionCreators.resetLastAddedItem();
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.image !== this.props.image) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var caption = this.props.image.caption;

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        'data-dragging': this.getDragState(DragItemTypes.IMAGE).isDragging },
	      React.createElement(
	        'div',
	        _extends({ className: 'editor-GalleryImage-image',
	          style: { backgroundImage: this.getBackgroundImageUrl() },
	          'data-dragging': this.getDragState(DragItemTypes.IMAGE).isDragging
	        }, this.dragSourceFor(DragItemTypes.IMAGE), this.dropTargetFor(DragItemTypes.IMAGE)),
	        this.renderLoaderImg()
	      ),
	      React.createElement(
	        Button,
	        { size: 'xsmall',
	          round: true,
	          overlay: true,
	          color: 'black',
	          className: 'editor-GalleryImage-delete',
	          onClick: this.handleDeleteClick },
	        React.createElement(Icon, { name: 'cross',
	          size: 'xxsmall',
	          mode: 'stroke' })
	      ),
	      React.createElement(ImageCaption, { text: caption,
	        onChange: this.handleCaptionChange })
	    );
	  },

	  handleCaptionChange: function handleCaptionChange(textContent) {
	    var imageUpdate = update(this.props.image, {
	      caption: { $set: textContent }
	    });

	    if (this.props.image.caption === textContent) {
	      return;
	    }

	    DraftActionCreators.updateGalleryImage(this.props.galleryId, this.props.image.uuid, imageUpdate);
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    this.props.onDeleteClick(this.props.image.uuid);
	  }
	});

	module.exports = EditorGalleryImage;

/***/ },

/***/ 666:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _actionsMediaActionCreators = __webpack_require__(557);

	var _actionsMediaActionCreators2 = _interopRequireDefault(_actionsMediaActionCreators);

	var _constantsMediaTypes = __webpack_require__(70);

	var _constantsMediaTypes2 = _interopRequireDefault(_constantsMediaTypes);

	var _constantsKeyCodes = __webpack_require__(145);

	var _constantsKeyCodes2 = _interopRequireDefault(_constantsKeyCodes);

	var _constantsDragItemTypes = __webpack_require__(85);

	var _constantsDragItemTypes2 = _interopRequireDefault(_constantsDragItemTypes);

	var _mixinsEditorSectionMixin = __webpack_require__(204);

	var _mixinsEditorSectionMixin2 = _interopRequireDefault(_mixinsEditorSectionMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _storesStampDraftStore = __webpack_require__(64);

	var _storesStampDraftStore2 = _interopRequireDefault(_storesStampDraftStore);

	var _EditorVideo = __webpack_require__(669);

	var _EditorVideo2 = _interopRequireDefault(_EditorVideo);

	var _EditorAudio = __webpack_require__(661);

	var _EditorAudio2 = _interopRequireDefault(_EditorAudio);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _atomsLoader = __webpack_require__(43);

	var _atomsLoader2 = _interopRequireDefault(_atomsLoader);

	var _actionsDraftActionCreators = __webpack_require__(33);

	var _actionsDraftActionCreators2 = _interopRequireDefault(_actionsDraftActionCreators);

	var _constantsDefaultAudioImage = __webpack_require__(144);

	var _constantsDefaultAudioImage2 = _interopRequireDefault(_constantsDefaultAudioImage);

	var _constantsEditorDragImages = __webpack_require__(200);

	var _constantsEditorDragImages2 = _interopRequireDefault(_constantsEditorDragImages);

	var _utilsGetThumbnailUrl = __webpack_require__(37);

	var _utilsGetThumbnailUrl2 = _interopRequireDefault(_utilsGetThumbnailUrl);

	var _reactDnd = __webpack_require__(74);

	var _underscore = __webpack_require__(4);

	var _utilsNormalizeUrl = __webpack_require__(451);

	var _utilsNormalizeUrl2 = _interopRequireDefault(_utilsNormalizeUrl);

	__webpack_require__(137);

	__webpack_require__(232);

	'use strict';

	var VIMEO_URL_RE = /^(?:https?:\/\/)?vimeo.com\/(?:.*\/)?(\d+)(?:[\?#].*)?\/?$/i,
	    SOUNDCLOUD_URL_RE = /^((?:https?:\/\/)?soundcloud.com\/[^\?#]*)(?:[\?#].*)?\/?$/i;

	var EditorMedia = _react2['default'].createClass({
	  displayName: 'EditorMedia',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default'], _reactDnd.DragDropMixin, _reactDnd.ImagePreloaderMixin, _mixinsEditorSectionMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesStampDraftStore2['default'])],

	  className: 'editor-Section editor-Section--media',

	  propTypes: {
	    uuid: _react.PropTypes.string.isRequired,
	    section: _react.PropTypes.shape({
	      url: _react.PropTypes.string,
	      mediaType: _react.PropTypes.oneOf([_constantsMediaTypes2['default'].VIDEO, _constantsMediaTypes2['default'].AUDIO_TRACK, _constantsMediaTypes2['default'].AUDIO_PLAYLIST]),
	      background: _react.PropTypes.object
	    }).isRequired,
	    onDeleteClick: _react.PropTypes.func.isRequired,
	    isNew: _react.PropTypes.bool
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      isLoadingMedia: _storesStampDraftStore2['default'].isLoadingMedia(this.props.section.uuid),
	      isLoadingMediaBackground: _storesStampDraftStore2['default'].isLoadingMediaBackground(this.props.section.uuid)
	    };
	  },

	  getSectionDragPreviewUrl: function getSectionDragPreviewUrl() {
	    var scale = this.getDragImageScale(),
	        image;

	    switch (this.props.section.mediaType) {
	      case _constantsMediaTypes2['default'].AUDIO_TRACK:
	      case _constantsMediaTypes2['default'].AUDIO_PLAYLIST:
	        image = _constantsEditorDragImages2['default'].AUDIO;
	        break;
	      case _constantsMediaTypes2['default'].VIDEO:
	        image = _constantsEditorDragImages2['default'].VIDEO;
	        break;
	    }

	    return (0, _utilsGetThumbnailUrl2['default'])(image, {
	      mode: 'preview',
	      width: Math.round(image.size.width / image.intendedScale * scale),
	      height: Math.round(image.size.height / image.intendedScale * scale)
	    });
	  },

	  getImageUrlsToPreload: function getImageUrlsToPreload() {
	    return [this.getSectionDragPreviewUrl()];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(_constantsDragItemTypes2['default'].SECTION, {
	      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
	      dropTarget: this.getSectionDropTarget()
	    });
	  },

	  componentDidMount: function componentDidMount() {
	    if (this.props.isNew) {
	      this.getDOMNode().scrollIntoViewIfNeeded();
	      if (this.refs.input) {
	        this.refs.input.getDOMNode().focus();
	      }

	      _actionsDraftActionCreators2['default'].resetLastAddedItem();
	    }
	  },

	  render: function render() {
	    var dragSectionState = this.getDragState(_constantsDragItemTypes2['default'].SECTION);

	    return _react2['default'].createElement(
	      'div',
	      _extends({ className: this.getClassName(),
	        'data-state': this.props.section.background ? 'background' : 'empty',
	        'data-dragging': dragSectionState.isDragging
	      }, this.dropTargetFor(_constantsDragItemTypes2['default'].SECTION)),
	      _react2['default'].createElement(
	        'div',
	        _extends({ className: 'editor-Section-topBar'
	        }, this.dragSourceFor(_constantsDragItemTypes2['default'].SECTION)),
	        this.renderSectionType(),
	        _react2['default'].createElement(
	          'div',
	          { className: 'editor-Section-delete',
	            onClick: this.handleDeleteClick },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'cross', size: 'xsmall', mode: 'stroke' })
	        )
	      ),
	      this.props.section.url ? this.renderMedia() : this.renderInput()
	    );
	  },

	  renderSectionType: function renderSectionType() {
	    switch (this.props.section.mediaType) {
	      case _constantsMediaTypes2['default'].VIDEO:
	        return _react2['default'].createElement(
	          'div',
	          { className: 'editor-Section-type' },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'video', size: 'small', mode: 'stroke' }),
	          _react2['default'].createElement(
	            'span',
	            { className: 'editor-Section-typeTitle' },
	            'Video'
	          )
	        );

	      case _constantsMediaTypes2['default'].AUDIO_TRACK:
	      case _constantsMediaTypes2['default'].AUDIO_PLAYLIST:
	        return _react2['default'].createElement(
	          'div',
	          { className: 'editor-Section-type' },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'audio', size: 'small', mode: 'stroke' }),
	          _react2['default'].createElement(
	            'span',
	            { className: 'editor-Section-typeTitle' },
	            'Audio'
	          )
	        );
	    }
	  },

	  renderMedia: function renderMedia() {
	    var _props$section = this.props.section;
	    var background = _props$section.background;
	    var url = _props$section.url;
	    var title = _props$section.title;
	    var username = _props$section.username;
	    var duration = _props$section.duration;
	    var tracks = _props$section.tracks;
	    var mediaType = _props$section.mediaType;
	    var artwork = _props$section.artwork;var _state = this.state;
	    var isLoadingMedia = _state.isLoadingMedia;

	    var isLoadingMediaBackground = _state.isLoadingMediaBackground;
	    var isBackgroundReady = !isLoadingMedia && !isLoadingMediaBackground;

	    switch (mediaType) {
	      case _constantsMediaTypes2['default'].VIDEO:
	        return _react2['default'].createElement(_EditorVideo2['default'], { title: title,
	          username: username,
	          duration: duration,
	          background: background,
	          url: url,
	          isBackgroundReady: isBackgroundReady,
	          absoluteCenter: true });

	      case _constantsMediaTypes2['default'].AUDIO_TRACK:
	        return _react2['default'].createElement(_EditorAudio2['default'], { title: title,
	          username: username,
	          duration: duration,
	          background: background,
	          artwork: artwork || isBackgroundReady && _constantsDefaultAudioImage2['default'],
	          url: url,
	          isBackgroundReady: isBackgroundReady,
	          absoluteCenter: true });

	      case _constantsMediaTypes2['default'].AUDIO_PLAYLIST:
	        artwork = artwork || ((0, _underscore.find)(tracks, function (track) {
	          return !!track.artwork;
	        }) || {}).artwork;
	        return _react2['default'].createElement(_EditorAudio2['default'], { title: title,
	          username: username,
	          duration: duration,
	          tracks: tracks,
	          background: background,
	          artwork: artwork || isBackgroundReady && _constantsDefaultAudioImage2['default'],
	          url: url,
	          isBackgroundReady: isBackgroundReady,
	          absoluteCenter: true });
	    }
	  },

	  renderInput: function renderInput() {
	    var isValidMediaUrl = this.state.isValidMediaUrl;
	    var placeholder;
	    var caption;
	    var logo;

	    switch (this.props.section.mediaType) {
	      case _constantsMediaTypes2['default'].VIDEO:
	        caption = 'Insert video URL from Vimeo.';
	        placeholder = 'http://vimeo.com/example';
	        logo = '//stampsy-eu-1.s3.amazonaws.com/2014/10/31/media/vimeo-logo--dark.svg';
	        break;

	      case _constantsMediaTypes2['default'].AUDIO_TRACK:
	      case _constantsMediaTypes2['default'].AUDIO_PLAYLIST:
	        caption = 'Insert audio track or playlist URL from Soundcloud.';
	        placeholder = 'http://soundcloud.com/example';
	        logo = '//stampsy-eu-1.s3.amazonaws.com/2014/10/31/media/soundcloud-logo--dark.svg';
	        break;
	    }

	    if (this.state.isLoadingMedia) {
	      return _react2['default'].createElement(_atomsLoader2['default'], { absoluteCenter: true });
	    }

	    return _react2['default'].createElement(
	      'div',
	      { className: 'editor-Section-wrapperBox' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'editor-Section-embedLogo' },
	        _react2['default'].createElement('img', { className: 'editor-Section-embedLogoImage', src: logo })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'editor-Section-embedCaption' },
	        caption
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'editor-Section-embedForm' },
	        _react2['default'].createElement('input', { ref: 'input',
	          className: 'editor-Section-embedInput',
	          readOnly: this.state.isLoadingMedia,
	          onKeyDown: this.handleInputKeyDown,
	          placeholder: placeholder,
	          onChange: this.handleChange }),
	        _react2['default'].createElement(
	          _atomsButton2['default'],
	          { className: 'editor-Section-embedSubmit',
	            onClick: this.submitUrl,
	            color: 'green',
	            size: 'large',
	            disabled: !isValidMediaUrl },
	          'Embed'
	        )
	      )
	    );
	  },

	  isValidMediaUrl: function isValidMediaUrl(url) {
	    var match = url.trim().match(VIMEO_URL_RE),
	        mediaType = this.props.section.mediaType;

	    if (match && mediaType === _constantsMediaTypes2['default'].VIDEO) {
	      return true;
	    }

	    match = url.trim().match(SOUNDCLOUD_URL_RE);
	    if (match && mediaType === _constantsMediaTypes2['default'].AUDIO_TRACK) {
	      return true;
	    }
	  },

	  handleChange: function handleChange(e) {
	    var url = e.target.value;
	    this.setState({
	      url: url,
	      isValidMediaUrl: url && this.isValidMediaUrl(url)
	    });
	  },

	  handleInputKeyDown: function handleInputKeyDown(e) {
	    if (e.which !== _constantsKeyCodes2['default'].ENTER) {
	      return;
	    }

	    this.submitUrl();
	  },

	  submitUrl: function submitUrl() {
	    var url = this.state.url,
	        section = this.props.section;

	    if (this.isValidMediaUrl(url)) {
	      url = (0, _utilsNormalizeUrl2['default'])(url.toLowerCase());

	      if (url[url.length - 1] === '/') {
	        url = url.slice(0, -1);
	      }

	      _actionsMediaActionCreators2['default'].requestMediaData(section.uuid, url);
	    }
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    var section = this.props.section;
	    this.props.onDeleteClick(section.uuid, section.url && section.url.length > 0);
	  } });

	exports['default'] = EditorMedia;
	module.exports = exports['default'];

/***/ },

/***/ 667:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var getThumbnailUrl = __webpack_require__(37);
	var DraftActionCreators = __webpack_require__(33);
	var DragItemTypes = __webpack_require__(85);
	var EditorSectionMixin = __webpack_require__(204);
	var DraftActionCreators = __webpack_require__(33);
	var PureRenderMixin = __webpack_require__(2);
	var ImageCaption = __webpack_require__(401);
	var ImageSizes = __webpack_require__(203);
	var EditorDragImages = __webpack_require__(200);
	var getThumbnailUrl = __webpack_require__(37);
	var createFlexibleImageQueueMixin = __webpack_require__(96);
	var update = __webpack_require__(49);
	var _require = __webpack_require__(74);

	var DragDropMixin = _require.DragDropMixin;
	var ImagePreloaderMixin = _require.ImagePreloaderMixin;

	var DropEffects = _require.DropEffects;var PropTypes = React.PropTypes;

	__webpack_require__(137);

	var EditorPoster = React.createClass({
	  displayName: 'EditorPoster',

	  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, EditorSectionMixin, createFlexibleImageQueueMixin(1)],

	  className: 'editor-Section editor-Section--poster',

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    background: PropTypes.object,
	    onDeleteClick: PropTypes.func.isRequired,
	    isNew: PropTypes.bool
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.background,
	      mode: 'scale_crop',
	      sizes: {
	        thumb: true,
	        normal: true,
	        retina: window.devicePixelRatio > 1.5
	      }
	    };
	  },

	  getBackgroundDragPreviewUrl: function getBackgroundDragPreviewUrl() {
	    if (!this.props.background) {
	      return;
	    }

	    var background = this.props.background,
	        scale = this.getDragImageScale();

	    return getThumbnailUrl(background, {
	      mode: 'preview',
	      width: Math.round(ImageSizes.EDITOR_POSTER_DRAG.width * scale),
	      height: Math.round(ImageSizes.EDITOR_POSTER_DRAG.height * scale)
	    });
	  },

	  getSectionDragPreviewUrl: function getSectionDragPreviewUrl() {
	    var scale = this.getDragImageScale(),
	        image = EditorDragImages.POSTER;

	    return getThumbnailUrl(image, {
	      mode: 'preview',
	      width: Math.round(image.size.width / image.intendedScale * scale),
	      height: Math.round(image.size.height / image.intendedScale * scale)
	    });
	  },

	  getImageUrlsToPreload: function getImageUrlsToPreload() {
	    return [this.getSectionDragPreviewUrl(), this.getBackgroundDragPreviewUrl()];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(DragItemTypes.SECTION, {
	      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
	      dropTarget: this.getSectionDropTarget()
	    });

	    registerType(DragItemTypes.IMAGE, {
	      dragSource: {
	        canDrag: function canDrag() {
	          return this.props.background && this.hasPreloadedImage(this.getBackgroundDragPreviewUrl());
	        },

	        beginDrag: function beginDrag() {
	          return {
	            effectsAllowed: [DropEffects.MOVE],
	            dragPreview: this.getPreloadedImage(this.getBackgroundDragPreviewUrl()),
	            item: {
	              image: this.props.background
	            }
	          };
	        },

	        endDrag: function endDrag(dropEffect) {
	          if (dropEffect === DropEffects.MOVE) {
	            DraftActionCreators.deleteSection(this.props.uuid);
	          }
	        }
	      },

	      dropTarget: {
	        acceptDrop: function acceptDrop(item) {
	          DraftActionCreators.updateSection(this.props.uuid, {
	            background: item.image
	          });
	        }
	      }
	    });
	  },

	  componentDidMount: function componentDidMount() {
	    if (this.props.isNew) {
	      this.getDOMNode().scrollIntoViewIfNeeded();

	      DraftActionCreators.resetLastAddedItem();
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.background !== this.props.background) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var backgroundStyle = {},
	        sectionDragState = this.getDragState(DragItemTypes.SECTION),
	        imageDragState = this.getDragState(DragItemTypes.IMAGE),
	        imageDropState = this.getDropState(DragItemTypes.IMAGE),
	        showBackground = this.props.background && !imageDragState.isDragging,
	        caption;

	    if (showBackground) {
	      caption = this.props.background.caption;
	      backgroundStyle.backgroundImage = this.getBackgroundImageUrl();
	    }

	    return React.createElement(
	      'div',
	      _extends({ className: this.getClassName(),
	        'data-state': showBackground ? 'background' : 'empty',
	        'data-dragging': sectionDragState.isDragging,
	        'data-hint': imageDropState.isDragging,
	        'data-hover': imageDropState.isHovering
	      }, this.dropTargetFor(DragItemTypes.IMAGE, DragItemTypes.SECTION)),
	      this.renderLoaderImg(),
	      React.createElement(
	        'div',
	        _extends({ className: 'editor-Section-topBar'
	        }, this.dragSourceFor(DragItemTypes.SECTION)),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-type' },
	          React.createElement(Icon, { name: 'poster', size: 'small', mode: 'stroke' }),
	          React.createElement(
	            'span',
	            { className: 'editor-Section-typeTitle' },
	            'Fullscreen'
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-delete',
	            onClick: this.handleDeleteClick },
	          React.createElement(Icon, { name: 'cross', size: 'xsmall', mode: 'stroke' })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'editor-SectionHint' },
	        React.createElement(
	          'div',
	          { className: 'editor-SectionHint-box' },
	          React.createElement('p', { className: 'editor-SectionHint-message utils--smallCaps' })
	        )
	      ),
	      showBackground && React.createElement(
	        'div',
	        null,
	        React.createElement('div', _extends({ className: 'editor-Section-background',
	          style: backgroundStyle
	        }, this.dragSourceFor(DragItemTypes.IMAGE))),
	        React.createElement(ImageCaption, { text: caption,
	          onChange: this.handleCaptionChange })
	      )
	    );
	  },

	  handeCaptionFocus: function handeCaptionFocus() {
	    this.setState({ isCaptionActive: true });
	  },

	  handeCaptionBlur: function handeCaptionBlur() {
	    this.setState({ isCaptionActive: false });
	  },

	  handleCaptionChange: function handleCaptionChange(textContent) {
	    var background = update(this.props.background, {
	      caption: { $set: textContent }
	    });

	    if (this.props.background.caption === textContent) {
	      return;
	    }

	    DraftActionCreators.updateSection(this.props.uuid, {
	      background: background
	    });
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    this.props.onDeleteClick(this.props.uuid, !!this.props.background);
	  }
	});

	module.exports = EditorPoster;

/***/ },

/***/ 668:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var MediumEditor = __webpack_require__(1046);
	var DraftActionCreators = __webpack_require__(33);
	var EditorSectionMixin = __webpack_require__(204);
	var PureRenderMixin = __webpack_require__(2);
	var DragItemTypes = __webpack_require__(85);
	var EditorDragImages = __webpack_require__(200);
	var getThumbnailUrl = __webpack_require__(37);
	var _require = __webpack_require__(36);

	var isIE = _require.isIE;
	var _require2 = __webpack_require__(74);

	var DragDropMixin = _require2.DragDropMixin;

	var ImagePreloaderMixin = _require2.ImagePreloaderMixin;var PropTypes = React.PropTypes;

	__webpack_require__(137);

	var EditorText = React.createClass({
	  displayName: 'EditorText',

	  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, EditorSectionMixin],

	  className: 'editor-Section editor-Section--text',

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    text: PropTypes.string.isRequired,
	    onDeleteClick: PropTypes.func.isRequired,
	    isNew: PropTypes.bool
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      text: ''
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      text: this.props.text
	    };
	  },

	  getSectionDragPreviewUrl: function getSectionDragPreviewUrl() {
	    var scale = this.getDragImageScale(),
	        image = EditorDragImages.TEXT;

	    return getThumbnailUrl(image, {
	      mode: 'preview',
	      width: Math.round(image.size.width / image.intendedScale * scale),
	      height: Math.round(image.size.height / image.intendedScale * scale)
	    });
	  },

	  getImageUrlsToPreload: function getImageUrlsToPreload() {
	    return [this.getSectionDragPreviewUrl()];
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(DragItemTypes.SECTION, {
	      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
	      dropTarget: this.getSectionDropTarget()
	    });
	  },

	  componentDidMount: function componentDidMount() {
	    var iconHTML = React.renderToString(React.createElement(Icon, { name: 'link', size: 'xsmall', mode: 'stroke' })),
	        wysiwygEl = this.refs.wysiwyg.getDOMNode();

	    this.textEditor = new MediumEditor([wysiwygEl], {
	      cleanPastedHTML: true,
	      placeholder: 'Add some text',
	      anchorInputPlaceholder: 'Type a link',
	      buttons: ['bold', 'italic', 'quote', 'anchor', 'header1'],
	      buttonLabels: { 'anchor': iconHTML },
	      diffLeft: 0,
	      diffTop: 0,
	      firstHeader: 'h3'
	    });

	    if (this.props.isNew) {
	      this.getDOMNode().scrollIntoViewIfNeeded();
	      wysiwygEl.focus();

	      DraftActionCreators.resetLastAddedItem();
	    }

	    if (isIE() && typeof MutationObserver !== 'undefined') {
	      this.observer = new MutationObserver(this.handleWysiwygInput);
	      this.observer.observe(wysiwygEl, {
	        attributes: true,
	        childList: true,
	        characterData: true,
	        characterDataOldValue: true,
	        subtree: true
	      });
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this.textEditor.deactivate();

	    if (this.observer) {
	      this.observer.disconnect();
	      this.observer = null;
	    }
	  },

	  render: function render() {
	    var dragSectionState = this.getDragState(DragItemTypes.SECTION);

	    return React.createElement(
	      'div',
	      _extends({ className: this.getClassName(),
	        'data-dragging': dragSectionState.isDragging
	      }, this.dropTargetFor(DragItemTypes.SECTION)),
	      React.createElement(
	        'div',
	        _extends({ className: 'editor-Section-topBar'
	        }, this.dragSourceFor(DragItemTypes.SECTION)),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-type' },
	          React.createElement(Icon, { name: 'text', size: 'small', mode: 'stroke' }),
	          React.createElement(
	            'span',
	            { className: 'editor-Section-typeTitle' },
	            'Text'
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'editor-Section-delete',
	            onClick: this.handleDeleteClick },
	          React.createElement(Icon, { name: 'cross', size: 'xsmall', mode: 'stroke' })
	        )
	      ),
	      React.createElement('div', { ref: 'wysiwyg',
	        className: 'editor-Section-textEditor',
	        onInput: this.handleWysiwygInput,
	        dangerouslySetInnerHTML: { __html: this.state.text } })
	    );
	  },

	  handleWysiwygInput: function handleWysiwygInput() {
	    var node = this.refs.wysiwyg.getDOMNode(),
	        text = node.innerHTML;

	    if (text === this.props.text) {
	      return;
	    }

	    DraftActionCreators.updateSection(this.props.uuid, {
	      text: text
	    });
	  },

	  handleDeleteClick: function handleDeleteClick() {
	    this.props.onDeleteClick(this.props.uuid, this.props.text.length > 0);
	  }
	});

	module.exports = EditorText;

/***/ },

/***/ 669:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Loader = __webpack_require__(43);
	var Icon = __webpack_require__(10);
	var PureRenderMixin = __webpack_require__(2);
	var formatTime = __webpack_require__(136);
	var createFlexibleImageQueueMixin = __webpack_require__(96);var PropTypes = React.PropTypes;

	__webpack_require__(137);
	__webpack_require__(232);

	var EditorVideo = React.createClass({
	  displayName: 'EditorVideo',

	  mixins: [ClassNameMixin, PureRenderMixin, createFlexibleImageQueueMixin(1)],

	  propTypes: {
	    url: PropTypes.string.isRequired,
	    title: PropTypes.string.isRequired,
	    username: PropTypes.string.isRequired,
	    duration: PropTypes.number.isRequired,
	    background: PropTypes.shape({
	      url: PropTypes.string.isRequired
	    }),
	    isBackgroundReady: PropTypes.bool.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.isBackgroundReady && 'ready'];
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.background,
	      mode: 'scale_crop',
	      sizes: {
	        thumb: true,
	        small: true,
	        normal: true,
	        retina: window.devicePixelRatio > 1.5
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.background !== this.props.background) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var isReady = this.props.isBackgroundReady;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      !isReady && React.createElement(Loader, { absoluteCenter: true }),
	      isReady && this.renderBackground(),
	      isReady && this.renderPlayer()
	    );
	  },

	  renderBackground: function renderBackground() {
	    var background = this.props.background;
	    var style;

	    if (background) {
	      style = {
	        backgroundImage: this.getBackgroundImageUrl(),
	        backgroundSize: 'cover'
	      };
	    }

	    return React.createElement(
	      'div',
	      { className: 'editor-Section-background', style: style },
	      this.renderLoaderImg()
	    );
	  },

	  renderPlayer: function renderPlayer() {
	    var _props = this.props;
	    var title = _props.title;
	    var username = _props.username;
	    var duration = _props.duration;

	    return React.createElement(
	      'div',
	      { className: 'EditorMedia-wrapper' },
	      React.createElement(
	        'div',
	        { className: 'EditorMedia-badge' },
	        React.createElement(Icon, { className: 'EditorMedia-icon',
	          name: 'video',
	          size: 'large',
	          mode: 'stroke' }),
	        React.createElement(
	          'div',
	          { className: 'EditorMedia-duration' },
	          formatTime(duration)
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'EditorMedia-info' },
	        React.createElement(
	          'div',
	          { className: 'EditorMedia-title' },
	          title
	        ),
	        React.createElement(
	          'div',
	          { className: 'EditorMedia-author' },
	          username
	        )
	      )
	    );
	  }
	});

	module.exports = EditorVideo;

/***/ },

/***/ 670:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _mixinsClassNameMixin = __webpack_require__(3);

	var _mixinsClassNameMixin2 = _interopRequireDefault(_mixinsClassNameMixin);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _GrabbagItem = __webpack_require__(671);

	var _GrabbagItem2 = _interopRequireDefault(_GrabbagItem);

	var _organismsImagePicker = __webpack_require__(270);

	var _organismsImagePicker2 = _interopRequireDefault(_organismsImagePicker);

	var _storesGrabbagImageStore = __webpack_require__(209);

	var _storesGrabbagImageStore2 = _interopRequireDefault(_storesGrabbagImageStore);

	var _storesStampDraftStore = __webpack_require__(64);

	var _storesStampDraftStore2 = _interopRequireDefault(_storesStampDraftStore);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _mixinsCreateStoreMixin = __webpack_require__(8);

	var _mixinsCreateStoreMixin2 = _interopRequireDefault(_mixinsCreateStoreMixin);

	var _actionsGrabbagActionCreators = __webpack_require__(389);

	var _actionsGrabbagActionCreators2 = _interopRequireDefault(_actionsGrabbagActionCreators);

	var _actionsImageActionCreators = __webpack_require__(248);

	var _actionsImageActionCreators2 = _interopRequireDefault(_actionsImageActionCreators);

	var _actionsModalActionCreators = __webpack_require__(77);

	var _actionsModalActionCreators2 = _interopRequireDefault(_actionsModalActionCreators);

	var _actionsDraftActionCreators = __webpack_require__(33);

	var _actionsDraftActionCreators2 = _interopRequireDefault(_actionsDraftActionCreators);

	var _constantsModalTypes = __webpack_require__(58);

	var _constantsModalTypes2 = _interopRequireDefault(_constantsModalTypes);

	var _atomsButton = __webpack_require__(13);

	var _atomsButton2 = _interopRequireDefault(_atomsButton);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _utilsFirstIfShallowEqual = __webpack_require__(218);

	var _utilsFirstIfShallowEqual2 = _interopRequireDefault(_utilsFirstIfShallowEqual);

	var _actionsSidebarActionCreators = __webpack_require__(29);

	var _actionsSidebarActionCreators2 = _interopRequireDefault(_actionsSidebarActionCreators);

	var _constantsSidebarTypes = __webpack_require__(39);

	var _constantsSidebarTypes2 = _interopRequireDefault(_constantsSidebarTypes);

	var _moleculesBtnGroup = __webpack_require__(44);

	var _moleculesBtnGroup2 = _interopRequireDefault(_moleculesBtnGroup);

	var _atomsLoader = __webpack_require__(43);

	var _atomsLoader2 = _interopRequireDefault(_atomsLoader);

	var _reactLibKeyMirror = __webpack_require__(24);

	var _reactLibKeyMirror2 = _interopRequireDefault(_reactLibKeyMirror);

	var _utilsSafeLocalStorage = __webpack_require__(134);

	var _utilsSafeLocalStorage2 = _interopRequireDefault(_utilsSafeLocalStorage);

	var _moleculesTabBar = __webpack_require__(171);

	var _moleculesTabBar2 = _interopRequireDefault(_moleculesTabBar);

	var _atomsTabLink = __webpack_require__(198);

	var _atomsTabLink2 = _interopRequireDefault(_atomsTabLink);

	var _lodashArrayUniq = __webpack_require__(995);

	var _lodashArrayUniq2 = _interopRequireDefault(_lodashArrayUniq);

	var _lodashCollectionPluck = __webpack_require__(999);

	var _lodashCollectionPluck2 = _interopRequireDefault(_lodashCollectionPluck);

	var _lodashArrayUnion = __webpack_require__(480);

	var _lodashArrayUnion2 = _interopRequireDefault(_lodashArrayUnion);

	__webpack_require__(921);

	'use strict';

	var GrabbagTabs = (0, _reactLibKeyMirror2['default'])({
	  UPLOADED: null,
	  SAVED: null
	});

	var GRABBAG_TAB_KEY = 'grabbag.tab';

	var Grabbag = _react2['default'].createClass({
	  displayName: 'Grabbag',

	  mixins: [_mixinsClassNameMixin2['default'], _mixinsPureRenderMixin2['default'], (0, _mixinsCreateStoreMixin2['default'])(_storesGrabbagImageStore2['default'], _storesStampDraftStore2['default'], _storesUserStore2['default'])],

	  propTypes: {
	    canAutoSave: _react.PropTypes.bool.isRequired
	  },

	  className: 'editor-Grabbag',

	  getInitialState: function getInitialState() {
	    var activeTabId = _utilsSafeLocalStorage2['default'].getItem(GRABBAG_TAB_KEY);
	    return {
	      activeTabId: GrabbagTabs[activeTabId] || GrabbagTabs.UPLOADED
	    };
	  },

	  getStateFromStores: function getStateFromStores() {
	    var uploadedItems = _storesGrabbagImageStore2['default'].getUploadedImageItems(),
	        savedItems = _storesGrabbagImageStore2['default'].getSavedImageItems(),
	        stampletItems = _storesGrabbagImageStore2['default'].getStampletImageItems();

	    return {
	      uploadedItems: uploadedItems,
	      savedItems: savedItems,
	      stampletItems: stampletItems,
	      isExpectingSavedItems: _storesGrabbagImageStore2['default'].isExpectingPage('saved'),
	      isExpectingStampletItems: _storesGrabbagImageStore2['default'].isExpectingPage('stamplet'),
	      draftCount: _storesUserStore2['default'].getMe().draftCount,
	      hasUnsavedChanges: _storesStampDraftStore2['default'].hasUnsavedChanges(),
	      isEmpty: _storesStampDraftStore2['default'].isEmpty(),
	      usedImageUrls: (0, _utilsFirstIfShallowEqual2['default'])(this.state && this.state.usedImageUrls, (0, _lodashArrayUniq2['default'])((0, _lodashCollectionPluck2['default'])(_storesStampDraftStore2['default'].getDraftImages(), 'url')).sort())
	    };
	  },

	  getTabs: function getTabs() {
	    return [{
	      id: GrabbagTabs.UPLOADED,
	      title: 'Uploaded Images'
	    }, {
	      id: GrabbagTabs.SAVED,
	      title: 'Saved Images'
	    }];
	  },

	  getItems: function getItems(tabId) {
	    switch (tabId) {
	      case GrabbagTabs.UPLOADED:
	        return this.state.uploadedItems;
	      case GrabbagTabs.SAVED:
	        return (0, _lodashArrayUnion2['default'])(this.state.savedItems, this.state.stampletItems);
	    }
	  },

	  isExpectingPage: function isExpectingPage(tabId) {
	    switch (tabId) {
	      case GrabbagTabs.UPLOADED:
	        return false;
	      case GrabbagTabs.SAVED:
	        return this.state.isExpectingSavedItems || this.state.isExpectingStampletItems;
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    _actionsDraftActionCreators2['default'].requestDraftPage(true);
	    this.tabDidActivate(this.state.activeTabId);
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var activeTabId = this.state.activeTabId;
	    var prevActiveTabId = prevState.activeTabId;

	    if (activeTabId !== prevActiveTabId) {
	      this.tabDidActivate(activeTabId);
	    }
	  },

	  tabDidActivate: function tabDidActivate(activeTabId) {
	    if (activeTabId === GrabbagTabs.SAVED) {
	      _actionsImageActionCreators2['default'].requestGrabbagImagesPage('saved');
	      _actionsImageActionCreators2['default'].requestGrabbagImagesPage('stamplet');
	    }
	  },

	  render: function render() {
	    var _this = this;

	    var canAutoSave = this.props.canAutoSave;
	    var _state = this.state;
	    var activeTabId = _state.activeTabId;
	    var draftCount = _state.draftCount;
	    var hasUnsavedChanges = _state.hasUnsavedChanges;
	    var isEmpty = _state.isEmpty;

	    return _react2['default'].createElement(
	      'div',
	      { className: this.getClassName() },
	      _react2['default'].createElement(
	        'div',
	        { className: 'editor-Grabbag-topBar' },
	        _react2['default'].createElement(
	          _moleculesBtnGroup2['default'],
	          { className: 'utils--floatRight' },
	          canAutoSave && !isEmpty && _react2['default'].createElement(
	            'span',
	            { className: 'editor-Grabbag-saveLabel' },
	            hasUnsavedChanges ? 'Saving...' : 'Saved'
	          ),
	          _react2['default'].createElement(
	            _atomsButton2['default'],
	            { size: 'small',
	              color: 'gray',
	              onClick: this.handleShowDraftsClick,
	              counter: draftCount > 0 ? draftCount : null },
	            'Drafts'
	          ),
	          _react2['default'].createElement(
	            _atomsButton2['default'],
	            { color: 'gray',
	              size: 'small',
	              round: true,
	              onClick: this.handleHelpClick },
	            '?'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        _moleculesTabBar2['default'],
	        { context: 'Grabbag' },
	        this.getTabs().map(function (tab) {
	          return _react2['default'].createElement(
	            _atomsTabLink2['default'],
	            { key: tab.id,
	              active: tab.id === activeTabId,
	              icon: tab.icon,
	              mode: tab.mode,
	              onClick: function () {
	                return _this.handleTabClick(tab.id);
	              } },
	            tab.title
	          );
	        })
	      ),
	      this.renderTab(activeTabId)
	    );
	  },

	  renderTab: function renderTab(tabId) {
	    var _this2 = this;

	    var items = this.getItems(tabId),
	        isExpectingPage = this.isExpectingPage(tabId);

	    if (items.length === 0) {
	      return isExpectingPage ? _react2['default'].createElement(_atomsLoader2['default'], { absoluteCenter: true }) : this.renderEmptyTab(tabId);
	    }

	    return _react2['default'].createElement(
	      'div',
	      { className: 'editor-Grabbag-collection utils--hideScrollbars' },
	      tabId === GrabbagTabs.SAVED && this.renderStampletButton(),
	      tabId === GrabbagTabs.UPLOADED && this.renderUploadButtonItem(),
	      items.map(function (item) {
	        return _this2.renderItem(item, tabId);
	      })
	    );
	  },

	  renderStampletButton: function renderStampletButton() {
	    return [_react2['default'].createElement('div', null), _react2['default'].createElement(
	      _atomsButton2['default'],
	      { color: 'light',
	        onClick: this.handleStampletClick,
	        className: 'editor-Grabbag-stampletLink' },
	      'Get Stampsy Bookmarklet'
	    )];
	  },

	  renderEmptyTab: function renderEmptyTab(tabId) {
	    switch (tabId) {
	      case GrabbagTabs.UPLOADED:
	        return _react2['default'].createElement(
	          'div',
	          { className: 'editor-Grabbag-message' },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'set', size: 'large', mode: 'stroke' }),
	          _react2['default'].createElement(
	            'h4',
	            { className: 'editor-Grabbag-title' },
	            'Drag images here'
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'editor-Grabbag-divider' },
	            'or'
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'Btn Btn--light' },
	            'Choose Images to Upload',
	            this.renderImagePicker()
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'editor-Grabbag-warning' },
	            'Uploading images that are at least ',
	            _react2['default'].createElement(
	              'b',
	              null,
	              '1024px'
	            ),
	            ' will work best.'
	          )
	        );
	      case GrabbagTabs.SAVED:
	        return _react2['default'].createElement(
	          'div',
	          { className: 'editor-Grabbag-message' },
	          _react2['default'].createElement(_atomsIcon2['default'], { name: 'collect', size: 'large', mode: 'stroke' }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'editor-Grabbag-warning' },
	            'Press ',
	            _react2['default'].createElement(_atomsIcon2['default'], { name: 'collect', mode: 'stroke', size: 'xxsmall' }),
	            ' when viewing images on Stampsy to save them here and use in your own Stamps.'
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'editor-Grabbag-divider' },
	            'or'
	          ),
	          this.renderStampletButton(),
	          _react2['default'].createElement(
	            'div',
	            { className: 'editor-Grabbag-warning' },
	            'And save any images you find on the web straight to your Stampsy editor.'
	          )
	        );
	    }
	  },

	  renderItem: function renderItem(item, tabId) {
	    var _this3 = this;

	    var isUsed = false;var image = item.image;

	    if (image) {
	      isUsed = this.state.usedImageUrls.indexOf(image.url) > -1;
	    }

	    return _react2['default'].createElement(_GrabbagItem2['default'], { key: item.uuid,
	      item: item,
	      isUsed: isUsed,
	      onDeleteClick: function () {
	        return _this3.handleDeleteClick(item, tabId);
	      } });
	  },

	  renderUploadButtonItem: function renderUploadButtonItem() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'editor-GrabbagItem editor-GrabbagItem--upload' },
	      this.renderImagePicker(),
	      _react2['default'].createElement(_atomsIcon2['default'], { name: 'plus',
	        size: 'small',
	        mode: 'stroke' })
	    );
	  },

	  renderImagePicker: function renderImagePicker() {
	    return _react2['default'].createElement(_organismsImagePicker2['default'], { className: 'editor-Grabbag-input',
	      onUploadStart: this.handleUploadStart,
	      onUploadError: this.handleUploadError,
	      onUploadProgress: this.handleUploadProgress,
	      onUploadSuccess: this.handleUploadSuccess,
	      hideProgress: true,
	      multiple: true });
	  },

	  handleTabClick: function handleTabClick(tabId) {
	    this.setState({
	      activeTabId: tabId
	    });

	    _utilsSafeLocalStorage2['default'].setItem(GRABBAG_TAB_KEY, tabId);
	  },

	  handleShowDraftsClick: function handleShowDraftsClick() {
	    _actionsSidebarActionCreators2['default'].showSidebar(_constantsSidebarTypes2['default'].DRAFTS);
	  },

	  handleDeleteClick: function handleDeleteClick(item, tabId) {
	    switch (tabId) {
	      case GrabbagTabs.UPLOADED:
	        _actionsGrabbagActionCreators2['default'].deleteGrabbagItem(item.uuid);
	        break;
	      case GrabbagTabs.SAVED:
	        if (item.image.sourceImage) {
	          _actionsImageActionCreators2['default'].removeFromGrabbag(item.image.sourceImage);
	        } else {
	          _actionsImageActionCreators2['default'].removeStampletItem(item.uuid);
	        }
	        break;
	    }
	  },

	  handleHelpClick: function handleHelpClick() {
	    _actionsModalActionCreators2['default'].showModal(_constantsModalTypes2['default'].EDITOR_HELP);
	  },

	  handleStampletClick: function handleStampletClick() {
	    _actionsModalActionCreators2['default'].showModal(_constantsModalTypes2['default'].STAMPLET);
	  },

	  handleUploadStart: function handleUploadStart(filePath) {
	    _actionsGrabbagActionCreators2['default'].addGrabbagItem(filePath);
	  },

	  handleUploadError: function handleUploadError(filePath) {
	    _actionsGrabbagActionCreators2['default'].deleteGrabbagItem(filePath);
	  },

	  handleUploadProgress: function handleUploadProgress(filePath, progress) {
	    _actionsGrabbagActionCreators2['default'].updateGrabbagItem(filePath, { progress: progress });
	  },

	  handleUploadSuccess: function handleUploadSuccess(filePath, image) {
	    _actionsGrabbagActionCreators2['default'].updateGrabbagItem(filePath, {
	      progress: 0,
	      image: image
	    });
	  }
	});

	exports['default'] = Grabbag;
	module.exports = exports['default'];

/***/ },

/***/ 671:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var getThumbnailUrl = __webpack_require__(37);
	var DragItemTypes = __webpack_require__(85);
	var ImageSizes = __webpack_require__(203);
	var PureRenderMixin = __webpack_require__(2);
	var createFlexibleImageQueueMixin = __webpack_require__(96);
	var guid = __webpack_require__(246);
	var assign = __webpack_require__(15);
	var _require = __webpack_require__(74);

	var DragDropMixin = _require.DragDropMixin;
	var ImagePreloaderMixin = _require.ImagePreloaderMixin;

	var DropEffects = _require.DropEffects;var PropTypes = React.PropTypes;

	__webpack_require__(922);

	function isSmallImage(image) {
	  var size = image.size;
	  return size.width < 1024 && size.height < 1024;
	}

	var GrabbagItem = React.createClass({
	  displayName: 'GrabbagItem',

	  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, createFlexibleImageQueueMixin(1)],

	  className: 'editor-GrabbagItem',

	  propTypes: {
	    item: PropTypes.shape({
	      uuid: PropTypes.string.isRequired,
	      progress: PropTypes.number,
	      image: PropTypes.shape({
	        url: PropTypes.string.isRequired
	      }) }).isRequired,
	    isUsed: PropTypes.bool.isRequired,
	    onDeleteClick: PropTypes.func.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var isUsed = this.props.isUsed;

	    return [isUsed && 'used'];
	  },

	  getImageOptions: function getImageOptions() {
	    var image = this.props.item.image;

	    if (!image) {
	      return;
	    }

	    return {
	      image: image,
	      mode: 'preview',
	      sizes: {
	        thumb: true,
	        normal: true,
	        retina: window.devicePixelRatio > 1.5
	      }
	    };
	  },

	  getImageUrlsToPreload: function getImageUrlsToPreload() {
	    return [this.getDragPreviewUrl()];
	  },

	  getDragPreviewUrl: function getDragPreviewUrl() {
	    if (!this.props.item.image) {
	      return;
	    }

	    var image = this.props.item.image,
	        scale = this.getDragImageScale();

	    return getThumbnailUrl(image, {
	      mode: 'preview',
	      width: Math.round(ImageSizes.EDITOR_GRABBAG_ITEM_DRAG.width * scale),
	      height: Math.round(ImageSizes.EDITOR_GRABBAG_ITEM_DRAG.height * scale)
	    });
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(DragItemTypes.IMAGE, {
	      dragSource: {
	        canDrag: function canDrag() {
	          return this.hasPreloadedImage(this.getDragPreviewUrl());
	        },

	        beginDrag: function beginDrag() {
	          return {
	            effectsAllowed: [DropEffects.COPY],
	            dragPreview: this.getPreloadedImage(this.getDragPreviewUrl()),
	            item: {
	              image: assign({}, this.props.item.image, {
	                uuid: guid(),
	                caption: ''
	              })
	            }
	          };
	        }
	      }
	    });
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.item.image !== this.props.item.image) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var image = this.props.item.image,
	        isLoading = !image,
	        progress = this.props.item.progress;

	    return React.createElement(
	      'div',
	      _extends({}, this.dragSourceFor(DragItemTypes.IMAGE), {
	        className: this.getClassName(),
	        style: {
	          backgroundImage: this.getBackgroundImageUrl()
	        } }),
	      this.renderLoaderImg(),
	      isLoading && React.createElement(
	        'div',
	        { className: 'editor-GrabbagItem-progress' },
	        React.createElement('div', { className: 'editor-GrabbagItem-progressBar',
	          style: {
	            width: Math.min(Math.max(2, progress * 100), 96) + '%'
	          } })
	      ),
	      image && isSmallImage(image) && React.createElement(
	        'div',
	        { className: 'editor-GrabbagItem-small' },
	        React.createElement(
	          'div',
	          { className: 'editor-GrabbagItem-smallExclamation' },
	          '!'
	        ),
	        React.createElement(
	          'div',
	          { className: 'editor-GrabbagItem-smallDetails' },
	          React.createElement(
	            'span',
	            { className: 'editor-GrabbagItem-smallHeader' },
	            'Small Image'
	          ),
	          React.createElement(
	            'span',
	            { className: 'editor-GrabbagItem-smallInfo' },
	            'Images that are at least ',
	            React.createElement(
	              'b',
	              null,
	              '1024px'
	            ),
	            ' will work best.'
	          )
	        )
	      ),
	      React.createElement('div', { className: 'editor-GrabbagItem-item' }),
	      React.createElement(
	        Button,
	        { size: 'xsmall',
	          round: true,
	          color: 'black',
	          overlay: true,
	          className: 'editor-GrabbagItem-delete',
	          onClick: this.props.onDeleteClick },
	        React.createElement(Icon, { name: 'cross',
	          size: 'xxsmall',
	          mode: 'stroke' })
	      )
	    );
	  }
	});

	module.exports = GrabbagItem;

/***/ },

/***/ 741:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Object$defineProperty = __webpack_require__(12)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	_Object$defineProperty(exports, '__esModule', {
	  value: true
	});

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _editorGrabbag = __webpack_require__(670);

	var _editorGrabbag2 = _interopRequireDefault(_editorGrabbag);

	var _editorCanvas = __webpack_require__(660);

	var _editorCanvas2 = _interopRequireDefault(_editorCanvas);

	var _constantsPageControlsTypes = __webpack_require__(94);

	var _constantsPageControlsTypes2 = _interopRequireDefault(_constantsPageControlsTypes);

	var _atomsIcon = __webpack_require__(10);

	var _atomsIcon2 = _interopRequireDefault(_atomsIcon);

	var _actionsGrabbagActionCreators = __webpack_require__(389);

	var _actionsGrabbagActionCreators2 = _interopRequireDefault(_actionsGrabbagActionCreators);

	var _actionsAlertActionCreators = __webpack_require__(32);

	var _actionsAlertActionCreators2 = _interopRequireDefault(_actionsAlertActionCreators);

	var _constantsAlertTypes = __webpack_require__(48);

	var _constantsAlertTypes2 = _interopRequireDefault(_constantsAlertTypes);

	var _utilsImageUploader = __webpack_require__(295);

	var _utilsImageUploader2 = _interopRequireDefault(_utilsImageUploader);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	var _utilsGetDraftComposeRedirectTarget = __webpack_require__(792);

	var _utilsGetDraftComposeRedirectTarget2 = _interopRequireDefault(_utilsGetDraftComposeRedirectTarget);

	var _constantsNavigationContextTypes = __webpack_require__(51);

	var _constantsNavigationContextTypes2 = _interopRequireDefault(_constantsNavigationContextTypes);

	var _AppContext = __webpack_require__(67);

	var _AppContext2 = _interopRequireDefault(_AppContext);

	var _reactDnd = __webpack_require__(74);

	'use strict';

	__webpack_require__(924);

	var DraftComposePage = _react2['default'].createClass({
	  displayName: 'DraftComposePage',

	  mixins: [_reactDnd.DragDropMixin, _mixinsPureRenderMixin2['default']],

	  propTypes: {
	    draft: _react.PropTypes.object,
	    stampSegment: _react.PropTypes.string.isRequired
	  },

	  contextTypes: {
	    router: _react.PropTypes.func
	  },

	  statics: {
	    willTransitionTo: function willTransitionTo(transition, params) {
	      var stampSegment = params.stampSegment;

	      var _getDraftComposeRedirectTarget = (0, _utilsGetDraftComposeRedirectTarget2['default'])(stampSegment);

	      var _getDraftComposeRedirectTarget2 = _slicedToArray(_getDraftComposeRedirectTarget, 2);

	      var redirectTo = _getDraftComposeRedirectTarget2[0];
	      var redirectParams = _getDraftComposeRedirectTarget2[1];

	      // First sanity check to avoid mounting if we know we don't need to.
	      // Saves us runtime errors because editor doesn't work for anon users.
	      if (redirectTo) {
	        transition.redirect(redirectTo, redirectParams);
	        return;
	      }
	    }
	  },

	  configureDragDrop: function configureDragDrop(registerType) {
	    registerType(_reactDnd.NativeDragItemTypes.FILE, {
	      dropTarget: {
	        canDrop: function canDrop() {
	          return true;
	        },

	        getDropEffect: function getDropEffect() {
	          return _reactDnd.DropEffects.COPY;
	        },

	        acceptDrop: function acceptDrop(item) {
	          item.files.forEach(this.uploadImage);
	        }
	      }
	    });
	  },

	  getPageControls: function getPageControls() {
	    var _props = this.props;
	    var draft = _props.draft;
	    var stampSegment = _props.stampSegment;

	    var _parseStampSegment = (0, _utilsParseStampSegment2['default'])(stampSegment);

	    var isNewDraft = _parseStampSegment.isNewDraft;

	    if (!draft || isNewDraft) {
	      return null;
	    }

	    return [_constantsPageControlsTypes2['default'].DRAFT_COMPOSE, { stampSegment: stampSegment }];
	  },

	  getNavigationContext: function getNavigationContext() {
	    return [_constantsNavigationContextTypes2['default'].DRAFT_COMPOSE];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    var _ref = this.getPageControls() || [];

	    var _ref2 = _slicedToArray(_ref, 2);

	    var pageControlsType = _ref2[0];
	    var pageControlsOptions = _ref2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions,
	      pageControlsType: pageControlsType,
	      pageControlsOptions: pageControlsOptions
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this.imageUploader = _utilsImageUploader2['default'].createFileUploader();
	    this.ensureHasAccess();
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (Boolean(prevProps.draft) !== Boolean(this.props.draft) || prevProps.stampSegment !== this.props.stampSegment) {

	      this.ensureHasAccess();
	    }
	  },

	  ensureHasAccess: function ensureHasAccess() {
	    // Second sanity check to redirect if data arrives and tells us user may not edit.
	    var _props2 = this.props;
	    var stampSegment = _props2.stampSegment;
	    var draft = _props2.draft;

	    var _getDraftComposeRedirectTarget3 = (0, _utilsGetDraftComposeRedirectTarget2['default'])(stampSegment, draft);

	    var _getDraftComposeRedirectTarget32 = _slicedToArray(_getDraftComposeRedirectTarget3, 2);

	    var redirectTo = _getDraftComposeRedirectTarget32[0];
	    var redirectParams = _getDraftComposeRedirectTarget32[1];
	    var replaceWith = this.context.router.replaceWith;

	    if (redirectTo) {
	      replaceWith(redirectTo, redirectParams);
	    }
	  },

	  render: function render() {
	    var _props3 = this.props;
	    var draft = _props3.draft;
	    var stampSegment = _props3.stampSegment;

	    var _parseStampSegment2 = (0, _utilsParseStampSegment2['default'])(stampSegment);

	    var isDraft = _parseStampSegment2.isDraft;

	    var fileDropState = this.getDropState(_reactDnd.NativeDragItemTypes.FILE);

	    return _react2['default'].createElement(
	      _AppContext2['default'],
	      this.getAppContext(),
	      _react2['default'].createElement(
	        'div',
	        this.dropTargetFor(_reactDnd.NativeDragItemTypes.FILE),
	        fileDropState.isDragging && _react2['default'].createElement(
	          'div',
	          { className: 'editor-DropZone' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'editor-DropZone-body' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'editor-DropZone-center' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'editor-GrabbagItem--upload' },
	                _react2['default'].createElement(_atomsIcon2['default'], { name: 'plus',
	                  size: 'medium',
	                  mode: 'stroke' })
	              ),
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Drop here to upload'
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(_editorGrabbag2['default'], { canAutoSave: isDraft }),
	        _react2['default'].createElement(_editorCanvas2['default'], { draft: draft })
	      )
	    );
	  },

	  uploadImage: function uploadImage(filePath) {
	    _actionsGrabbagActionCreators2['default'].addGrabbagItem(filePath);

	    function handleProgress(progress) {
	      _actionsGrabbagActionCreators2['default'].updateGrabbagItem(filePath, { progress: progress });
	    }

	    this.imageUploader.uploadFile(filePath, handleProgress).then(function (image) {
	      _actionsGrabbagActionCreators2['default'].updateGrabbagItem(filePath, {
	        progress: 0,
	        image: image
	      });
	    })['catch'](function () {
	      _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].UPLOAD_USER_IMAGE_ERROR);
	      _actionsGrabbagActionCreators2['default'].deleteGrabbagItem(filePath);
	    });
	  }
	});

	exports['default'] = DraftComposePage;
	module.exports = exports['default'];

/***/ },

/***/ 742:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var StampStore = __webpack_require__(17);
	var createStoreMixin = __webpack_require__(8);
	var DocumentTitle = __webpack_require__(68);
	var StampDraftStore = __webpack_require__(64);
	var UserStore = __webpack_require__(5);
	var GrabbagImageStore = __webpack_require__(209);
	var DraftActionCreators = __webpack_require__(33);
	var PureRenderMixin = __webpack_require__(2);
	var parseStampSegment = __webpack_require__(53);
	var getStampSegment = __webpack_require__(60);
	var shallowEqual = __webpack_require__(46);
	var _require = __webpack_require__(154);

	var Navigation = _require.Navigation;

	var RouteHandler = _require.RouteHandler;
	var _require2 = __webpack_require__(4);

	var throttle = _require2.throttle;

	var throttledSaveDraft = throttle(function () {
	  if (StampDraftStore.isReady()) {
	    DraftActionCreators.saveDraft();
	  }
	}, 2000);

	var DraftPage = React.createClass({
	  displayName: 'DraftPage',

	  mixins: [PureRenderMixin, Navigation, createStoreMixin(StampStore, StampDraftStore, GrabbagImageStore)],

	  statics: {
	    willTransitionTo: function willTransitionTo(transition, params) {
	      var stampSegment = params.stampSegment;

	      var currentDraft = StampDraftStore.getDraftStamp();
	      var isCurrentDraft = currentDraft && shallowEqual(getStampSegment(currentDraft), stampSegment);

	      if (isCurrentDraft) {
	        return;
	      }

	      var _parseStampSegment = parseStampSegment(stampSegment);

	      var stampId = _parseStampSegment.stampId;
	      var draftUuid = _parseStampSegment.draftUuid;
	      var isNewDraft = _parseStampSegment.isNewDraft;
	      var isDraft = _parseStampSegment.isDraft;
	      var isStamp = _parseStampSegment.isStamp;

	      if (isNewDraft && UserStore.isAuthenticated()) {
	        DraftActionCreators.loadEmptyDraft();

	        if (StampDraftStore.hasUnsavedChanges()) {
	          // This is a legacy draft migrated from localStorage. Save it!
	          throttledSaveDraft();
	        }
	      } else if (isStamp) {
	        DraftActionCreators.loadStampInEditor(stampId);
	      } else if (isDraft) {
	        DraftActionCreators.loadDraftInEditor(draftUuid);
	      }
	    }
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var _parseStampSegment2 = parseStampSegment(props.params.stampSegment || '');

	    var isDraft = _parseStampSegment2.isDraft;
	    var isNewDraft = _parseStampSegment2.isNewDraft;

	    return {
	      grabbag: GrabbagImageStore.getUploadedImageItems(),
	      draft: StampDraftStore.getDraftStamp(),
	      isEmpty: StampDraftStore.isEmpty(),
	      isDraft: isDraft,
	      isNewDraft: isNewDraft
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!shallowEqual(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var _state = this.state;
	    var isDraft = _state.isDraft;
	    var draft = _state.draft;
	    var grabbag = _state.grabbag;
	    var isEmpty = _state.isEmpty;

	    var isDraftAndReady = isDraft && Boolean(draft) && Boolean(prevState.draft);
	    var isChanged = draft !== prevState.draft || grabbag !== prevState.grabbag;

	    if (isDraftAndReady && draft.canEdit && isChanged && (!isEmpty || draft.uuid)) {
	      throttledSaveDraft();
	    }
	  },

	  render: function render() {
	    var stampSegment = this.props.params.stampSegment;
	    var draft = this.state.draft;

	    return React.createElement(
	      DocumentTitle,
	      { title: draft && draft.title },
	      React.createElement(RouteHandler, { draft: draft, stampSegment: stampSegment })
	    );
	  }
	});

	module.exports = DraftPage;

/***/ },

/***/ 743:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var React = __webpack_require__(1);
	var Stamp = __webpack_require__(284);
	var PageControlsTypes = __webpack_require__(94);
	var LightboxStore = __webpack_require__(147);
	var PureRenderMixin = __webpack_require__(2);
	var getRefinedStamp = __webpack_require__(439);
	var createStoreMixin = __webpack_require__(8);
	var getDraftPreviewRedirectTarget = __webpack_require__(793);
	var NavigationContextTypes = __webpack_require__(51);
	var Loader = __webpack_require__(43);
	var ScrollStateMixin = __webpack_require__(115);
	var AppContext = __webpack_require__(67);
	var _require = __webpack_require__(154);

	var Navigation = _require.Navigation;var PropTypes = React.PropTypes;

	var DraftPreviewPage = React.createClass({
	  displayName: 'DraftPreviewPage',

	  mixins: [Navigation, PureRenderMixin, createStoreMixin(LightboxStore), ScrollStateMixin],

	  statics: {
	    willTransitionTo: function willTransitionTo(transition, params) {
	      var stampSegment = params.stampSegment;

	      var _getDraftPreviewRedirectTarget = getDraftPreviewRedirectTarget(stampSegment);

	      var _getDraftPreviewRedirectTarget2 = _slicedToArray(_getDraftPreviewRedirectTarget, 2);

	      var redirectTo = _getDraftPreviewRedirectTarget2[0];
	      var redirectParams = _getDraftPreviewRedirectTarget2[1];

	      if (redirectTo) {
	        transition.redirect(redirectTo, redirectParams);
	      }
	    }
	  },

	  propTypes: {
	    draft: PropTypes.object,
	    stampSegment: PropTypes.string.isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      lightboxImageUuid: LightboxStore.getActiveImageUuid(),
	      lightboxSectionType: LightboxStore.getActiveSectionType()
	    };
	  },

	  getScrollState: function getScrollState() {
	    return {
	      hasScrolledToInfo: this.hasScrolledToOffset(this._infoPanelOffsetTop)
	    };
	  },

	  getPageControls: function getPageControls() {
	    var _props = this.props;
	    var draft = _props.draft;
	    var stampSegment = _props.stampSegment;
	    var hasScrolledToInfo = this.state.hasScrolledToInfo;

	    if (!draft || hasScrolledToInfo) {
	      return null;
	    }

	    var canEdit = draft.canEdit;
	    var draftUuid = draft.uuid;
	    var _state = this.state;
	    var imageUuid = _state.lightboxImageUuid;
	    var sectionType = _state.lightboxSectionType;

	    if (imageUuid) {
	      return [PageControlsTypes.IMAGE, { imageUuid: imageUuid, sectionType: sectionType }];
	    } else if (canEdit) {
	      return [PageControlsTypes.DRAFT_PREVIEW, { stampSegment: stampSegment }];
	    } else {
	      return [PageControlsTypes.DRAFT_FEEDBACK, { draftUuid: draftUuid }];
	    }
	  },

	  getNavigationContext: function getNavigationContext() {
	    return [NavigationContextTypes.DRAFT_PREVIEW];
	  },

	  getAppContext: function getAppContext() {
	    var _getNavigationContext = this.getNavigationContext();

	    var _getNavigationContext2 = _slicedToArray(_getNavigationContext, 2);

	    var navigationContextType = _getNavigationContext2[0];
	    var navigationContextOptions = _getNavigationContext2[1];

	    var _ref = this.getPageControls() || [];

	    var _ref2 = _slicedToArray(_ref, 2);

	    var pageControlsType = _ref2[0];
	    var pageControlsOptions = _ref2[1];

	    return {
	      navigationContextType: navigationContextType,
	      navigationContextOptions: navigationContextOptions,
	      pageControlsType: pageControlsType,
	      pageControlsOptions: pageControlsOptions
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    this._infoPanelOffsetTop = 0;
	  },

	  render: function render() {
	    var draft = this.props.draft;

	    if (!draft) {
	      return React.createElement(Loader, { absoluteCenter: true });
	    }

	    var canEdit = draft.canEdit;

	    return React.createElement(
	      AppContext,
	      this.getAppContext(),
	      React.createElement(
	        'div',
	        null,
	        draft && React.createElement(Stamp, { stamp: getRefinedStamp(draft),
	          disableInfoPanel: canEdit,
	          showFeedback: !canEdit,
	          onInfoPanelOffsetTopChange: this.handleInfoPanelOffsetTopChange,
	          isLast: true })
	      )
	    );
	  },

	  handleInfoPanelOffsetTopChange: function handleInfoPanelOffsetTopChange(infoPanelOffsetTop) {
	    this._infoPanelOffsetTop = infoPanelOffsetTop;
	    this.updateScrollState();
	  }
	});

	module.exports = DraftPreviewPage;

/***/ },

/***/ 792:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _actionsAlertActionCreators = __webpack_require__(32);

	var _actionsAlertActionCreators2 = _interopRequireDefault(_actionsAlertActionCreators);

	var _constantsAlertTypes = __webpack_require__(48);

	var _constantsAlertTypes2 = _interopRequireDefault(_constantsAlertTypes);

	var _storesUserStore = __webpack_require__(5);

	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	var _utilsBrowser = __webpack_require__(36);

	'use strict';

	function getDraftComposeRedirectTarget(stampSegment, draft) {

	  // Tricky edge cases to keep in mind:
	  // * User visiting draft's compose but we don't know if user is author yet
	  // * User visiting somebody else's stamp compose
	  // * Anonymous visiting somebody's draft compose
	  // etc

	  var isAuthenticated = _storesUserStore2['default'].isAuthenticated();

	  var _parseStampSegment = (0, _utilsParseStampSegment2['default'])(stampSegment);

	  var isServerDraft = _parseStampSegment.isServerDraft;
	  var isStamp = _parseStampSegment.isStamp;

	  var isReady = Boolean(draft);

	  // It is important that we figure out if access is forbidden
	  // even if draft is not ready yet. Thus we can exit early in
	  // willTransitionTo instead of mounting the editor.

	  var isForbidden = !isAuthenticated || isReady && !draft.canEdit;

	  if (isForbidden) {
	    if (isServerDraft) {
	      // User is not owner, might have copied the wrong link.
	      // If it's a server draft, redirect to preview instead.
	      return ['draftPreview', { stampSegment: stampSegment }];
	    } else if (isStamp) {
	      // Probably "Edit Stamp" link but user logged out. Redirect to stamp.
	      return ['feedStamp', { stampSegment: stampSegment }];
	    } else {
	      // "New Draft" link but we're not logged in. Go home.
	      _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].NOT_FOUND, { hideOnRouteChange: false });
	      return ['feed'];
	    }
	  }

	  if ((0, _utilsBrowser.isMobile)()) {
	    // Editor is not available on mobile.
	    // Only show the message if we know this is the author.

	    if (!isReady) {
	      // Wait for the draft to load
	      return [];
	    }

	    if (draft.canEdit) {
	      _actionsAlertActionCreators2['default'].showAlert(_constantsAlertTypes2['default'].EDITOR_DESKTOP_ONLY, { hideOnRouteChange: false });
	    }

	    if (isServerDraft) {
	      // Try our best and redirect to the preview which works on mobile.
	      return ['draftPreview', { stampSegment: stampSegment }];
	    } else if (isStamp) {
	      // It's an "Edit Stamp" link, show stamp.
	      return ['feedStamp', { stampSegment: stampSegment }];
	    } else {
	      // Go home.
	      return ['feed'];
	    }
	  }

	  return [];
	}

	module.exports = getDraftComposeRedirectTarget;

/***/ },

/***/ 793:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var UserStore = __webpack_require__(5);
	var parseStampSegment = __webpack_require__(53);
	var AlertActionCreators = __webpack_require__(32);
	var AlertTypes = __webpack_require__(48);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	function getDraftPreviewRedirectTarget(stampSegment) {

	  // It's just a preview so we won't try to catch all the edge cases like in
	  // DraftComposePage. Preview page works on mobile, and anyone can view
	  // preview page for server drafts.

	  var _parseStampSegment = parseStampSegment(stampSegment);

	  var isServerDraft = _parseStampSegment.isServerDraft;

	  if (!isServerDraft) {
	    if (!UserStore.isAuthenticated()) {
	      return ['feed'];
	    }

	    if (isMobile()) {
	      AlertActionCreators.showAlert(AlertTypes.EDITOR_DESKTOP_ONLY, { hideOnRouteChange: false });
	      return ['feed'];
	    }
	  }

	  return [];
	}

	module.exports = getDraftPreviewRedirectTarget;

/***/ },

/***/ 889:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-AddSectionButton{margin:0 .5rem;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:1000px;opacity:0;-webkit-animation-name:popUp;animation-name:popUp;-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1.15);animation-timing-function:cubic-bezier(.175,.885,.32,1.15);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.editor-AddSectionButton:nth-child(2),.editor-AddSectionButton:nth-child(4){-webkit-animation-delay:.075s;animation-delay:.075s}.editor-AddSectionButton:first-child,.editor-AddSectionButton:last-child{-webkit-animation-delay:.15s;animation-delay:.15s}.editor-AddSectionButton:first-child,.editor-AddSectionButton:nth-child(2){-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.editor-AddSectionButton:nth-child(4),.editor-AddSectionButton:last-child{-webkit-transform-origin:0 50%;transform-origin:0 50%}.editor-AddSectionButton-label{font-weight:700;font-size:1.125rem;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1);color:#02b871}.editor-AddSectionButton:not(.editor-AddSectionButton--drop) .editor-AddSectionButton-label{position:absolute;bottom:-1.75rem;left:0;right:0;text-align:center;opacity:0;pointer-events:none}.editor-AddSectionButton:not(.editor-AddSectionButton--drop):hover .editor-AddSectionButton-label{opacity:1}.editor-AddSectionButton.editor-AddSectionButton--drop{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;height:2.75rem;border-radius:2px;border:1px dashed #02cc7d;background-color:rgba(2,204,125,.1);color:#02cc7d}.editor-AddSectionButton.editor-AddSectionButton--drop:first-child{margin-left:0}.editor-AddSectionButton.editor-AddSectionButton--drop:last-child{margin-right:0}.editor-AddSectionButton.editor-AddSectionButton--drop[data-hover=true]{background-color:rgba(2,204,125,.5);color:#fff}.editor-AddSectionButton.editor-AddSectionButton--drop.editor-AddSectionButton--last{height:5rem}.editor-AddSectionButton.editor-AddSectionButton--drop.editor-AddSectionButton--last .editor-AddSectionButton-label{margin-left:.75rem;font-size:1.25rem}.editor-AddSectionButton.editor-AddSectionButton--drop .editor-AddSectionButton-label{margin-left:.5rem;color:inherit}", ""]);

/***/ },

/***/ 890:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-AddSectionControl{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:.5rem auto;width:46rem;min-height:3.5rem}.editor-AddSectionControl:not(.editor-AddSectionControl--last) .editor-AddSectionControl-plus{opacity:.35;-webkit-transition:opacity .1s linear;transition:opacity .1s linear}.editor-AddSectionControl:not(.editor-AddSectionControl--last):hover .editor-AddSectionControl-plus{opacity:1}.editor-AddSectionControl--last{margin-top:2rem;margin-bottom:6rem;opacity:1}", ""]);

/***/ },

/***/ 891:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-Canvas{position:relative;min-height:100vh;margin-left:23rem;padding-bottom:1px;background-color:#e8e8e8}.editor-Canvas-sections{padding:3.5rem 2rem}", ""]);

/***/ },

/***/ 892:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-GalleryImage{position:relative;display:inline-block;vertical-align:bottom;width:21.625rem;height:21.625rem;margin:.625rem 0 0 .625rem;background-color:#797b80;background-size:cover;background-position:center;box-shadow:inset 0 0 0 1px rgba(0,0,0,.05);cursor:grab}.editor-GalleryImage:nth-child(2n+1){margin-left:0}.editor-GalleryImage:nth-child(-n+2){margin-top:0}.editor-GalleryImage[data-dragging=true]{opacity:0}.editor-GalleryImage-image{width:100%;height:100%;background-color:#797b80;background-size:cover;background-position:center}.editor-GalleryImage-delete{position:absolute;top:.5rem;right:.5rem;opacity:0}.editor-GalleryImage:hover .editor-GalleryImage-delete{opacity:1}", ""]);

/***/ },

/***/ 893:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-Grabbag{z-index:104;position:fixed;overflow:hidden;width:23rem;height:100%;color:#fff;background-color:#000;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.editor-Grabbag-topBar{z-index:104;padding:.5rem .75rem;width:100%;height:3rem;background-color:#2e2f33}.editor-Grabbag-saveLabel{-ms-flex-item-align:center;align-self:center;font-size:.875rem;opacity:.35}.editor-Grabbag-collection{width:23rem;height:100%;padding-top:3rem;padding-right:.125rem;overflow-y:auto}.editor-Grabbag-collection .editor-Grabbag-stampletLink{margin:0 .75rem 1rem;width:21.5rem}.editor-Grabbag-collection:after{display:inline-block;width:10rem;margin-left:1rem;content:\"\"}.editor-Grabbag-message{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;text-align:center}.editor-Grabbag-message .editor-Grabbag-title{position:relative;margin-top:.5rem;font-size:1.5rem}.editor-Grabbag-message .editor-Grabbag-divider{position:relative;margin:2em 0;color:#797b80}.editor-Grabbag-message .editor-Grabbag-divider:before,.editor-Grabbag-message .editor-Grabbag-divider:after{display:block;position:absolute;bottom:45%;width:3rem;height:1px;background-color:rgba(255,255,255,.15);content:\"\"}.editor-Grabbag-message .editor-Grabbag-divider:before{left:-3.5rem}.editor-Grabbag-message .editor-Grabbag-divider:after{right:-3.5rem}.editor-Grabbag-message div.Btn{position:relative}.editor-Grabbag-input{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;pointer-events:auto}.editor-Grabbag .editor-Grabbag-warning{margin-top:1rem;max-width:16rem;color:#797b80;font-size:.875rem}", ""]);

/***/ },

/***/ 894:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-GrabbagItem{position:relative;display:inline-block;width:11.375rem;height:11.375rem;margin:0 0 .125rem .125rem;vertical-align:bottom;background-color:#2e2f33;background-size:contain;background-repeat:no-repeat;background-position:center;cursor:grab}.editor-GrabbagItem:hover .editor-GrabbagItem-small{opacity:1}.editor-GrabbagItem.editor-GrabbagItem--used{opacity:.5}.editor-GrabbagItem.editor-GrabbagItem--used:hover{opacity:1}.editor-GrabbagItem-delete{position:absolute;top:4px;right:4px;opacity:0}.editor-GrabbagItem:hover .editor-GrabbagItem-delete{opacity:1}.editor-GrabbagItem:nth-child(2n+1){margin-left:0}.editor-GrabbagItem-progressBar{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background:rgba(2,204,125,.75);margin-bottom:.25rem;-webkit-transition:width .5s ease-in-out;transition:width .5s ease-in-out}.editor-GrabbagItem-small{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;pointer-events:none;position:absolute;width:100%;height:100%;padding:.75rem;background-color:rgba(245,186,10,.75);opacity:0}.editor-GrabbagItem-small .editor-GrabbagItem-smallExclamation{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:.5rem;width:2rem;height:2rem;border-radius:1000px;background-color:#000;color:#fff;font-size:1.5rem;font-weight:700;opacity:1}.editor-GrabbagItem-small .editor-GrabbagItem-smallDetails{text-align:center;color:#000;line-height:normal}.editor-GrabbagItem-small .editor-GrabbagItem-smallDetails .editor-GrabbagItem-smallHeader{display:block;margin-bottom:.25rem;font-weight:700}.editor-GrabbagItem-small .editor-GrabbagItem-smallDetails .editor-GrabbagItem-smallInfo{font-size:.875rem}.editor-GrabbagItem-item{width:11.375rem;height:11.375rem}.editor-GrabbagItem.editor-GrabbagItem--upload{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#797b80}.editor-GrabbagItem.editor-GrabbagItem--upload:hover{color:#fff}.editor-GrabbagItem.editor-GrabbagItem--upload .Icon{pointer-events:none}", ""]);

/***/ },

/***/ 895:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-ImageCaption{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:1.5rem 1rem;padding-top:2rem;position:absolute;left:0;right:0;bottom:0;text-align:center;background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.4),transparent);background-image:linear-gradient(to top,rgba(0,0,0,.4),transparent);pointer-events:none}.editor-ImageCaption-input{text-align:center;color:#fff;line-height:normal;cursor:text;pointer-events:auto}", ""]);

/***/ },

/***/ 896:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-DropZone{position:fixed;left:0;top:0;width:100%;height:100%;color:#fff;z-index:106}.editor-DropZone .editor-DropZone-body{display:table;width:100%;height:100%;background-color:rgba(0,0,0,.85)}.editor-DropZone .editor-DropZone-center{display:table-cell;vertical-align:middle;text-align:center}.editor-DropZone p{font-size:1.5rem;font-weight:700}", ""]);

/***/ },

/***/ 897:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".EditorMedia-background{position:absolute;height:100%;width:100%}.EditorMedia-wrapper{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;width:100%;height:100%;color:#fff;text-align:center;background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.4),transparent);background-image:linear-gradient(to top,rgba(0,0,0,.4),transparent)}.EditorMedia-wrapper:before{position:absolute;top:0;left:0;right:0;content:\"\";height:12rem;background-image:-webkit-linear-gradient(rgba(0,0,0,.4),transparent);background-image:linear-gradient(rgba(0,0,0,.4),transparent)}.EditorMedia-cover{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;width:12rem;height:12rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:2px;background-color:#797b80;background-size:cover;background-position:center;box-shadow:0 2px 6px rgba(0,0,0,.25)}.EditorMedia-badge{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:10rem;height:10rem;border-radius:1000px;background-color:rgba(0,0,0,.4)}.EditorMedia-duration{position:absolute;bottom:.75rem;left:0;right:0;text-align:center;font-size:.875rem}.EditorMedia-info{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:1.75rem;position:absolute;left:0;right:0;bottom:0;text-align:center;background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.4),transparent);background-image:linear-gradient(to top,rgba(0,0,0,.4),transparent)}.EditorMedia-title{width:80%;overflow:hidden;margin-bottom:.25rem;font-size:1.75rem;font-weight:700;text-overflow:ellipsis;white-space:nowrap}.EditorMedia-author{width:80%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

/***/ },

/***/ 898:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".editor-Section{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0 auto;padding:1rem;padding-top:4rem;width:46rem;border-radius:2px;overflow:hidden;background-color:#fff;background-size:cover;box-shadow:0 2px 12px rgba(0,0,0,.05)}.editor-Section[data-dragging=true]{opacity:0;max-height:25.75rem}.editor-Section[data-state=background]{background-color:#797b80}.editor-Section.editor-Section--gallery,.editor-Section.editor-Section--poster,.editor-Section.editor-Section--media,.editor-Section.editor-Section--cover{min-height:25.75rem}.App--ie .editor-Section.editor-Section--gallery,.App--ie .editor-Section.editor-Section--poster,.App--ie .editor-Section.editor-Section--media,.App--ie .editor-Section.editor-Section--cover{height:25.75rem}.editor-Section-background{position:absolute;background-size:cover;background-position:center;background-color:#797b80;top:0;right:0;bottom:0;left:0}.editor-Section-background:before{position:absolute;content:\"\";top:0;right:0;left:0;height:12rem;background-image:-webkit-linear-gradient(top,rgba(0,0,0,.4),transparent);background-image:linear-gradient(to bottom,rgba(0,0,0,.4),transparent)}.editor-Section.editor-Section--cover .editor-Section-background:before{height:auto;bottom:0;background-image:none;background-color:rgba(0,0,0,.3)}.editor-Section.editor-Section--cover .editor-Section-deleteBackground{position:absolute;top:0;right:0;color:#fff;opacity:.5;cursor:pointer;z-index:2}.editor-Section.editor-Section--cover .editor-Section-deleteBackground:hover{opacity:1}.editor-Section-wrapperBox{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.editor-Section-topBar{position:absolute;z-index:3;top:0;left:1rem;right:1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:3rem;border-bottom:1px solid #e8e8e8;cursor:move;color:#797b80}.editor-Section--cover .editor-Section-topBar{cursor:default}.editor-Section[data-state=background] .editor-Section-topBar{border-color:rgba(255,255,255,.2);color:#fff}.editor-Section-type,.editor-Section-delete{position:absolute;top:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.editor-Section-type{left:0;font-weight:700}.editor-Section-delete{right:0;cursor:pointer}.editor-Section-delete:hover{color:#fc3224;opacity:1}.editor-Section-options{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.editor-Section-typeTitle,.editor-Section-layoutTitle{margin-left:.5rem;vertical-align:middle}.editor-Section-layoutSwitch{padding:.75rem 1rem;color:#797b80;cursor:pointer}.editor-Section-layoutSwitch:hover{color:#2e2f33}.editor-Section-layoutSwitch[data-active=true]{color:#02cc7d}.editor-Section-layoutSwitch .Icon{display:inline-block}.editor-Section-hgroup{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:2rem 0;text-align:center;color:#2e2f33;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);-webkit-transition:-webkit-transform .3s cubic-bezier(.175,.885,.32,1);transition:transform .3s cubic-bezier(.175,.885,.32,1)}.editor-Section-hgroup .editor-Section-title{margin:0 0 1rem;outline:none;font-size:3.75rem;line-height:1;word-break:break-word}.editor-Section-hgroup .editor-Section-subtitle{margin:0;outline:none;font-size:1.5rem;font-weight:400;line-height:1.2;word-break:break-word;opacity:.75}.editor-Section.editor-Section--cover[data-state=empty] .editor-Section-hgroup{color:#2e2f33}.editor-Section.editor-Section--cover[data-state=empty] .editor-Section-title:before{opacity:.5}.editor-Section.editor-Section--cover[data-state=empty] .editor-Section-subtitle:before{opacity:.3}.editor-Section.editor-Section--cover[data-state=background] .editor-Section-hgroup{color:#fff}.editor-Section.editor-Section--cover[data-state=background] .editor-Section-title:before{opacity:.75}.editor-Section.editor-Section--cover[data-state=background] .editor-Section-subtitle:before{opacity:.5}.editor-Section.editor-Section--cover[data-state=empty] .editor-Section-hgroup{-webkit-transform:translate3d(0,2rem,0);transform:translate3d(0,2rem,0)}.editor-Section-textEditor{padding:3.5rem;padding-top:1.75rem;white-space:pre-wrap;outline:none;font-family:minion-pro-condensed,serif}.editor-Section-textEditor:after{top:2rem;left:2rem;font-size:1.25rem}.editor-Section-textEditor p{white-space:pre-wrap;font-size:1.25rem;outline:none}.editor-Section-textEditor h3{margin:2.75rem 0;font-size:2.25rem;text-align:center}.editor-Section-textEditor h3:first-child{margin-top:0}.editor-Section-textEditor blockquote,.editor-Section-textEditor blockquote p,.editor-Section-textEditor blockquote span{margin:2.75rem 0;padding:0 .75rem;color:#797b80;font-size:1.75rem;font-style:italic;text-align:center}.editor-Section-textEditor blockquote:first-child,.editor-Section-textEditor blockquote p:first-child,.editor-Section-textEditor blockquote span:first-child{margin-top:0}.editor-Section-textEditor blockquote span,.editor-Section-textEditor blockquote p span,.editor-Section-textEditor blockquote span span{font-size:inherit!important}.editor-Section-embedLogo{position:absolute;top:1rem;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:auto;width:5rem;opacity:.1}.editor-Section-embedLogo .editor-Section-embedLogoImage{width:5rem}.editor-Section-embedCaption{margin-bottom:1.5rem;color:#797b80;font-size:1.125rem;text-align:center}.editor-Section-embedForm{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:32rem}.editor-Section-embedInput{margin-bottom:1.5rem;outline:none;color:#2e2f33;width:100%;padding:.75rem 1rem;border:1px solid rgba(46,47,51,.2);text-align:center}.editor-Section-embedInput:focus{border-color:#2e2f33}.editor-SectionHint{z-index:2;position:absolute;top:0;right:0;left:0;width:100%;height:100%;padding:4rem 1rem 1rem;background-color:rgba(255,255,255,.9);pointer-events:none}.editor-SectionHint-box{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;height:100%;color:#02cc7d;border:1px dashed #02cc7d;background-color:rgba(2,204,125,.1)}.editor-SectionHint-message{margin:0;text-align:center;max-width:80%;pointer-events:none;-webkit-transition:-webkit-transform .3s cubic-bezier(.175,.885,.32,1.15);transition:transform .3s cubic-bezier(.175,.885,.32,1.15)}.editor-SectionHint-message:before,.editor-SectionHint-message:after{margin:.75rem 0;display:block}.editor-Section.editor-Section--cover .editor-SectionHint{background-color:transparent}.editor-Section.editor-Section--cover .editor-SectionHint-box{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:2rem}.editor-Section[data-state=background] .editor-SectionHint,.editor-Section[data-state=images] .editor-SectionHint,.editor-Section[data-state=full] .editor-SectionHint{opacity:0}.editor-Section[data-state=empty].editor-Section--gallery .editor-SectionHint-message:before,.editor-Section[data-state=images].editor-Section--gallery .editor-SectionHint-message:before{content:\"Drag up to 10 images here\"}.editor-Section[data-state=empty].editor-Section--poster .editor-SectionHint-message:before,.editor-Section[data-state=images].editor-Section--poster .editor-SectionHint-message:before{content:\"Drag image here\"}.editor-Section[data-state=empty].editor-Section--cover .editor-SectionHint-message:before,.editor-Section[data-state=images].editor-Section--cover .editor-SectionHint-message:before{content:\"Drag image here\"}.editor-Section[data-state=\"empty\"][data-hint=\"true\"] .editor-SectionHint,.editor-Section[data-state=\"images\"][data-hint=\"true\"] .editor-SectionHint{opacity:1}.editor-Section[data-state=\"empty\"][data-hint=\"true\"] .editor-SectionHint-box,.editor-Section[data-state=\"images\"][data-hint=\"true\"] .editor-SectionHint-box{border-color:#02cc7d;color:#02cc7d;background-color:rgba(2,204,125,.2)}.editor-Section[data-state=\"empty\"][data-hint=\"true\"] .editor-SectionHint-message,.editor-Section[data-state=\"images\"][data-hint=\"true\"] .editor-SectionHint-message{-webkit-transform:scale(1.05);transform:scale(1.05)}.editor-Section[data-state=\"empty\"][data-hint=\"true\"][data-hover=\"true\"] .editor-SectionHint-box,.editor-Section[data-state=\"images\"][data-hint=\"true\"][data-hover=\"true\"] .editor-SectionHint-box{color:#fff;background-color:rgba(2,204,125,.5)}.editor-Section[data-state=\"full\"][data-hint=\"true\"] .editor-SectionHint{opacity:1}.editor-Section[data-state=\"full\"][data-hint=\"true\"] .editor-SectionHint-message:before{content:\"You can only put up to 10 images in one set\"}.editor-Section[data-state=\"full\"][data-hint=\"true\"] .editor-SectionHint-box{border-color:#fc3224;color:#fc3224;background-color:rgba(252,50,36,.2)}.editor-Section[data-state=\"full\"][data-hint=\"true\"] .editor-SectionHint-message{-webkit-transform:scale(1.05);transform:scale(1.05)}.editor-Section[data-state=\"full\"][data-hint=\"true\"][data-hover=\"true\"] .editor-SectionHint-box{color:#fff;background-color:rgba(252,50,36,.5)}.editor-Section[data-state=\"background\"][data-hint=\"true\"] .editor-SectionHint{opacity:1;background-color:rgba(0,0,0,.3)}.editor-Section[data-state=\"background\"][data-hint=\"true\"] .editor-SectionHint-box{color:#fff;border-color:#fff;background-color:rgba(255,255,255,.1)}.editor-Section[data-state=\"background\"][data-hint=\"true\"] .editor-SectionHint-message{-webkit-transform:scale(1.05);transform:scale(1.05)}.editor-Section[data-state=\"background\"][data-hint=\"true\"] .editor-SectionHint-message:before{content:\"Drag here to replace this image\"}.editor-Section[data-state=\"background\"][data-hint=\"true\"][data-hover=\"true\"] .editor-SectionHint-box{background-color:rgba(255,255,255,.2)}", ""]);

/***/ },

/***/ 917:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(889);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/AddSectionButton.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/AddSectionButton.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 918:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(890);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/AddSectionControl.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/AddSectionControl.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 919:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(891);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/Canvas.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/Canvas.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 920:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(892);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/EditorGalleryImage.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/EditorGalleryImage.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 921:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(893);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/Grabbag.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/Grabbag.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 922:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(894);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/GrabbagItem.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/GrabbagItem.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 923:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(895);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/ImageCaption.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/ImageCaption.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 924:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(896);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/legacy/Dropzone.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/editor/legacy/Dropzone.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 995:
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(152),
	    baseUniq = __webpack_require__(491),
	    isIterateeCall = __webpack_require__(494),
	    sortedUniq = __webpack_require__(1038);

	/**
	 * Creates a duplicate-value-free version of an array using `SameValueZero`
	 * for equality comparisons. Providing `true` for `isSorted` performs a faster
	 * search algorithm for sorted arrays. If an iteratee function is provided it
	 * is invoked for each value in the array to generate the criterion by which
	 * uniqueness is computed. The `iteratee` is bound to `thisArg` and invoked
	 * with three arguments; (value, index, array).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @alias unique
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {boolean} [isSorted] Specify the array is sorted.
	 * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 * @example
	 *
	 * _.uniq([1, 2, 1]);
	 * // => [1, 2]
	 *
	 * // using `isSorted`
	 * _.uniq([1, 1, 2], true);
	 * // => [1, 2]
	 *
	 * // using an iteratee function
	 * _.uniq([1, 2.5, 1.5, 2], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => [1, 2.5]
	 *
	 * // using the `_.property` callback shorthand
	 * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniq(array, isSorted, iteratee, thisArg) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (isSorted != null && typeof isSorted != 'boolean') {
	    thisArg = iteratee;
	    iteratee = isIterateeCall(array, isSorted, thisArg) ? null : isSorted;
	    isSorted = false;
	  }
	  iteratee = iteratee == null ? iteratee : baseCallback(iteratee, thisArg, 3);
	  return (isSorted)
	    ? sortedUniq(array, iteratee)
	    : baseUniq(array, iteratee);
	}

	module.exports = uniq;


/***/ },

/***/ 996:
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(485),
	    baseSlice = __webpack_require__(1020);

	/**
	 * Creates an array excluding all provided values using `SameValueZero` for
	 * equality comparisons.
	 *
	 * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	 * e.g. `===`, except that `NaN` matches `NaN`. See the
	 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	function without(array) {
	  return baseDifference(array, baseSlice(arguments, 1));
	}

	module.exports = without;


/***/ },

/***/ 999:
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(490),
	    map = __webpack_require__(481);

	/**
	 * Gets the value of `key` from all elements in `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {string} key The key of the property to pluck.
	 * @returns {Array} Returns the property values.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 }
	 * ];
	 *
	 * _.pluck(users, 'user');
	 * // => ['barney', 'fred']
	 *
	 * var userIndex = _.indexBy(users, 'user');
	 * _.pluck(userIndex, 'age');
	 * // => [36, 40] (iteration order is not guaranteed)
	 */
	function pluck(collection, key) {
	  return map(collection, baseProperty(key));
	}

	module.exports = pluck;


/***/ },

/***/ 1004:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Used by `_.defaults` to customize its `_.assign` use.
	 *
	 * @private
	 * @param {*} objectValue The destination object property value.
	 * @param {*} sourceValue The source object property value.
	 * @returns {*} Returns the value to assign to the destination object.
	 */
	function assignDefaults(objectValue, sourceValue) {
	  return typeof objectValue == 'undefined' ? sourceValue : objectValue;
	}

	module.exports = assignDefaults;


/***/ },

/***/ 1005:
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(484),
	    keys = __webpack_require__(126);

	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} [customizer] The function to customize assigning values.
	 * @returns {Object} Returns the destination object.
	 */
	function baseAssign(object, source, customizer) {
	  var props = keys(source);
	  if (!customizer) {
	    return baseCopy(source, object, props);
	  }
	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);

	    if ((result === result ? result !== value : value === value) ||
	        (typeof value == 'undefined' && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}

	module.exports = baseAssign;


/***/ },

/***/ 1020:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;

	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (typeof end == 'undefined' || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : (end - start) >>> 0;
	  start >>>= 0;

	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}

	module.exports = baseSlice;


/***/ },

/***/ 1025:
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(187),
	    isIterateeCall = __webpack_require__(494);

	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return function() {
	    var length = arguments.length,
	        object = arguments[0];

	    if (length < 2 || object == null) {
	      return object;
	    }
	    if (length > 3 && isIterateeCall(arguments[1], arguments[2], arguments[3])) {
	      length = 2;
	    }
	    // Juggle arguments.
	    if (length > 3 && typeof arguments[length - 2] == 'function') {
	      var customizer = bindCallback(arguments[--length - 1], arguments[length--], 5);
	    } else if (length > 2 && typeof arguments[length - 1] == 'function') {
	      customizer = arguments[--length];
	    }
	    var index = 0;
	    while (++index < length) {
	      var source = arguments[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  };
	}

	module.exports = createAssigner;


/***/ },

/***/ 1038:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * An implementation of `_.uniq` optimized for sorted arrays without support
	 * for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 */
	function sortedUniq(array, iteratee) {
	  var seen,
	      index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];

	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;

	    if (!index || seen !== computed) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}

	module.exports = sortedUniq;


/***/ },

/***/ 1040:
/***/ function(module, exports, __webpack_require__) {

	var baseAssign = __webpack_require__(1005),
	    createAssigner = __webpack_require__(1025);

	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments;
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return typeof value == 'undefined' ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(baseAssign);

	module.exports = assign;


/***/ },

/***/ 1041:
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(482),
	    assign = __webpack_require__(1040),
	    assignDefaults = __webpack_require__(1004);

	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object for all destination properties that resolve to `undefined`. Once a
	 * property is set, additional defaults of the same property are ignored.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	function defaults(object) {
	  if (object == null) {
	    return object;
	  }
	  var args = arrayCopy(arguments);
	  args.push(assignDefaults);
	  return assign.apply(undefined, args);
	}

	module.exports = defaults;


/***/ },

/***/ 1046:
/***/ function(module, exports, __webpack_require__) {

	/*global self, document, DOMException */

	/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

	// Full polyfill for browsers with no classList support
	if (!("classList" in document.createElement("_"))) {
	  (function (view) {

	  "use strict";

	  if (!('Element' in view)) return;

	  var
	      classListProp = "classList"
	    , protoProp = "prototype"
	    , elemCtrProto = view.Element[protoProp]
	    , objCtr = Object
	    , strTrim = String[protoProp].trim || function () {
	      return this.replace(/^\s+|\s+$/g, "");
	    }
	    , arrIndexOf = Array[protoProp].indexOf || function (item) {
	      var
	          i = 0
	        , len = this.length
	      ;
	      for (; i < len; i++) {
	        if (i in this && this[i] === item) {
	          return i;
	        }
	      }
	      return -1;
	    }
	    // Vendors: please allow content code to instantiate DOMExceptions
	    , DOMEx = function (type, message) {
	      this.name = type;
	      this.code = DOMException[type];
	      this.message = message;
	    }
	    , checkTokenAndGetIndex = function (classList, token) {
	      if (token === "") {
	        throw new DOMEx(
	            "SYNTAX_ERR"
	          , "An invalid or illegal string was specified"
	        );
	      }
	      if (/\s/.test(token)) {
	        throw new DOMEx(
	            "INVALID_CHARACTER_ERR"
	          , "String contains an invalid character"
	        );
	      }
	      return arrIndexOf.call(classList, token);
	    }
	    , ClassList = function (elem) {
	      var
	          trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
	        , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
	        , i = 0
	        , len = classes.length
	      ;
	      for (; i < len; i++) {
	        this.push(classes[i]);
	      }
	      this._updateClassName = function () {
	        elem.setAttribute("class", this.toString());
	      };
	    }
	    , classListProto = ClassList[protoProp] = []
	    , classListGetter = function () {
	      return new ClassList(this);
	    }
	  ;
	  // Most DOMException implementations don't allow calling DOMException's toString()
	  // on non-DOMExceptions. Error's toString() is sufficient here.
	  DOMEx[protoProp] = Error[protoProp];
	  classListProto.item = function (i) {
	    return this[i] || null;
	  };
	  classListProto.contains = function (token) {
	    token += "";
	    return checkTokenAndGetIndex(this, token) !== -1;
	  };
	  classListProto.add = function () {
	    var
	        tokens = arguments
	      , i = 0
	      , l = tokens.length
	      , token
	      , updated = false
	    ;
	    do {
	      token = tokens[i] + "";
	      if (checkTokenAndGetIndex(this, token) === -1) {
	        this.push(token);
	        updated = true;
	      }
	    }
	    while (++i < l);

	    if (updated) {
	      this._updateClassName();
	    }
	  };
	  classListProto.remove = function () {
	    var
	        tokens = arguments
	      , i = 0
	      , l = tokens.length
	      , token
	      , updated = false
	      , index
	    ;
	    do {
	      token = tokens[i] + "";
	      index = checkTokenAndGetIndex(this, token);
	      while (index !== -1) {
	        this.splice(index, 1);
	        updated = true;
	        index = checkTokenAndGetIndex(this, token);
	      }
	    }
	    while (++i < l);

	    if (updated) {
	      this._updateClassName();
	    }
	  };
	  classListProto.toggle = function (token, force) {
	    token += "";

	    var
	        result = this.contains(token)
	      , method = result ?
	        force !== true && "remove"
	      :
	        force !== false && "add"
	    ;

	    if (method) {
	      this[method](token);
	    }

	    if (force === true || force === false) {
	      return force;
	    } else {
	      return !result;
	    }
	  };
	  classListProto.toString = function () {
	    return this.join(" ");
	  };

	  if (objCtr.defineProperty) {
	    var classListPropDesc = {
	        get: classListGetter
	      , enumerable: true
	      , configurable: true
	    };
	    try {
	      objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	    } catch (ex) { // IE 8 doesn't support enumerable:true
	      if (ex.number === -0x7FF5EC54) {
	        classListPropDesc.enumerable = false;
	        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	      }
	    }
	  } else if (objCtr[protoProp].__defineGetter__) {
	    elemCtrProto.__defineGetter__(classListProp, classListGetter);
	  }

	  }(self));
	}

	(function (root, factory) {
	    'use strict';
	    if (true) {
	        module.exports = factory;
	    } else if (typeof define === 'function' && define.amd) {
	        define(factory);
	    } else {
	        root.MediumEditor = factory;
	    }
	}(this, function () {

	    'use strict';

	var mediumEditorUtil;

	(function (window, document) {
	    'use strict';

	    function copyInto(dest, source, overwrite) {
	        var prop;
	        dest = dest || {};
	        for (prop in source) {
	            if (source.hasOwnProperty(prop) && (overwrite || dest.hasOwnProperty(prop) === false)) {
	                dest[prop] = source[prop];
	            }
	        }
	        return dest;
	    }

	    mediumEditorUtil = {

	        // http://stackoverflow.com/questions/17907445/how-to-detect-ie11#comment30165888_17907562
	        // by rg89
	        isIE: ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})').exec(navigator.userAgent) !== null))),

	        // https://github.com/jashkenas/underscore
	        keyCode: {
	            BACKSPACE: 8,
	            TAB: 9,
	            ENTER: 13,
	            ESCAPE: 27,
	            SPACE: 32,
	            DELETE: 46
	        },

	        parentElements: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre'],

	        defaults: function defaults(dest, source) {
	            return copyInto(dest, source);
	        },

	        extend: function extend(dest, source) {
	            return copyInto(dest, source, true);
	        },

	        derives: function derives(base, derived) {
	            var origPrototype = derived.prototype;
	            function Proto() { }
	            Proto.prototype = base.prototype;
	            derived.prototype = new Proto();
	            derived.prototype.constructor = base;
	            derived.prototype = copyInto(derived.prototype, origPrototype);
	            return derived;
	        },

	        // Find the next node in the DOM tree that represents any text that is being
	        // displayed directly next to the targetNode (passed as an argument)
	        // Text that appears directly next to the current node can be:
	        //  - A sibling text node
	        //  - A descendant of a sibling element
	        //  - A sibling text node of an ancestor
	        //  - A descendant of a sibling element of an ancestor
	        findAdjacentTextNodeWithContent: function findAdjacentTextNodeWithContent(rootNode, targetNode, ownerDocument) {
	            var pastTarget = false,
	                nextNode,
	                nodeIterator = ownerDocument.createNodeIterator(rootNode, NodeFilter.SHOW_TEXT, null, false);

	            // Use a native NodeIterator to iterate over all the text nodes that are descendants
	            // of the rootNode.  Once past the targetNode, choose the first non-empty text node
	            nextNode = nodeIterator.nextNode();
	            while (nextNode) {
	                if (nextNode === targetNode) {
	                    pastTarget = true;
	                } else if (pastTarget) {
	                    if (nextNode.nodeType === 3 && nextNode.nodeValue && nextNode.nodeValue.trim().length > 0) {
	                        break;
	                    }
	                }
	                nextNode = nodeIterator.nextNode();
	            }

	            return nextNode;
	        },

	        isDescendant: function isDescendant(parent, child) {
	            if (!parent || !child) {
	                return false;
	            }
	            var node = child.parentNode;
	            while (node !== null) {
	                if (node === parent) {
	                    return true;
	                }
	                node = node.parentNode;
	            }
	            return false;
	        },

	        // https://github.com/jashkenas/underscore
	        isElement: function isElement(obj) {
	            return !!(obj && obj.nodeType === 1);
	        },

	        now: function now() {
	            return Date.now || new Date().getTime();
	        },

	        // https://github.com/jashkenas/underscore
	        throttle: function throttle(func, wait) {
	            var THROTTLE_INTERVAL = 50,
	                context,
	                args,
	                result,
	                timeout = null,
	                previous = 0,
	                later;

	            if (!wait && wait !== 0) {
	                wait = THROTTLE_INTERVAL;
	            }

	            later = function () {
	                previous = mediumEditorUtil.now();
	                timeout = null;
	                result = func.apply(context, args);
	                if (!timeout) {
	                    context = args = null;
	                }
	            };

	            return function () {
	                var currNow = mediumEditorUtil.now(),
	                    remaining = wait - (currNow - previous);
	                context = this;
	                args = arguments;
	                if (remaining <= 0 || remaining > wait) {
	                    clearTimeout(timeout);
	                    timeout = null;
	                    previous = currNow;
	                    result = func.apply(context, args);
	                    if (!timeout) {
	                        context = args = null;
	                    }
	                } else if (!timeout) {
	                    timeout = setTimeout(later, remaining);
	                }
	                return result;
	            };
	        },

	        traverseUp: function (current, testElementFunction) {

	            do {
	                if (current.nodeType === 1) {
	                    if (testElementFunction(current)) {
	                        return current;
	                    }
	                    // do not traverse upwards past the nearest containing editor
	                    if (current.getAttribute('data-medium-element')) {
	                        return false;
	                    }
	                }

	                current = current.parentNode;
	            } while (current);

	            return false;

	        },

	        htmlEntities: function (str) {
	            // converts special characters (like <) into their escaped/encoded values (like &lt;).
	            // This allows you to show to display the string without the browser reading it as HTML.
	            return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	        },

	        // http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
	        insertHTMLCommand: function (doc, html) {
	            var selection, range, el, fragment, node, lastNode;

	            if (doc.queryCommandSupported('insertHTML')) {
	                try {
	                    return doc.execCommand('insertHTML', false, html);
	                } catch (ignore) {}
	            }

	            selection = window.getSelection();
	            if (selection.getRangeAt && selection.rangeCount) {
	                range = selection.getRangeAt(0);
	                range.deleteContents();

	                el = doc.createElement("div");
	                el.innerHTML = html;
	                fragment = doc.createDocumentFragment();
	                while (el.firstChild) {
	                    node = el.firstChild;
	                    lastNode = fragment.appendChild(node);
	                }
	                range.insertNode(fragment);

	                // Preserve the selection:
	                if (lastNode) {
	                    range = range.cloneRange();
	                    range.setStartAfter(lastNode);
	                    range.collapse(true);
	                    selection.removeAllRanges();
	                    selection.addRange(range);
	                }
	            }
	        },

	        // TODO: not sure if this should be here
	        setTargetBlank: function (el) {
	            var i;
	            if (el.tagName.toLowerCase() === 'a') {
	                el.target = '_blank';
	            } else {
	                el = el.getElementsByTagName('a');

	                for (i = 0; i < el.length; i += 1) {
	                    el[i].target = '_blank';
	                }
	            }
	        },

	        isListItemChild: function (node) {
	            var parentNode = node.parentNode,
	                tagName = parentNode.tagName.toLowerCase();
	            while (this.parentElements.indexOf(tagName) === -1 && tagName !== 'div') {
	                if (tagName === 'li') {
	                    return true;
	                }
	                parentNode = parentNode.parentNode;
	                if (parentNode && parentNode.tagName) {
	                    tagName = parentNode.tagName.toLowerCase();
	                } else {
	                    return false;
	                }
	            }
	            return false;
	        }
	    };
	}(window, document));

	var meSelection;

	(function (window, document) {
	    'use strict';

	    meSelection = {
	        // http://stackoverflow.com/questions/1197401/how-can-i-get-the-element-the-caret-is-in-with-javascript-when-using-contentedi
	        // by You
	        getSelectionStart: function (ownerDocument) {
	            var node = ownerDocument.getSelection().anchorNode,
	                startNode = (node && node.nodeType === 3 ? node.parentNode : node);
	            return startNode;
	        },

	        findMatchingSelectionParent: function (testElementFunction, contentWindow) {
	            var selection = contentWindow.getSelection(), range, current;

	            if (selection.rangeCount === 0) {
	                return false;
	            }

	            range = selection.getRangeAt(0);
	            current = range.commonAncestorContainer;

	            return mediumEditorUtil.traverseUp(current, testElementFunction);
	        },

	        getSelectionElement: function (contentWindow) {
	            return this.findMatchingSelectionParent(function (el) {
	                return el.getAttribute('data-medium-element');
	            }, contentWindow);
	        },

	        selectionInContentEditableFalse: function (contentWindow) {
	            return this.findMatchingSelectionParent(function (el) {
	                return (el && el.nodeName !== '#text' && el.getAttribute('contenteditable') === 'false');
	            }, contentWindow);
	        },

	        // http://stackoverflow.com/questions/4176923/html-of-selected-text
	        // by Tim Down
	        getSelectionHtml: function getSelectionHtml() {
	            var i,
	                html = '',
	                sel,
	                len,
	                container;
	            if (this.options.contentWindow.getSelection !== undefined) {
	                sel = this.options.contentWindow.getSelection();
	                if (sel.rangeCount) {
	                    container = this.options.ownerDocument.createElement('div');
	                    for (i = 0, len = sel.rangeCount; i < len; i += 1) {
	                        container.appendChild(sel.getRangeAt(i).cloneContents());
	                    }
	                    html = container.innerHTML;
	                }
	            } else if (this.options.ownerDocument.selection !== undefined) {
	                if (this.options.ownerDocument.selection.type === 'Text') {
	                    html = this.options.ownerDocument.selection.createRange().htmlText;
	                }
	            }
	            return html;
	        },

	        /**
	         *  Find the caret position within an element irrespective of any inline tags it may contain.
	         *
	         *  @param {DOMElement} An element containing the cursor to find offsets relative to.
	         *  @param {Range} A Range representing cursor position. Will window.getSelection if none is passed.
	         *  @return {Object} 'left' and 'right' attributes contain offsets from begining and end of Element
	         */
	        getCaretOffsets: function getCaretOffsets(element, range) {
	            var preCaretRange, postCaretRange;

	            if (!range) {
	                range = window.getSelection().getRangeAt(0);
	            }

	            preCaretRange = range.cloneRange();
	            postCaretRange = range.cloneRange();

	            preCaretRange.selectNodeContents(element);
	            preCaretRange.setEnd(range.endContainer, range.endOffset);

	            postCaretRange.selectNodeContents(element);
	            postCaretRange.setStart(range.endContainer, range.endOffset);

	            return {
	                left: preCaretRange.toString().length,
	                right: postCaretRange.toString().length
	            };
	        },

	        // http://stackoverflow.com/questions/15867542/range-object-get-selection-parent-node-chrome-vs-firefox
	        rangeSelectsSingleNode: function (range) {
	            var startNode = range.startContainer;
	            return startNode === range.endContainer &&
	                startNode.hasChildNodes() &&
	                range.endOffset === range.startOffset + 1;
	        },

	        getSelectedParentElement: function (range) {
	            var selectedParentElement = null;
	            if (this.rangeSelectsSingleNode(range) && range.startContainer.childNodes[range.startOffset].nodeType !== 3) {
	                selectedParentElement = range.startContainer.childNodes[range.startOffset];
	            } else if (range.startContainer.nodeType === 3) {
	                selectedParentElement = range.startContainer.parentNode;
	            } else {
	                selectedParentElement = range.startContainer;
	            }
	            return selectedParentElement;
	        },

	        getSelectionData: function (el) {
	            var tagName;

	            if (el && el.tagName) {
	                tagName = el.tagName.toLowerCase();
	            }

	            while (el && mediumEditorUtil.parentElements.indexOf(tagName) === -1) {
	                el = el.parentNode;
	                if (el && el.tagName) {
	                    tagName = el.tagName.toLowerCase();
	                }
	            }

	            return {
	                el: el,
	                tagName: tagName
	            };
	        }
	    };
	}(document, window));

	var DefaultButton,
	    ButtonsData;

	(function (window, document) {
	    'use strict';

	    ButtonsData = {
	        'bold': {
	            name: 'bold',
	            action: 'bold',
	            aria: 'bold',
	            tagNames: ['b', 'strong'],
	            style: {
	                prop: 'font-weight',
	                value: '700|bold'
	            },
	            useQueryState: true,
	            contentDefault: '<b>B</b>',
	            contentFA: '<i class="fa fa-bold"></i>',
	            key: 'b'
	        },
	        'italic': {
	            name: 'italic',
	            action: 'italic',
	            aria: 'italic',
	            tagNames: ['i', 'em'],
	            style: {
	                prop: 'font-style',
	                value: 'italic'
	            },
	            useQueryState: true,
	            contentDefault: '<b><i>I</i></b>',
	            contentFA: '<i class="fa fa-italic"></i>',
	            key: 'i'
	        },
	        'underline': {
	            name: 'underline',
	            action: 'underline',
	            aria: 'underline',
	            tagNames: ['u'],
	            style: {
	                prop: 'text-decoration',
	                value: 'underline'
	            },
	            useQueryState: true,
	            contentDefault: '<b><u>U</u></b>',
	            contentFA: '<i class="fa fa-underline"></i>',
	            key: 'u'
	        },
	        'strikethrough': {
	            name: 'strikethrough',
	            action: 'strikethrough',
	            aria: 'strike through',
	            tagNames: ['strike'],
	            style: {
	                prop: 'text-decoration',
	                value: 'line-through'
	            },
	            useQueryState: true,
	            contentDefault: '<s>A</s>',
	            contentFA: '<i class="fa fa-strikethrough"></i>'
	        },
	        'superscript': {
	            name: 'superscript',
	            action: 'superscript',
	            aria: 'superscript',
	            tagNames: ['sup'],
	            /* firefox doesn't behave the way we want it to, so we CAN'T use queryCommandState for superscript
	               https://github.com/guardian/scribe/blob/master/BROWSERINCONSISTENCIES.md#documentquerycommandstate */
	            // useQueryState: true
	            contentDefault: '<b>x<sup>1</sup></b>',
	            contentFA: '<i class="fa fa-superscript"></i>'
	        },
	        'subscript': {
	            name: 'subscript',
	            action: 'subscript',
	            aria: 'subscript',
	            tagNames: ['sub'],
	            /* firefox doesn't behave the way we want it to, so we CAN'T use queryCommandState for subscript
	               https://github.com/guardian/scribe/blob/master/BROWSERINCONSISTENCIES.md#documentquerycommandstate */
	            // useQueryState: true
	            contentDefault: '<b>x<sub>1</sub></b>',
	            contentFA: '<i class="fa fa-subscript"></i>'
	        },
	        'image': {
	            name: 'image',
	            action: 'image',
	            aria: 'image',
	            tagNames: ['img'],
	            contentDefault: '<b>image</b>',
	            contentFA: '<i class="fa fa-picture-o"></i>'
	        },
	        'quote': {
	            name: 'quote',
	            action: 'append-blockquote',
	            aria: 'blockquote',
	            tagNames: ['blockquote'],
	            contentDefault: '<b>&ldquo;</b>',
	            contentFA: '<i class="fa fa-quote-right"></i>'
	        },
	        'orderedlist': {
	            name: 'orderedlist',
	            action: 'insertorderedlist',
	            aria: 'ordered list',
	            tagNames: ['ol'],
	            useQueryState: true,
	            contentDefault: '<b>1.</b>',
	            contentFA: '<i class="fa fa-list-ol"></i>'
	        },
	        'unorderedlist': {
	            name: 'unorderedlist',
	            action: 'insertunorderedlist',
	            aria: 'unordered list',
	            tagNames: ['ul'],
	            useQueryState: true,
	            contentDefault: '<b>&bull;</b>',
	            contentFA: '<i class="fa fa-list-ul"></i>'
	        },
	        'pre': {
	            name: 'pre',
	            action: 'append-pre',
	            aria: 'preformatted text',
	            tagNames: ['pre'],
	            contentDefault: '<b>0101</b>',
	            contentFA: '<i class="fa fa-code fa-lg"></i>'
	        },
	        'indent': {
	            name: 'indent',
	            action: 'indent',
	            aria: 'indent',
	            tagNames: [],
	            contentDefault: '<b>&rarr;</b>',
	            contentFA: '<i class="fa fa-indent"></i>'
	        },
	        'outdent': {
	            name: 'outdent',
	            action: 'outdent',
	            aria: 'outdent',
	            tagNames: [],
	            contentDefault: '<b>&larr;</b>',
	            contentFA: '<i class="fa fa-outdent"></i>'
	        },
	        'justifyCenter': {
	            name: 'justifyCenter',
	            action: 'justifyCenter',
	            aria: 'center justify',
	            tagNames: [],
	            style: {
	                prop: 'text-align',
	                value: 'center'
	            },
	            useQueryState: true,
	            contentDefault: '<b>C</b>',
	            contentFA: '<i class="fa fa-align-center"></i>'
	        },
	        'justifyFull': {
	            name: 'justifyFull',
	            action: 'justifyFull',
	            aria: 'full justify',
	            tagNames: [],
	            style: {
	                prop: 'text-align',
	                value: 'justify'
	            },
	            useQueryState: true,
	            contentDefault: '<b>J</b>',
	            contentFA: '<i class="fa fa-align-justify"></i>'
	        },
	        'justifyLeft': {
	            name: 'justifyLeft',
	            action: 'justifyLeft',
	            aria: 'left justify',
	            tagNames: [],
	            style: {
	                prop: 'text-align',
	                value: 'left'
	            },
	            useQueryState: true,
	            contentDefault: '<b>L</b>',
	            contentFA: '<i class="fa fa-align-left"></i>'
	        },
	        'justifyRight': {
	            name: 'justifyRight',
	            action: 'justifyRight',
	            aria: 'right justify',
	            tagNames: [],
	            style: {
	                prop: 'text-align',
	                value: 'right'
	            },
	            useQueryState: true,
	            contentDefault: '<b>R</b>',
	            contentFA: '<i class="fa fa-align-right"></i>'
	        },
	        'header1': {
	            name: 'header1',
	            action: function (options) {
	                return 'append-' + options.firstHeader;
	            },
	            aria: function (options) {
	                return options.firstHeader;
	            },
	            tagNames: function (options) {
	                return [options.firstHeader];
	            },
	            contentDefault: '<b>H1</b>'
	        },
	        'header2': {
	            name: 'header2',
	            action: function (options) {
	                return 'append-' + options.secondHeader;
	            },
	            aria: function (options) {
	                return options.secondHeader;
	            },
	            tagNames: function (options) {
	                return [options.secondHeader];
	            },
	            contentDefault: '<b>H2</b>'
	        }
	    };

	    DefaultButton = function (options, instance) {
	        this.options = options;
	        this.name = options.name;
	        this.init(instance);
	    };

	    DefaultButton.prototype = {
	        init: function (instance) {
	            this.base = instance;

	            this.button = this.createButton();
	            this.base.on(this.button, 'click', this.handleClick.bind(this));
	        },
	        getButton: function () {
	            return this.button;
	        },
	        getAction: function () {
	            return (typeof this.options.action === 'function') ? this.options.action(this.base.options) : this.options.action;
	        },
	        getAria: function () {
	            return (typeof this.options.aria === 'function') ? this.options.aria(this.base.options) : this.options.aria;
	        },
	        getTagNames: function () {
	            return (typeof this.options.tagNames === 'function') ? this.options.tagNames(this.base.options) : this.options.tagNames;
	        },
	        createButton: function () {
	            var button = this.base.options.ownerDocument.createElement('button'),
	                content = this.options.contentDefault;
	            button.classList.add('medium-editor-action');
	            button.classList.add('medium-editor-action-' + this.name);
	            button.setAttribute('data-action', this.getAction());
	            button.setAttribute('aria-label', this.getAria());
	            if (this.base.options.buttonLabels) {
	                if (this.base.options.buttonLabels === 'fontawesome' && this.options.contentFA) {
	                    content = this.options.contentFA;
	                } else if (typeof this.base.options.buttonLabels === 'object' && this.base.options.buttonLabels[this.name]) {
	                    content = this.base.options.buttonLabels[this.options.name];
	                }
	            }
	            button.innerHTML = content;
	            return button;
	        },
	        handleClick: function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();

	            var action = this.getAction();

	            if (action) {
	                this.base.execAction(action);
	            }
	        },
	        isActive: function () {
	            return this.button.classList.contains(this.base.options.activeButtonClass);
	        },
	        setInactive: function () {
	            this.button.classList.remove(this.base.options.activeButtonClass);
	            delete this.knownState;
	        },
	        setActive: function () {
	            this.button.classList.add(this.base.options.activeButtonClass);
	            delete this.knownState;
	        },
	        queryCommandState: function () {
	            var queryState = null;
	            if (this.options.useQueryState) {
	                try {
	                    queryState = this.base.options.ownerDocument.queryCommandState(this.getAction());
	                } catch (exc) {
	                    queryState = null;
	                }
	            }
	            return queryState;
	        },
	        isAlreadyApplied: function (node) {
	            var isMatch = false,
	                tagNames = this.getTagNames(),
	                styleVals,
	                computedStyle;

	            if (this.knownState === false || this.knownState === true) {
	                return this.knownState;
	            }

	            if (tagNames && tagNames.length > 0 && node.tagName) {
	                isMatch = tagNames.indexOf(node.tagName.toLowerCase()) !== -1;
	            }

	            if (!isMatch && this.options.style) {
	                styleVals = this.options.style.value.split('|');
	                computedStyle = this.base.options.contentWindow.getComputedStyle(node, null).getPropertyValue(this.options.style.prop);
	                styleVals.forEach(function (val) {
	                    if (!this.knownState) {
	                        this.knownState = isMatch = (computedStyle.indexOf(val) !== -1);
	                    }
	                }.bind(this));
	            }

	            return isMatch;
	        }
	    };
	}(window, document));

	var pasteHandler;

	(function (window, document) {
	    'use strict';
	    /*jslint regexp: true*/
	    /*
	        jslint does not allow character negation, because the negation
	        will not match any unicode characters. In the regexes in this
	        block, negation is used specifically to match the end of an html
	        tag, and in fact unicode characters *should* be allowed.
	    */
	    function createReplacements() {
	        return [

	            // replace two bogus tags that begin pastes from google docs
	            [new RegExp(/<[^>]*docs-internal-guid[^>]*>/gi), ""],
	            [new RegExp(/<\/b>(<br[^>]*>)?$/gi), ""],

	             // un-html spaces and newlines inserted by OS X
	            [new RegExp(/<span class="Apple-converted-space">\s+<\/span>/g), ' '],
	            [new RegExp(/<br class="Apple-interchange-newline">/g), '<br>'],

	            // replace google docs italics+bold with a span to be replaced once the html is inserted
	            [new RegExp(/<span[^>]*(font-style:italic;font-weight:bold|font-weight:bold;font-style:italic)[^>]*>/gi), '<span class="replace-with italic bold">'],

	            // replace google docs italics with a span to be replaced once the html is inserted
	            [new RegExp(/<span[^>]*font-style:italic[^>]*>/gi), '<span class="replace-with italic">'],

	            //[replace google docs bolds with a span to be replaced once the html is inserted
	            [new RegExp(/<span[^>]*font-weight:bold[^>]*>/gi), '<span class="replace-with bold">'],

	             // replace manually entered b/i/a tags with real ones
	            [new RegExp(/&lt;(\/?)(i|b|a)&gt;/gi), '<$1$2>'],

	             // replace manually a tags with real ones, converting smart-quotes from google docs
	            [new RegExp(/&lt;a\s+href=(&quot;|&rdquo;|&ldquo;|“|”)([^&]+)(&quot;|&rdquo;|&ldquo;|“|”)&gt;/gi), '<a href="$2">']

	        ];
	    }
	    /*jslint regexp: false*/

	    pasteHandler = {
	        handlePaste: function (element, evt, options) {
	            var paragraphs,
	                html = '',
	                p,
	                dataFormatHTML = 'text/html',
	                dataFormatPlain = 'text/plain';

	            element.classList.remove('medium-editor-placeholder');
	            if (!options.forcePlainText && !options.cleanPastedHTML) {
	                return element;
	            }

	            if (options.contentWindow.clipboardData && evt.clipboardData === undefined) {
	                evt.clipboardData = options.contentWindow.clipboardData;
	                // If window.clipboardData exists, but e.clipboardData doesn't exist,
	                // we're probably in IE. IE only has two possibilities for clipboard
	                // data format: 'Text' and 'URL'.
	                //
	                // Of the two, we want 'Text':
	                dataFormatHTML = 'Text';
	                dataFormatPlain = 'Text';
	            }

	            if (evt.clipboardData && evt.clipboardData.getData && !evt.defaultPrevented) {
	                evt.preventDefault();

	                if (options.cleanPastedHTML && evt.clipboardData.getData(dataFormatHTML)) {
	                    return this.cleanPaste(evt.clipboardData.getData(dataFormatHTML), options);
	                }
	                if (!(options.disableReturn || element.getAttribute('data-disable-return'))) {
	                    paragraphs = evt.clipboardData.getData(dataFormatPlain).split(/[\r\n]/g);
	                    for (p = 0; p < paragraphs.length; p += 1) {
	                        if (paragraphs[p] !== '') {
	                            html += '<p>' + mediumEditorUtil.htmlEntities(paragraphs[p]) + '</p>';
	                        }
	                    }
	                    mediumEditorUtil.insertHTMLCommand(options.ownerDocument, html);
	                } else {
	                    html = mediumEditorUtil.htmlEntities(evt.clipboardData.getData(dataFormatPlain));
	                    mediumEditorUtil.insertHTMLCommand(options.ownerDocument, html);
	                }
	            }
	        },

	        cleanPaste: function (text, options) {
	            var i, elList, workEl,
	                el = meSelection.getSelectionElement(options.contentWindow),
	                multiline = /<p|<br|<div/.test(text),
	                replacements = createReplacements();

	            for (i = 0; i < replacements.length; i += 1) {
	                text = text.replace(replacements[i][0], replacements[i][1]);
	            }

	            if (multiline) {
	                // double br's aren't converted to p tags, but we want paragraphs.
	                elList = text.split('<br><br>');

	                this.pasteHTML('<p>' + elList.join('</p><p>') + '</p>', options.ownerDocument);

	                try {
	                    options.ownerDocument.execCommand('insertText', false, "\n");
	                } catch (ignore) { }

	                // block element cleanup
	                elList = el.querySelectorAll('a,p,div,br');
	                for (i = 0; i < elList.length; i += 1) {
	                    workEl = elList[i];

	                    switch (workEl.tagName.toLowerCase()) {
	                    case 'a':
	                        if (options.targetBlank) {
	                            mediumEditorUtil.setTargetBlank(workEl);
	                        }
	                        break;
	                    case 'p':
	                    case 'div':
	                        this.filterCommonBlocks(workEl);
	                        break;
	                    case 'br':
	                        this.filterLineBreak(workEl);
	                        break;
	                    }
	                }
	            } else {
	                this.pasteHTML(text, options.ownerDocument);
	            }
	        },

	        pasteHTML: function (html, ownerDocument) {
	            var elList, workEl, i, fragmentBody, pasteBlock = ownerDocument.createDocumentFragment();

	            pasteBlock.appendChild(ownerDocument.createElement('body'));

	            fragmentBody = pasteBlock.querySelector('body');
	            fragmentBody.innerHTML = html;

	            this.cleanupSpans(fragmentBody, ownerDocument);

	            elList = fragmentBody.querySelectorAll('*');
	            for (i = 0; i < elList.length; i += 1) {
	                workEl = elList[i];

	                // delete ugly attributes
	                workEl.removeAttribute('class');
	                workEl.removeAttribute('style');
	                workEl.removeAttribute('dir');

	                if (workEl.tagName.toLowerCase() === 'meta') {
	                    workEl.parentNode.removeChild(workEl);
	                }
	            }
	            mediumEditorUtil.insertHTMLCommand(ownerDocument, fragmentBody.innerHTML.replace(/&nbsp;/g, ' '));
	        },
	        isCommonBlock: function (el) {
	            return (el && (el.tagName.toLowerCase() === 'p' || el.tagName.toLowerCase() === 'div'));
	        },
	        filterCommonBlocks: function (el) {
	            if (/^\s*$/.test(el.textContent)) {
	                el.parentNode.removeChild(el);
	            }
	        },
	        filterLineBreak: function (el) {
	            if (this.isCommonBlock(el.previousElementSibling)) {
	                // remove stray br's following common block elements
	                el.parentNode.removeChild(el);
	            } else if (this.isCommonBlock(el.parentNode) && (el.parentNode.firstChild === el || el.parentNode.lastChild === el)) {
	                // remove br's just inside open or close tags of a div/p
	                el.parentNode.removeChild(el);
	            } else if (el.parentNode.childElementCount === 1 && el.parentNode.textContent === '') {
	                // and br's that are the only child of a div/p
	                this.removeWithParent(el);
	            }

	        },

	        // remove an element, including its parent, if it is the only element within its parent
	        removeWithParent: function (el) {
	            if (el && el.parentNode) {
	                if (el.parentNode.parentNode && el.parentNode.childElementCount === 1) {
	                    el.parentNode.parentNode.removeChild(el.parentNode);
	                } else {
	                    el.parentNode.removeChild(el.parentNode);
	                }
	            }
	        },

	        cleanupSpans: function (container_el, ownerDocument) {
	            var i,
	                el,
	                new_el,
	                spans = container_el.querySelectorAll('.replace-with'),
	                isCEF = function (el) {
	                    return (el && el.nodeName !== '#text' && el.getAttribute('contenteditable') === 'false');
	                };

	            for (i = 0; i < spans.length; i += 1) {
	                el = spans[i];
	                new_el = ownerDocument.createElement(el.classList.contains('bold') ? 'b' : 'i');

	                if (el.classList.contains('bold') && el.classList.contains('italic')) {
	                    // add an i tag as well if this has both italics and bold
	                    new_el.innerHTML = '<i>' + el.innerHTML + '</i>';
	                } else {
	                    new_el.innerHTML = el.innerHTML;
	                }
	                el.parentNode.replaceChild(new_el, el);
	            }

	            spans = container_el.querySelectorAll('span');
	            for (i = 0; i < spans.length; i += 1) {
	                el = spans[i];

	                // bail if span is in contenteditable = false
	                if (mediumEditorUtil.traverseUp(el, isCEF)) {
	                    return false;
	                }

	                // remove empty spans, replace others with their contents
	                if (/^\s*$/.test()) {
	                    el.parentNode.removeChild(el);
	                } else {
	                    el.parentNode.replaceChild(ownerDocument.createTextNode(el.textContent), el);
	                }
	            }
	        }
	    };
	}(window, document));

	var AnchorExtension;

	(function (window, document) {
	    'use strict';

	    function AnchorDerived() {
	        this.parent = true;
	        this.options = {
	            name: 'anchor',
	            action: 'createLink',
	            aria: 'link',
	            tagNames: ['a'],
	            contentDefault: '<b>#</b>',
	            contentFA: '<i class="fa fa-link"></i>'
	        };
	        this.name = 'anchor';
	        this.hasForm = true;
	    }

	    AnchorDerived.prototype = {

	        // Button and Extension handling

	        // Called when the button the toolbar is clicked
	        // Overrides DefaultButton.handleClick
	        handleClick: function (evt) {
	            evt.preventDefault();
	            evt.stopPropagation();

	            if (!this.base.selection) {
	                this.base.checkSelection();
	            }

	            var selectedParentElement = meSelection.getSelectedParentElement(this.base.selectionRange);
	            if (selectedParentElement.tagName &&
	                    selectedParentElement.tagName.toLowerCase() === 'a') {
	                return this.base.execAction('unlink');
	            }

	            if (!this.isDisplayed()) {
	                this.showForm();
	            }

	            return false;
	        },

	        // Called by medium-editor to append form to the toolbar
	        getForm: function () {
	            if (!this.anchorForm) {
	                this.anchorForm = this.createForm();
	            }
	            return this.anchorForm;
	        },

	        // Used by medium-editor when the default toolbar is to be displayed
	        isDisplayed: function () {
	            return this.getForm().style.display === 'block';
	        },

	        hideForm: function () {
	            this.getForm().style.display = 'none';
	            this.getInput().value = '';
	        },

	        showForm: function (link_value) {
	            var input = this.getInput();

	            this.base.saveSelection();
	            this.base.hideToolbarDefaultActions();
	            this.getForm().style.display = 'block';
	            this.base.setToolbarPosition();
	            this.base.keepToolbarAlive = true;

	            input.value = link_value || '';
	            input.focus();
	        },

	        // Called by core when tearing down medium-editor (deactivate)
	        deactivate: function () {
	            if (!this.anchorForm) {
	                return false;
	            }

	            if (this.anchorForm.parentNode) {
	                this.anchorForm.parentNode.removeChild(this.anchorForm);
	            }

	            delete this.anchorForm;
	        },

	        // core methods

	        doLinkCreation: function () {
	            var targetCheckbox = this.getForm().querySelector('.medium-editor-toolbar-anchor-target'),
	                buttonCheckbox = this.getForm().querySelector('.medium-editor-toolbar-anchor-button'),
	                opts = {
	                    url: this.getInput().value
	                };

	            this.base.restoreSelection();

	            if (this.base.options.checkLinkFormat) {
	                opts.url = this.checkLinkFormat(opts.url);
	            }

	            if (targetCheckbox && targetCheckbox.checked) {
	                opts.target = "_blank";
	            } else {
	                opts.target = "_self";
	            }

	            if (buttonCheckbox && buttonCheckbox.checked) {
	                opts.buttonClass = this.base.options.anchorButtonClass;
	            }

	            this.base.createLink(opts);
	            this.base.keepToolbarAlive = false;
	            this.base.checkSelection();
	        },

	        checkLinkFormat: function (value) {
	            var re = /^(https?|ftps?|rtmpt?):\/\/|mailto:/;
	            return (re.test(value) ? '' : 'http://') + value;
	        },

	        doFormCancel: function () {
	            this.base.restoreSelection();
	            this.base.keepToolbarAlive = false;
	            this.base.checkSelection();
	        },

	        // form creation and event handling

	        createForm: function () {
	            var doc = this.base.options.ownerDocument,
	                form = doc.createElement('div'),
	                input = doc.createElement('input'),
	                close = doc.createElement('a'),
	                save = doc.createElement('a'),
	                target,
	                target_label,
	                button,
	                button_label;

	            // Anchor Form (div)
	            form.className = 'medium-editor-toolbar-form';
	            form.id = 'medium-editor-toolbar-form-anchor-' + this.base.id;

	            // Handle clicks on the form itself
	            this.base.on(form, 'click', this.handleFormClick.bind(this));

	            // Add url textbox
	            input.setAttribute('type', 'text');
	            input.className = 'medium-editor-toolbar-input';
	            input.setAttribute('placeholder', this.base.options.anchorInputPlaceholder);
	            form.appendChild(input);

	            // Handle typing in the textbox
	            this.base.on(input, 'keyup', this.handleTextboxKeyup.bind(this));

	            // Handle clicks into the textbox
	            this.base.on(input, 'click', this.handleFormClick.bind(this));

	            // Add save buton
	            save.setAttribute('href', '#');
	            save.className = 'medium-editor-toobar-save';
	            save.innerHTML = this.base.options.buttonLabels === 'fontawesome' ?
	                             '<i class="fa fa-check"></i>' :
	                             '&#10003;';
	            form.appendChild(save);

	            // Handle save button clicks (capture)
	            this.base.on(save, 'click', this.handleSaveClick.bind(this), true);

	            // Add close button
	            close.setAttribute('href', '#');
	            close.className = 'medium-editor-toobar-close';
	            close.innerHTML = this.base.options.buttonLabels === 'fontawesome' ?
	                              '<i class="fa fa-times"></i>' :
	                              '&times;';
	            form.appendChild(close);

	            // Handle close button clicks
	            this.base.on(close, 'click', this.handleCloseClick.bind(this));

	            // (Optional) Add 'open in new window' checkbox
	            if (this.base.options.anchorTarget) {
	                target = doc.createElement('input');
	                target.setAttribute('type', 'checkbox');
	                target.className = 'medium-editor-toolbar-anchor-target';

	                target_label = doc.createElement('label');
	                target_label.innerHTML = this.base.options.anchorInputCheckboxLabel;
	                target_label.insertBefore(target, target_label.firstChild);

	                form.appendChild(target_label);
	            }

	            // (Optional) Add 'add button class to anchor' checkbox
	            if (this.base.options.anchorButton) {
	                button = doc.createElement('input');
	                button.setAttribute('type', 'checkbox');
	                button.className = 'medium-editor-toolbar-anchor-button';

	                button_label = doc.createElement('label');
	                button_label.innerHTML = "Button";
	                button_label.insertBefore(button, button_label.firstChild);

	                form.appendChild(button_label);
	            }

	            // Handle click (capture) & focus (capture) outside of the form
	            this.base.on(doc.body, 'click', this.handleOutsideInteraction.bind(this), true);
	            this.base.on(doc.body, 'focus', this.handleOutsideInteraction.bind(this), true);

	            return form;
	        },

	        getInput: function () {
	            return this.getForm().querySelector('input.medium-editor-toolbar-input');
	        },

	        handleOutsideInteraction: function (event) {
	            if (event.target !== this.getForm() &&
	                    !mediumEditorUtil.isDescendant(this.getForm(), event.target) &&
	                    !mediumEditorUtil.isDescendant(this.base.toolbarActions, event.target)) {
	                this.base.keepToolbarAlive = false;
	                this.base.checkSelection();
	            }
	        },

	        handleTextboxKeyup: function (event) {
	            // For ENTER -> create the anchor
	            if (event.keyCode === mediumEditorUtil.keyCode.ENTER) {
	                event.preventDefault();
	                this.doLinkCreation();
	                return;
	            }

	            // For ESCAPE -> close the form
	            if (event.keyCode === mediumEditorUtil.keyCode.ESCAPE) {
	                event.preventDefault();
	                this.doFormCancel();
	            }
	        },

	        handleFormClick: function (event) {
	            // make sure not to hide form when clicking inside the form
	            event.stopPropagation();
	            this.base.keepToolbarAlive = true;
	        },

	        handleSaveClick: function (event) {
	            // Clicking Save -> create the anchor
	            event.preventDefault();
	            this.doLinkCreation();
	        },

	        handleCloseClick: function (event) {
	            // Click Close -> close the form
	            event.preventDefault();
	            this.doFormCancel();
	        }
	    };

	    AnchorExtension = mediumEditorUtil.derives(DefaultButton, AnchorDerived);
	}(window, document));

	function MediumEditor(elements, options) {
	    'use strict';
	    return this.init(elements, options);
	}

	(function () {
	    'use strict';

	    MediumEditor.statics = {
	        ButtonsData: ButtonsData,
	        DefaultButton: DefaultButton,
	        AnchorExtension: AnchorExtension
	    };

	    MediumEditor.prototype = {
	        defaults: {
	            allowMultiParagraphSelection: true,
	            anchorInputPlaceholder: 'Paste or type a link',
	            anchorInputCheckboxLabel: 'Open in new window',
	            anchorPreviewHideDelay: 500,
	            buttons: ['bold', 'italic', 'underline', 'anchor', 'header1', 'header2', 'quote'],
	            buttonLabels: false,
	            checkLinkFormat: false,
	            cleanPastedHTML: false,
	            delay: 0,
	            diffLeft: 0,
	            diffTop: -10,
	            disableReturn: false,
	            disableDoubleReturn: false,
	            disableToolbar: false,
	            disableEditing: false,
	            disablePlaceholders: false,
	            elementsContainer: false,
	            imageDragging: true,
	            standardizeSelectionStart: false,
	            contentWindow: window,
	            ownerDocument: document,
	            firstHeader: 'h3',
	            forcePlainText: true,
	            placeholder: 'Type your text',
	            secondHeader: 'h4',
	            targetBlank: false,
	            anchorTarget: false,
	            anchorButton: false,
	            anchorButtonClass: 'btn',
	            extensions: {},
	            activeButtonClass: 'medium-editor-button-active',
	            firstButtonClass: 'medium-editor-button-first',
	            lastButtonClass: 'medium-editor-button-last'
	        },

	        init: function (elements, options) {
	            var uniqueId = 1;

	            this.options = mediumEditorUtil.defaults(options, this.defaults);
	            this.setElementSelection(elements);
	            if (this.elements.length === 0) {
	                return;
	            }

	            if (!this.options.elementsContainer) {
	                this.options.elementsContainer = this.options.ownerDocument.body;
	            }

	            while (this.options.elementsContainer.querySelector('#medium-editor-toolbar-' + uniqueId)) {
	                uniqueId = uniqueId + 1;
	            }

	            this.id = uniqueId;

	            return this.setup();
	        },

	        setup: function () {
	            this.events = [];
	            this.isActive = true;
	            this.initThrottledMethods()
	                .initCommands()
	                .initElements()
	                .bindSelect()
	                .bindDragDrop()
	                .bindPaste()
	                .setPlaceholders()
	                .bindElementActions()
	                .bindWindowActions();
	        },

	        on: function (target, event, listener, useCapture) {
	            target.addEventListener(event, listener, useCapture);
	            this.events.push([target, event, listener, useCapture]);
	        },

	        off: function (target, event, listener, useCapture) {
	            var index = this.indexOfListener(target, event, listener, useCapture),
	                e;
	            if (index !== -1) {
	                e = this.events.splice(index, 1)[0];
	                e[0].removeEventListener(e[1], e[2], e[3]);
	            }
	        },

	        indexOfListener: function (target, event, listener, useCapture) {
	            var i, n, item;
	            for (i = 0, n = this.events.length; i < n; i = i + 1) {
	                item = this.events[i];
	                if (item[0] === target && item[1] === event && item[2] === listener && item[3] === useCapture) {
	                    return i;
	                }
	            }
	            return -1;
	        },

	        delay: function (fn) {
	            var self = this;
	            setTimeout(function () {
	                if (self.isActive) {
	                    fn();
	                }
	            }, this.options.delay);
	        },

	        removeAllEvents: function () {
	            var e = this.events.pop();
	            while (e) {
	                e[0].removeEventListener(e[1], e[2], e[3]);
	                e = this.events.pop();
	            }
	        },

	        initThrottledMethods: function () {
	            var self = this;

	            // handleResize is throttled because:
	            // - It will be called when the browser is resizing, which can fire many times very quickly
	            // - For some event (like resize) a slight lag in UI responsiveness is OK and provides performance benefits
	            this.handleResize = mediumEditorUtil.throttle(function () {
	                if (self.isActive) {
	                    self.positionToolbarIfShown();
	                }
	            });

	            // handleBlur is throttled because:
	            // - This method could be called many times due to the type of event handlers that are calling it
	            // - We want a slight delay so that other events in the stack can run, some of which may
	            //   prevent the toolbar from being hidden (via this.keepToolbarAlive).
	            this.handleBlur = mediumEditorUtil.throttle(function () {
	                if (self.isActive && !self.keepToolbarAlive) {
	                    self.hideToolbarActions();
	                }
	            });

	            return this;
	        },

	        initElements: function () {
	            var i,
	                addToolbar = false;
	            for (i = 0; i < this.elements.length; i += 1) {
	                if (!this.options.disableEditing && !this.elements[i].getAttribute('data-disable-editing')) {
	                    this.elements[i].setAttribute('contentEditable', true);
	                }
	                if (!this.elements[i].getAttribute('data-placeholder')) {
	                    this.elements[i].setAttribute('data-placeholder', this.options.placeholder);
	                }
	                this.elements[i].setAttribute('data-medium-element', true);
	                this.elements[i].setAttribute('role', 'textbox');
	                this.elements[i].setAttribute('aria-multiline', true);
	                this.bindParagraphCreation(i);
	                if (!this.options.disableToolbar && !this.elements[i].getAttribute('data-disable-toolbar')) {
	                    addToolbar = true;
	                }
	            }
	            // Init toolbar
	            if (addToolbar) {
	                this.initToolbar()
	                    .setFirstAndLastButtons()
	                    .bindAnchorPreview();
	            }
	            return this;
	        },

	        setElementSelection: function (selector) {
	            if (!selector) {
	                selector = [];
	            }
	            // If string, use as query selector
	            if (typeof selector === 'string') {
	                selector = this.options.ownerDocument.querySelectorAll(selector);
	            }
	            // If element, put into array
	            if (mediumEditorUtil.isElement(selector)) {
	                selector = [selector];
	            }
	            // Convert NodeList (or other array like object) into an array
	            this.elements = Array.prototype.slice.apply(selector);
	        },

	        bindBlur: function () {
	            var self = this,
	                blurFunction = function (e) {
	                    var isDescendantOfEditorElements = false,
	                        selection = self.options.contentWindow.getSelection(),
	                        selRange = selection.isCollapsed ?
	                                   null :
	                                   meSelection.getSelectedParentElement(selection.getRangeAt(0)),
	                        i;

	                    // This control was introduced also to avoid the toolbar
	                    // to disapper when selecting from right to left and
	                    // the selection ends at the beginning of the text.
	                    for (i = 0; i < self.elements.length; i += 1) {
	                        if (mediumEditorUtil.isDescendant(self.elements[i], e.target)
	                                || mediumEditorUtil.isDescendant(self.elements[i], selRange)) {
	                            isDescendantOfEditorElements = true;
	                            break;
	                        }
	                    }
	                    // If it's not part of the editor, or the toolbar
	                    if (e.target !== self.toolbar
	                            && self.elements.indexOf(e.target) === -1
	                            && !isDescendantOfEditorElements
	                            && !mediumEditorUtil.isDescendant(self.toolbar, e.target)
	                            && !mediumEditorUtil.isDescendant(self.anchorPreview, e.target)) {

	                        // Activate the placeholder
	                        if (!self.options.disablePlaceholders) {
	                            self.placeholderWrapper(e, self.elements[0]);
	                        }

	                        // Hide the toolbar after a small delay so we can prevent this on toolbar click
	                        self.handleBlur();
	                    }
	                };

	            // Hide the toolbar when focusing outside of the editor.
	            this.on(this.options.ownerDocument.body, 'click', blurFunction, true);
	            this.on(this.options.ownerDocument.body, 'focus', blurFunction, true);

	            return this;
	        },

	        bindClick: function (i) {
	            var self = this;

	            this.on(this.elements[i], 'click', function () {
	                if (!self.options.disablePlaceholders) {
	                    // Remove placeholder
	                    this.classList.remove('medium-editor-placeholder');
	                }

	                if (self.options.staticToolbar) {
	                    self.setToolbarPosition();
	                }
	            });

	            return this;
	        },

	        /**
	         * This handles blur and keypress events on elements
	         * Including Placeholders, and tooldbar hiding on blur
	         */
	        bindElementActions: function () {
	            var i;

	            for (i = 0; i < this.elements.length; i += 1) {

	                if (!this.options.disablePlaceholders) {
	                    // Active all of the placeholders
	                    this.activatePlaceholder(this.elements[i]);
	                }

	                // Bind the return and tab keypress events
	                this.bindReturn(i)
	                    .bindKeydown(i)
	                    .bindClick(i);
	            }

	            return this;
	        },

	        // Two functions to handle placeholders
	        activatePlaceholder:  function (el) {
	            if (!(el.querySelector('img')) &&
	                    !(el.querySelector('blockquote')) &&
	                    el.textContent.replace(/^\s+|\s+$/g, '') === '') {

	                el.classList.add('medium-editor-placeholder');
	            }
	        },
	        placeholderWrapper: function (evt, el) {
	            el = el || evt.target;
	            el.classList.remove('medium-editor-placeholder');
	            if (evt.type !== 'keypress') {
	                this.activatePlaceholder(el);
	            }
	        },

	        serialize: function () {
	            var i,
	                elementid,
	                content = {};
	            for (i = 0; i < this.elements.length; i += 1) {
	                elementid = (this.elements[i].id !== '') ? this.elements[i].id : 'element-' + i;
	                content[elementid] = {
	                    value: this.elements[i].innerHTML.trim()
	                };
	            }
	            return content;
	        },

	        initExtension: function (extension, name) {
	            if (extension.parent) {
	                extension.base = this;
	            }
	            if (typeof extension.init === 'function') {
	                extension.init(this);
	            }
	            if (!extension.name) {
	                extension.name = name;
	            }
	            return extension;
	        },

	        initCommands: function () {
	            var buttons = this.options.buttons,
	                extensions = this.options.extensions,
	                ext,
	                name;
	            this.commands = [];

	            buttons.forEach(function (buttonName) {
	                if (extensions[buttonName]) {
	                    ext = this.initExtension(extensions[buttonName], buttonName);
	                    this.commands.push(ext);
	                } else if (buttonName === 'anchor') {
	                    ext = this.initExtension(new AnchorExtension(), buttonName);
	                    this.commands.push(ext);
	                } else if (ButtonsData.hasOwnProperty(buttonName)) {
	                    ext = new DefaultButton(ButtonsData[buttonName], this);
	                    this.commands.push(ext);
	                }
	            }.bind(this));

	            for (name in extensions) {
	                if (extensions.hasOwnProperty(name) && buttons.indexOf(name) === -1) {
	                    ext = this.initExtension(extensions[name], name);
	                }
	            }

	            return this;
	        },

	        getExtensionByName: function (name) {
	            var extension;
	            if (this.commands && this.commands.length) {
	                this.commands.forEach(function (ext) {
	                    if (ext.name === name) {
	                        extension = ext;
	                    }
	                });
	            }
	            return extension;
	        },

	        /**
	         * Helper function to call a method with a number of parameters on all registered extensions.
	         * The function assures that the function exists before calling.
	         *
	         * @param {string} funcName name of the function to call
	         * @param [args] arguments passed into funcName
	         */
	        callExtensions: function (funcName) {
	            if (arguments.length < 1) {
	                return;
	            }

	            var args = Array.prototype.slice.call(arguments, 1),
	                ext,
	                name;

	            for (name in this.options.extensions) {
	                if (this.options.extensions.hasOwnProperty(name)) {
	                    ext = this.options.extensions[name];
	                    if (ext[funcName] !== undefined) {
	                        ext[funcName].apply(ext, args);
	                    }
	                }
	            }
	            return this;
	        },

	        bindParagraphCreation: function (index) {
	            var self = this;
	            this.on(this.elements[index], 'keypress', function (e) {
	                var node,
	                    tagName;
	                if (e.which === mediumEditorUtil.keyCode.SPACE) {
	                    node = meSelection.getSelectionStart(self.options.ownerDocument);
	                    tagName = node.tagName.toLowerCase();
	                    if (tagName === 'a') {
	                        self.options.ownerDocument.execCommand('unlink', false, null);
	                    }
	                }
	            });

	            this.on(this.elements[index], 'keyup', function (e) {
	                var node = meSelection.getSelectionStart(self.options.ownerDocument),
	                    tagName,
	                    editorElement;

	                if (node && node.getAttribute('data-medium-element') && node.children.length === 0 && !(self.options.disableReturn || node.getAttribute('data-disable-return'))) {
	                    self.options.ownerDocument.execCommand('formatBlock', false, 'p');
	                }
	                if (e.which === mediumEditorUtil.keyCode.ENTER) {
	                    node = meSelection.getSelectionStart(self.options.ownerDocument);
	                    tagName = node.tagName.toLowerCase();
	                    editorElement = meSelection.getSelectionElement(self.options.contentWindow);

	                    if (!(self.options.disableReturn || editorElement.getAttribute('data-disable-return')) &&
	                            tagName !== 'li' && !mediumEditorUtil.isListItemChild(node)) {
	                        if (!e.shiftKey) {

	                            // paragraph creation should not be forced within a header tag
	                            if (!/h\d/.test(tagName)) {
	                                self.options.ownerDocument.execCommand('formatBlock', false, 'p');
	                            }
	                        }
	                        if (tagName === 'a') {
	                            self.options.ownerDocument.execCommand('unlink', false, null);
	                        }
	                    }
	                }
	            });
	            return this;
	        },

	        bindReturn: function (index) {
	            var self = this;
	            this.on(this.elements[index], 'keypress', function (e) {
	                if (e.which === mediumEditorUtil.keyCode.ENTER) {
	                    if (self.options.disableReturn || this.getAttribute('data-disable-return')) {
	                        e.preventDefault();
	                    } else if (self.options.disableDoubleReturn || this.getAttribute('data-disable-double-return')) {
	                        var node = meSelection.getSelectionStart(self.options.contentWindow);
	                        if (node && node.textContent.trim() === '') {
	                            e.preventDefault();
	                        }
	                    }
	                }
	            });
	            return this;
	        },

	        bindKeydown: function (index) {
	            var self = this;
	            this.on(this.elements[index], 'keydown', function (e) {
	                var node, tag, key;

	                if (e.which === mediumEditorUtil.keyCode.TAB) {
	                    // Override tab only for pre nodes
	                    node = meSelection.getSelectionStart(self.options.ownerDocument);
	                    tag = node && node.tagName.toLowerCase();

	                    if (tag === 'pre') {
	                        e.preventDefault();
	                        self.options.ownerDocument.execCommand('insertHtml', null, '    ');
	                    }

	                    // Tab to indent list structures!
	                    if (tag === 'li' || mediumEditorUtil.isListItemChild(node)) {
	                        e.preventDefault();

	                        // If Shift is down, outdent, otherwise indent
	                        if (e.shiftKey) {
	                            self.options.ownerDocument.execCommand('outdent', e);
	                        } else {
	                            self.options.ownerDocument.execCommand('indent', e);
	                        }
	                    }
	                } else if (e.which === mediumEditorUtil.keyCode.BACKSPACE || e.which === mediumEditorUtil.keyCode.DELETE || e.which === mediumEditorUtil.keyCode.ENTER) {

	                    // Bind keys which can create or destroy a block element: backspace, delete, return
	                    self.onBlockModifier(e);

	                } else if (e.ctrlKey || e.metaKey) {
	                    key = String.fromCharCode(e.which || e.keyCode).toLowerCase();
	                    self.commands.forEach(function (extension) {
	                        if (extension.options.key && extension.options.key === key) {
	                            extension.handleClick(e);
	                        }
	                    });
	                }
	            });
	            return this;
	        },

	        onBlockModifier: function (e) {
	            var range, sel, p, node = meSelection.getSelectionStart(this.options.ownerDocument),
	                tagName = node.tagName.toLowerCase(),
	                isEmpty = /^(\s+|<br\/?>)?$/i,
	                isHeader = /h\d/i;

	            if ((e.which === mediumEditorUtil.keyCode.BACKSPACE || e.which === mediumEditorUtil.keyCode.ENTER)
	                    && node.previousElementSibling
	                    // in a header
	                    && isHeader.test(tagName)
	                    // at the very end of the block
	                    && meSelection.getCaretOffsets(node).left === 0) {
	                if (e.which === mediumEditorUtil.keyCode.BACKSPACE && isEmpty.test(node.previousElementSibling.innerHTML)) {
	                    // backspacing the begining of a header into an empty previous element will
	                    // change the tagName of the current node to prevent one
	                    // instead delete previous node and cancel the event.
	                    node.previousElementSibling.parentNode.removeChild(node.previousElementSibling);
	                    e.preventDefault();
	                } else if (e.which === mediumEditorUtil.keyCode.ENTER) {
	                    // hitting return in the begining of a header will create empty header elements before the current one
	                    // instead, make "<p><br></p>" element, which are what happens if you hit return in an empty paragraph
	                    p = this.options.ownerDocument.createElement('p');
	                    p.innerHTML = '<br>';
	                    node.previousElementSibling.parentNode.insertBefore(p, node);
	                    e.preventDefault();
	                }
	            } else if (e.which === mediumEditorUtil.keyCode.DELETE
	                        && node.nextElementSibling
	                        && node.previousElementSibling
	                        // not in a header
	                        && !isHeader.test(tagName)
	                        // in an empty tag
	                        && isEmpty.test(node.innerHTML)
	                        // when the next tag *is* a header
	                        && isHeader.test(node.nextElementSibling.tagName)) {
	                // hitting delete in an empty element preceding a header, ex:
	                //  <p>[CURSOR]</p><h1>Header</h1>
	                // Will cause the h1 to become a paragraph.
	                // Instead, delete the paragraph node and move the cursor to the begining of the h1

	                // remove node and move cursor to start of header
	                range = document.createRange();
	                sel = window.getSelection();

	                range.setStart(node.nextElementSibling, 0);
	                range.collapse(true);

	                sel.removeAllRanges();
	                sel.addRange(range);

	                node.previousElementSibling.parentNode.removeChild(node);

	                e.preventDefault();
	            }
	        },

	        initToolbar: function () {
	            if (this.toolbar) {
	                return this;
	            }
	            this.toolbar = this.createToolbar();
	            this.keepToolbarAlive = false;
	            this.toolbarActions = this.toolbar.querySelector('.medium-editor-toolbar-actions');
	            this.anchorPreview = this.createAnchorPreview();

	            return this;
	        },

	        createToolbar: function () {
	            var toolbar = this.options.ownerDocument.createElement('div');
	            toolbar.id = 'medium-editor-toolbar-' + this.id;
	            toolbar.className = 'medium-editor-toolbar';

	            if (this.options.staticToolbar) {
	                toolbar.className += " static-toolbar";
	            } else {
	                toolbar.className += " stalker-toolbar";
	            }

	            toolbar.appendChild(this.toolbarButtons());

	            // Add any forms that extensions may have
	            this.commands.forEach(function (extension) {
	                if (extension.hasForm) {
	                    toolbar.appendChild(extension.getForm());
	                }
	            });

	            this.options.elementsContainer.appendChild(toolbar);
	            return toolbar;
	        },

	        //TODO: actionTemplate
	        toolbarButtons: function () {
	            var ul = this.options.ownerDocument.createElement('ul'),
	                li,
	                btn;

	            ul.id = 'medium-editor-toolbar-actions' + this.id;
	            ul.className = 'medium-editor-toolbar-actions clearfix';

	            this.commands.forEach(function (extension) {
	                if (typeof extension.getButton === 'function') {
	                    btn = extension.getButton(this);
	                    li = this.options.ownerDocument.createElement('li');
	                    if (mediumEditorUtil.isElement(btn)) {
	                        li.appendChild(btn);
	                    } else {
	                        li.innerHTML = btn;
	                    }
	                    ul.appendChild(li);
	                }
	            }.bind(this));

	            return ul;
	        },

	        bindSelect: function () {
	            var i,
	                blurHelper = function (event) {
	                    // Do not close the toolbar when bluring the editable area and clicking into the anchor form
	                    if (event &&
	                            event.type &&
	                            event.type.toLowerCase() === 'blur' &&
	                            event.relatedTarget &&
	                            mediumEditorUtil.isDescendant(this.toolbar, event.relatedTarget)) {
	                        return false;
	                    }
	                    this.checkSelection();
	                }.bind(this),
	                timeoutHelper = function () {
	                    setTimeout(function () {
	                        this.checkSelection();
	                    }.bind(this), 0);
	                }.bind(this);

	            this.on(this.options.ownerDocument.documentElement, 'mouseup', this.checkSelection.bind(this));

	            for (i = 0; i < this.elements.length; i += 1) {
	                this.on(this.elements[i], 'keyup', this.checkSelection.bind(this));
	                this.on(this.elements[i], 'blur', blurHelper);
	                this.on(this.elements[i], 'click', timeoutHelper);
	            }

	            return this;
	        },

	        bindDragDrop: function () {
	            var self = this, i, className, onDrag, onDrop, element;

	            if (!self.options.imageDragging) {
	                return this;
	            }

	            className = 'medium-editor-dragover';

	            onDrag = function (e) {
	                e.preventDefault();
	                e.dataTransfer.dropEffect = "copy";

	                if (e.type === "dragover") {
	                    this.classList.add(className);
	                } else {
	                    this.classList.remove(className);
	                }
	            };

	            onDrop = function (e) {
	                var files;
	                e.preventDefault();
	                e.stopPropagation();
	                files = Array.prototype.slice.call(e.dataTransfer.files, 0);
	                files.some(function (file) {
	                    if (file.type.match("image")) {
	                        var fileReader, id;
	                        fileReader = new FileReader();
	                        fileReader.readAsDataURL(file);

	                        id = 'medium-img-' + (+new Date());
	                        mediumEditorUtil.insertHTMLCommand(self.options.ownerDocument, '<img class="medium-image-loading" id="' + id + '" />');

	                        fileReader.onload = function () {
	                            var img = document.getElementById(id);
	                            if (img) {
	                                img.removeAttribute('id');
	                                img.removeAttribute('class');
	                                img.src = fileReader.result;
	                            }
	                        };
	                    }
	                });
	                this.classList.remove(className);
	            };

	            for (i = 0; i < this.elements.length; i += 1) {
	                element = this.elements[i];


	                this.on(element, 'dragover', onDrag);
	                this.on(element, 'dragleave', onDrag);
	                this.on(element, 'drop', onDrop);
	            }
	            return this;
	        },

	        stopSelectionUpdates: function () {
	            this.preventSelectionUpdates = true;
	        },

	        startSelectionUpdates: function () {
	            this.preventSelectionUpdates = false;
	        },

	        checkSelection: function () {
	            var newSelection,
	                selectionElement;

	            if (!this.preventSelectionUpdates &&
	                    this.keepToolbarAlive !== true &&
	                    !this.options.disableToolbar) {

	                newSelection = this.options.contentWindow.getSelection();
	                if ((!this.options.updateOnEmptySelection && newSelection.toString().trim() === '') ||
	                        (this.options.allowMultiParagraphSelection === false && this.multipleBlockElementsSelected()) ||
	                        meSelection.selectionInContentEditableFalse(this.options.contentWindow)) {
	                    if (!this.options.staticToolbar) {
	                        this.hideToolbarActions();
	                    } else {
	                        this.showAndUpdateToolbar();
	                    }

	                } else {
	                    selectionElement = meSelection.getSelectionElement(this.options.contentWindow);
	                    if (!selectionElement || selectionElement.getAttribute('data-disable-toolbar')) {
	                        if (!this.options.staticToolbar) {
	                            this.hideToolbarActions();
	                        }
	                    } else {
	                        this.checkSelectionElement(newSelection, selectionElement);
	                    }
	                }
	            }
	            return this;
	        },

	        // Checks for existance of multiple block elements in the current selection
	        multipleBlockElementsSelected: function () {
	            /*jslint regexp: true*/
	            var selectionHtml = meSelection.getSelectionHtml.call(this).replace(/<[\S]+><\/[\S]+>/gim, ''),
	                hasMultiParagraphs = selectionHtml.match(/<(p|h[1-6]|blockquote)[^>]*>/g);
	            /*jslint regexp: false*/

	            return !!hasMultiParagraphs && hasMultiParagraphs.length > 1;
	        },

	        checkSelectionElement: function (newSelection, selectionElement) {
	            var i,
	                adjacentNode,
	                offset = 0,
	                newRange;
	            this.selection = newSelection;
	            this.selectionRange = this.selection.getRangeAt(0);

	            /*
	            * In firefox, there are cases (ie doubleclick of a word) where the selectionRange start
	            * will be at the very end of an element.  In other browsers, the selectionRange start
	            * would instead be at the very beginning of an element that actually has content.
	            * example:
	            *   <span>foo</span><span>bar</span>
	            *
	            * If the text 'bar' is selected, most browsers will have the selectionRange start at the beginning
	            * of the 'bar' span.  However, there are cases where firefox will have the selectionRange start
	            * at the end of the 'foo' span.  The contenteditable behavior will be ok, but if there are any
	            * properties on the 'bar' span, they won't be reflected accurately in the toolbar
	            * (ie 'Bold' button wouldn't be active)
	            *
	            * So, for cases where the selectionRange start is at the end of an element/node, find the next
	            * adjacent text node that actually has content in it, and move the selectionRange start there.
	            */
	            if (this.options.standardizeSelectionStart &&
	                    this.selectionRange.startContainer.nodeValue &&
	                    (this.selectionRange.startOffset === this.selectionRange.startContainer.nodeValue.length)) {
	                adjacentNode = mediumEditorUtil.findAdjacentTextNodeWithContent(meSelection.getSelectionElement(this.options.contentWindow), this.selectionRange.startContainer, this.options.ownerDocument);
	                if (adjacentNode) {
	                    offset = 0;
	                    while (adjacentNode.nodeValue.substr(offset, 1).trim().length === 0) {
	                        offset = offset + 1;
	                    }
	                    newRange = this.options.ownerDocument.createRange();
	                    newRange.setStart(adjacentNode, offset);
	                    newRange.setEnd(this.selectionRange.endContainer, this.selectionRange.endOffset);
	                    this.selection.removeAllRanges();
	                    this.selection.addRange(newRange);
	                    this.selectionRange = newRange;
	                }
	            }

	            for (i = 0; i < this.elements.length; i += 1) {
	                if (this.elements[i] === selectionElement) {
	                    this.showAndUpdateToolbar();
	                    return;
	                }
	            }

	            if (!this.options.staticToolbar) {
	                this.hideToolbarActions();
	            }
	        },

	        showAndUpdateToolbar: function () {
	            this.setToolbarButtonStates()
	                .setToolbarPosition()
	                .showToolbarDefaultActions();
	        },

	        setToolbarPosition: function () {
	            // document.documentElement for IE 9
	            var scrollTop = (this.options.ownerDocument.documentElement && this.options.ownerDocument.documentElement.scrollTop) || this.options.ownerDocument.body.scrollTop,
	                container = this.elements[0],
	                containerRect = container.getBoundingClientRect(),
	                containerTop = containerRect.top + scrollTop,
	                buttonHeight = 50,
	                selection = this.options.contentWindow.getSelection(),
	                range,
	                boundary,
	                middleBoundary,
	                defaultLeft = (this.options.diffLeft) - (this.toolbar.offsetWidth / 2),
	                halfOffsetWidth = this.toolbar.offsetWidth / 2,
	                containerCenter = (containerRect.left + (containerRect.width / 2));

	            if (this.options.staticToolbar) {
	                this.showToolbar();

	                if (this.options.stickyToolbar) {

	                    // If it's beyond the height of the editor, position it at the bottom of the editor
	                    if (scrollTop > (containerTop + this.elements[0].offsetHeight - this.toolbar.offsetHeight)) {
	                        this.toolbar.style.top = (containerTop + this.elements[0].offsetHeight) + 'px';

	                    // Stick the toolbar to the top of the window
	                    } else if (scrollTop > (containerTop - this.toolbar.offsetHeight)) {
	                        this.toolbar.classList.add('sticky-toolbar');
	                        this.toolbar.style.top = "0px";
	                    // Normal static toolbar position
	                    } else {
	                        this.toolbar.classList.remove('sticky-toolbar');
	                        this.toolbar.style.top = containerTop - this.toolbar.offsetHeight + "px";
	                    }

	                } else {
	                    this.toolbar.style.top = containerTop - this.toolbar.offsetHeight + "px";
	                }

	                if (this.options.toolbarAlign) {
	                    if (this.options.toolbarAlign === 'left') {
	                        this.toolbar.style.left = containerRect.left + "px";
	                    } else if (this.options.toolbarAlign === 'center') {
	                        this.toolbar.style.left = (containerCenter - halfOffsetWidth) + "px";
	                    } else {
	                        this.toolbar.style.left = (containerRect.right - this.toolbar.offsetWidth) + "px";
	                    }
	                } else {
	                    this.toolbar.style.left = (containerCenter - halfOffsetWidth) + "px";
	                }

	                this.hideAnchorPreview();

	            } else if (selection.focusNode !== null && !selection.isCollapsed) {
	                this.showToolbar();

	                range = selection.getRangeAt(0);
	                boundary = range.getBoundingClientRect();
	                middleBoundary = (boundary.left + boundary.right) / 2;

	                if (boundary.top < buttonHeight) {
	                    this.toolbar.classList.add('medium-toolbar-arrow-over');
	                    this.toolbar.classList.remove('medium-toolbar-arrow-under');
	                    this.toolbar.style.top = buttonHeight + boundary.bottom - this.options.diffTop + this.options.contentWindow.pageYOffset - this.toolbar.offsetHeight + 'px';
	                } else {
	                    this.toolbar.classList.add('medium-toolbar-arrow-under');
	                    this.toolbar.classList.remove('medium-toolbar-arrow-over');
	                    this.toolbar.style.top = boundary.top + this.options.diffTop + this.options.contentWindow.pageYOffset - this.toolbar.offsetHeight + 'px';
	                }
	                if (middleBoundary < halfOffsetWidth) {
	                    this.toolbar.style.left = defaultLeft + halfOffsetWidth + 'px';
	                } else if ((this.options.contentWindow.innerWidth - middleBoundary) < halfOffsetWidth) {
	                    this.toolbar.style.left = this.options.contentWindow.innerWidth + defaultLeft - halfOffsetWidth + 'px';
	                } else {
	                    this.toolbar.style.left = defaultLeft + middleBoundary + 'px';
	                }

	                this.hideAnchorPreview();
	            }

	            return this;
	        },

	        setToolbarButtonStates: function () {
	            this.commands.forEach(function (extension) {
	                if (typeof extension.isActive === 'function') {
	                    extension.setInactive();
	                }
	            }.bind(this));
	            this.checkActiveButtons();
	            return this;
	        },

	        checkActiveButtons: function () {
	            var elements = Array.prototype.slice.call(this.elements),
	                manualStateChecks = [],
	                queryState = null,
	                parentNode,
	                checkExtension = function (extension) {
	                    if (typeof extension.checkState === 'function') {
	                        extension.checkState(parentNode);
	                    } else if (typeof extension.isActive === 'function' &&
	                               typeof extension.isAlreadyApplied === 'function') {
	                        if (!extension.isActive() && extension.isAlreadyApplied(parentNode)) {
	                            extension.setActive();
	                        }
	                    }
	                };

	            if (!this.selectionRange) {
	                return;
	            }
	            parentNode = meSelection.getSelectedParentElement(this.selectionRange);

	            // Loop through all commands
	            this.commands.forEach(function (command) {
	                // For those commands where we can use document.queryCommandState(), do so
	                if (typeof command.queryCommandState === 'function') {
	                    queryState = command.queryCommandState();
	                    // If queryCommandState returns a valid value, we can trust the browser
	                    // and don't need to do our manual checks
	                    if (queryState !== null) {
	                        if (queryState) {
	                            command.setActive();
	                        }
	                        return;
	                    }
	                }
	                // We can't use queryCommandState for this command, so add to manualStateChecks
	                manualStateChecks.push(command);
	            });

	            // Climb up the DOM and do manual checks for whether a certain command is currently enabled for this node
	            while (parentNode.tagName !== undefined && mediumEditorUtil.parentElements.indexOf(parentNode.tagName.toLowerCase) === -1) {
	                manualStateChecks.forEach(checkExtension.bind(this));

	                // we can abort the search upwards if we leave the contentEditable element
	                if (elements.indexOf(parentNode) !== -1) {
	                    break;
	                }
	                parentNode = parentNode.parentNode;
	            }
	        },

	        setFirstAndLastButtons: function () {
	            var buttons = this.toolbar.querySelectorAll('button');
	            if (buttons.length > 0) {
	                buttons[0].className += ' ' + this.options.firstButtonClass;
	                buttons[buttons.length - 1].className += ' ' + this.options.lastButtonClass;
	            }
	            return this;
	        },

	        execAction: function (action, opts) {
	            /*jslint regexp: true*/
	            var fullAction = /^full-(.+)$/gi,
	                match,
	                result;
	            /*jslint regexp: false*/

	            // Actions starting with 'full-' should be applied to to the entire contents of the editable element
	            // (ie full-bold, full-append-pre, etc.)
	            match = fullAction.exec(action);
	            if (match) {
	                // Store the current selection to be restored after applying the action
	                this.saveSelection();
	                // Select all of the contents before calling the action
	                this.selectAllContents();
	                result = this.execActionInternal(match[1], opts);
	                // Restore the previous selection
	                this.restoreSelection();
	            } else {
	                result = this.execActionInternal(action, opts);
	            }

	            this.checkSelection();
	            return result;
	        },

	        execActionInternal: function (action, opts) {
	            /*jslint regexp: true*/
	            var appendAction = /^append-(.+)$/gi,
	                match;
	            /*jslint regexp: false*/

	            // Actions starting with 'append-' should attempt to format a block of text ('formatBlock') using a specific
	            // type of block element (ie append-blockquote, append-h1, append-pre, etc.)
	            match = appendAction.exec(action);
	            if (match) {
	                return this.execFormatBlock(match[1]);
	            }

	            if (action === 'createLink') {
	                return this.createLink(opts);
	            }

	            if (action === 'image') {
	                return this.options.ownerDocument.execCommand('insertImage', false, this.options.contentWindow.getSelection());
	            }

	            return this.options.ownerDocument.execCommand(action, false, null);
	        },

	        // TODO: move these two methods to selection.js
	        // http://stackoverflow.com/questions/15867542/range-object-get-selection-parent-node-chrome-vs-firefox
	        rangeSelectsSingleNode: function (range) {
	            var startNode = range.startContainer;
	            return startNode === range.endContainer &&
	                startNode.hasChildNodes() &&
	                range.endOffset === range.startOffset + 1;
	        },

	        getSelectedParentElement: function () {
	            var selectedParentElement = null,
	                range = this.selectionRange;
	            if (this.rangeSelectsSingleNode(range) && range.startContainer.childNodes[range.startOffset].nodeType !== 3) {
	                selectedParentElement = range.startContainer.childNodes[range.startOffset];
	            } else if (range.startContainer.nodeType === 3) {
	                selectedParentElement = range.startContainer.parentNode;
	            } else {
	                selectedParentElement = range.startContainer;
	            }
	            return selectedParentElement;
	        },

	        execFormatBlock: function (el) {
	            var selectionData = meSelection.getSelectionData(this.selection.anchorNode);
	            // FF handles blockquote differently on formatBlock
	            // allowing nesting, we need to use outdent
	            // https://developer.mozilla.org/en-US/docs/Rich-Text_Editing_in_Mozilla
	            if (el === 'blockquote' && selectionData.el &&
	                    selectionData.el.parentNode.tagName.toLowerCase() === 'blockquote') {
	                return this.options.ownerDocument.execCommand('outdent', false, null);
	            }
	            if (selectionData.tagName === el) {
	                el = 'p';
	            }
	            // When IE we need to add <> to heading elements and
	            //  blockquote needs to be called as indent
	            // http://stackoverflow.com/questions/10741831/execcommand-formatblock-headings-in-ie
	            // http://stackoverflow.com/questions/1816223/rich-text-editor-with-blockquote-function/1821777#1821777
	            if (mediumEditorUtil.isIE) {
	                if (el === 'blockquote') {
	                    return this.options.ownerDocument.execCommand('indent', false, el);
	                }
	                el = '<' + el + '>';
	            }
	            return this.options.ownerDocument.execCommand('formatBlock', false, el);
	        },

	        isToolbarDefaultActionsShown: function () {
	            return !!this.toolbarActions && this.toolbarActions.style.display === 'block';
	        },

	        hideToolbarDefaultActions: function () {
	            if (this.toolbarActions && this.isToolbarDefaultActionsShown()) {
	                this.commands.forEach(function (extension) {
	                    if (extension.onHide && typeof extension.onHide === 'function') {
	                        extension.onHide();
	                    }
	                });
	                this.toolbarActions.style.display = 'none';
	            }
	        },

	        showToolbarDefaultActions: function () {
	            this.hideExtensionForms();

	            if (this.toolbarActions && !this.isToolbarDefaultActionsShown()) {
	                this.toolbarActions.style.display = 'block';
	            }

	            this.keepToolbarAlive = false;
	            // Using setTimeout + options.delay because:
	            // We will actually be displaying the toolbar, which should be controlled by options.delay
	            this.delay(function () {
	                this.showToolbar();
	            }.bind(this));

	            return this;
	        },

	        hideExtensionForms: function () {
	            // Hide all extension forms
	            this.commands.forEach(function (extension) {
	                if (extension.hasForm && extension.isDisplayed()) {
	                    extension.hideForm();
	                }
	            });
	        },

	        isToolbarShown: function () {
	            return this.toolbar && this.toolbar.classList.contains('medium-editor-toolbar-active');
	        },

	        showToolbar: function () {
	            if (this.toolbar && !this.isToolbarShown()) {
	                this.toolbar.classList.add('medium-editor-toolbar-active');
	                if (typeof this.options.onShowToolbar === 'function') {
	                    this.options.onShowToolbar();
	                }
	            }
	        },

	        hideToolbar: function () {
	            if (this.isToolbarShown()) {
	                this.toolbar.classList.remove('medium-editor-toolbar-active');
	                if (typeof this.options.onHideToolbar === 'function') {
	                    this.options.onHideToolbar();
	                }
	            }
	        },

	        hideToolbarActions: function () {
	            this.commands.forEach(function (extension) {
	                if (extension.onHide && typeof extension.onHide === 'function') {
	                    extension.onHide();
	                }
	            });
	            this.keepToolbarAlive = false;
	            this.hideToolbar();
	        },

	        selectAllContents: function () {
	            var range = this.options.ownerDocument.createRange(),
	                sel = this.options.contentWindow.getSelection(),
	                currNode = meSelection.getSelectionElement(this.options.contentWindow);

	            if (currNode) {
	                // Move to the lowest descendant node that still selects all of the contents
	                while (currNode.children.length === 1) {
	                    currNode = currNode.children[0];
	                }

	                range.selectNodeContents(currNode);
	                sel.removeAllRanges();
	                sel.addRange(range);
	            }
	        },

	        // http://stackoverflow.com/questions/17678843/cant-restore-selection-after-html-modify-even-if-its-the-same-html
	        // Tim Down
	        // TODO: move to selection.js and clean up old methods there
	        saveSelection: function () {
	            this.selectionState = null;

	            var selection = this.options.contentWindow.getSelection(),
	                range,
	                preSelectionRange,
	                start,
	                editableElementIndex = -1;

	            if (selection.rangeCount > 0) {
	                range = selection.getRangeAt(0);
	                preSelectionRange = range.cloneRange();

	                // Find element current selection is inside
	                this.elements.forEach(function (el, index) {
	                    if (el === range.startContainer || mediumEditorUtil.isDescendant(el, range.startContainer)) {
	                        editableElementIndex = index;
	                        return false;
	                    }
	                });

	                if (editableElementIndex > -1) {
	                    preSelectionRange.selectNodeContents(this.elements[editableElementIndex]);
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;

	                    this.selectionState = {
	                        start: start,
	                        end: start + range.toString().length,
	                        editableElementIndex: editableElementIndex
	                    };
	                }
	            }
	        },

	        // http://stackoverflow.com/questions/17678843/cant-restore-selection-after-html-modify-even-if-its-the-same-html
	        // Tim Down
	        // TODO: move to selection.js and clean up old methods there
	        restoreSelection: function () {
	            if (!this.selectionState) {
	                return;
	            }

	            var editableElement = this.elements[this.selectionState.editableElementIndex],
	                charIndex = 0,
	                range = this.options.ownerDocument.createRange(),
	                nodeStack = [editableElement],
	                node,
	                foundStart = false,
	                stop = false,
	                i,
	                sel,
	                nextCharIndex;

	            range.setStart(editableElement, 0);
	            range.collapse(true);

	            node = nodeStack.pop();
	            while (!stop && node) {
	                if (node.nodeType === 3) {
	                    nextCharIndex = charIndex + node.length;
	                    if (!foundStart && this.selectionState.start >= charIndex && this.selectionState.start <= nextCharIndex) {
	                        range.setStart(node, this.selectionState.start - charIndex);
	                        foundStart = true;
	                    }
	                    if (foundStart && this.selectionState.end >= charIndex && this.selectionState.end <= nextCharIndex) {
	                        range.setEnd(node, this.selectionState.end - charIndex);
	                        stop = true;
	                    }
	                    charIndex = nextCharIndex;
	                } else {
	                    i = node.childNodes.length - 1;
	                    while (i >= 0) {
	                        nodeStack.push(node.childNodes[i]);
	                        i -= 1;
	                    }
	                }
	                if (!stop) {
	                    node = nodeStack.pop();
	                }
	            }

	            sel = this.options.contentWindow.getSelection();
	            sel.removeAllRanges();
	            sel.addRange(range);
	        },

	        hideAnchorPreview: function () {
	            this.anchorPreview.classList.remove('medium-editor-anchor-preview-active');
	        },

	        // TODO: break method
	        showAnchorPreview: function (anchorEl) {
	            if (this.anchorPreview.classList.contains('medium-editor-anchor-preview-active')
	                    || anchorEl.getAttribute('data-disable-preview')) {
	                return true;
	            }

	            var self = this,
	                buttonHeight = 40,
	                boundary = anchorEl.getBoundingClientRect(),
	                middleBoundary = (boundary.left + boundary.right) / 2,
	                halfOffsetWidth,
	                defaultLeft;

	            self.anchorPreview.querySelector('i').textContent = anchorEl.attributes.href.value;
	            halfOffsetWidth = self.anchorPreview.offsetWidth / 2;
	            defaultLeft = self.options.diffLeft - halfOffsetWidth;

	            self.observeAnchorPreview(anchorEl);

	            self.anchorPreview.classList.add('medium-toolbar-arrow-over');
	            self.anchorPreview.classList.remove('medium-toolbar-arrow-under');
	            self.anchorPreview.style.top = Math.round(buttonHeight + boundary.bottom - self.options.diffTop + this.options.contentWindow.pageYOffset - self.anchorPreview.offsetHeight) + 'px';
	            if (middleBoundary < halfOffsetWidth) {
	                self.anchorPreview.style.left = defaultLeft + halfOffsetWidth + 'px';
	            } else if ((this.options.contentWindow.innerWidth - middleBoundary) < halfOffsetWidth) {
	                self.anchorPreview.style.left = this.options.contentWindow.innerWidth + defaultLeft - halfOffsetWidth + 'px';
	            } else {
	                self.anchorPreview.style.left = defaultLeft + middleBoundary + 'px';
	            }

	            if (this.anchorPreview && !this.anchorPreview.classList.contains('medium-editor-anchor-preview-active')) {
	                this.anchorPreview.classList.add('medium-editor-anchor-preview-active');
	            }

	            return this;
	        },

	        // TODO: break method
	        observeAnchorPreview: function (anchorEl) {
	            var self = this,
	                lastOver = (new Date()).getTime(),
	                over = true,
	                stamp = function () {
	                    lastOver = (new Date()).getTime();
	                    over = true;
	                },
	                unstamp = function (e) {
	                    if (!e.relatedTarget || !/anchor-preview/.test(e.relatedTarget.className)) {
	                        over = false;
	                    }
	                },
	                interval_timer = setInterval(function () {
	                    if (over) {
	                        return true;
	                    }
	                    var durr = (new Date()).getTime() - lastOver;
	                    if (durr > self.options.anchorPreviewHideDelay) {
	                        // hide the preview 1/2 second after mouse leaves the link
	                        self.hideAnchorPreview();

	                        // cleanup
	                        clearInterval(interval_timer);
	                        self.off(self.anchorPreview, 'mouseover', stamp);
	                        self.off(self.anchorPreview, 'mouseout', unstamp);
	                        self.off(anchorEl, 'mouseover', stamp);
	                        self.off(anchorEl, 'mouseout', unstamp);

	                    }
	                }, 200);

	            this.on(self.anchorPreview, 'mouseover', stamp);
	            this.on(self.anchorPreview, 'mouseout', unstamp);
	            this.on(anchorEl, 'mouseover', stamp);
	            this.on(anchorEl, 'mouseout', unstamp);
	        },

	        createAnchorPreview: function () {
	            var self = this,
	                anchorPreview = this.options.ownerDocument.createElement('div');

	            anchorPreview.id = 'medium-editor-anchor-preview-' + this.id;
	            anchorPreview.className = 'medium-editor-anchor-preview';
	            anchorPreview.innerHTML = this.anchorPreviewTemplate();
	            this.options.elementsContainer.appendChild(anchorPreview);

	            this.on(anchorPreview, 'click', function () {
	                self.anchorPreviewClickHandler();
	            });

	            return anchorPreview;
	        },

	        anchorPreviewTemplate: function () {
	            return '<div class="medium-editor-toolbar-anchor-preview" id="medium-editor-toolbar-anchor-preview">' +
	                '    <i class="medium-editor-toolbar-anchor-preview-inner"></i>' +
	                '</div>';
	        },

	        anchorPreviewClickHandler: function (event) {
	            var range,
	                sel,
	                anchorExtension = this.getExtensionByName('anchor');

	            if (anchorExtension && this.activeAnchor) {
	                range = this.options.ownerDocument.createRange();
	                range.selectNodeContents(this.activeAnchor);

	                sel = this.options.contentWindow.getSelection();
	                sel.removeAllRanges();
	                sel.addRange(range);
	                // Using setTimeout + options.delay because:
	                // We may actually be displaying the anchor form, which should be controlled by options.delay
	                this.delay(function () {
	                    if (this.activeAnchor) {
	                        anchorExtension.showForm(this.activeAnchor.attributes.href.value);
	                    }
	                    this.keepToolbarAlive = false;
	                }.bind(this));
	            }

	            this.hideAnchorPreview();
	        },

	        editorAnchorObserver: function (e) {
	            var self = this,
	                overAnchor = true,
	                leaveAnchor = function () {
	                    // mark the anchor as no longer hovered, and stop listening
	                    overAnchor = false;
	                    self.off(self.activeAnchor, 'mouseout', leaveAnchor);
	                };

	            if (e.target && e.target.tagName.toLowerCase() === 'a') {

	                // Detect empty href attributes
	                // The browser will make href="" or href="#top"
	                // into absolute urls when accessed as e.targed.href, so check the html
	                if (!/href=["']\S+["']/.test(e.target.outerHTML) || /href=["']#\S+["']/.test(e.target.outerHTML)) {
	                    return true;
	                }

	                // only show when hovering on anchors
	                if (this.isToolbarShown()) {
	                    // only show when toolbar is not present
	                    return true;
	                }
	                this.activeAnchor = e.target;
	                this.on(this.activeAnchor, 'mouseout', leaveAnchor);
	                // Using setTimeout + options.delay because:
	                // - We're going to show the anchor preview according to the configured delay
	                //   if the mouse has not left the anchor tag in that time
	                this.delay(function () {
	                    if (overAnchor) {
	                        self.showAnchorPreview(e.target);
	                    }
	                });
	            }
	        },

	        bindAnchorPreview: function (index) {
	            var i, self = this;
	            this.editorAnchorObserverWrapper = function (e) {
	                self.editorAnchorObserver(e);
	            };
	            for (i = 0; i < this.elements.length; i += 1) {
	                this.on(this.elements[i], 'mouseover', this.editorAnchorObserverWrapper);
	            }
	            return this;
	        },

	        createLink: function (opts) {
	            var customEvent,
	                i;

	            if (opts.url && opts.url.trim().length > 0) {
	                this.options.ownerDocument.execCommand('createLink', false, opts.url);

	                if (this.options.targetBlank || opts.target === '_blank') {
	                    mediumEditorUtil.setTargetBlank(meSelection.getSelectionStart(this.options.ownerDocument));
	                }

	                if (opts.buttonClass) {
	                    this.setButtonClass(opts.buttonClass);
	                }
	            }

	            if (this.options.targetBlank || opts.target === "_blank" || opts.buttonClass) {
	                customEvent = this.options.ownerDocument.createEvent("HTMLEvents");
	                customEvent.initEvent("input", true, true, this.options.contentWindow);
	                for (i = 0; i < this.elements.length; i += 1) {
	                    this.elements[i].dispatchEvent(customEvent);
	                }
	            }
	        },

	        setButtonClass: function (buttonClass) {
	            var el = meSelection.getSelectionStart(this.options.ownerDocument),
	                classes = buttonClass.split(' '),
	                i,
	                j;
	            if (el.tagName.toLowerCase() === 'a') {
	                for (j = 0; j < classes.length; j += 1) {
	                    el.classList.add(classes[j]);
	                }
	            } else {
	                el = el.getElementsByTagName('a');
	                for (i = 0; i < el.length; i += 1) {
	                    for (j = 0; j < classes.length; j += 1) {
	                        el[i].classList.add(classes[j]);
	                    }
	                }
	            }
	        },

	        positionToolbarIfShown: function () {
	            if (this.isToolbarShown()) {
	                this.setToolbarPosition();
	            }
	        },

	        bindWindowActions: function () {
	            var self = this;

	            // Add a scroll event for sticky toolbar
	            if (this.options.staticToolbar && this.options.stickyToolbar) {
	                // On scroll, re-position the toolbar
	                this.on(this.options.contentWindow, 'scroll', function () {
	                    self.positionToolbarIfShown();
	                }, true);
	            }

	            this.on(this.options.contentWindow, 'resize', function () {
	                self.handleResize();
	            });

	            this.bindBlur();

	            return this;
	        },

	        activate: function () {
	            if (this.isActive) {
	                return;
	            }

	            this.setup();
	        },

	        // TODO: break method
	        deactivate: function () {
	            var i;
	            if (!this.isActive) {
	                return;
	            }
	            this.isActive = false;

	            if (this.toolbar !== undefined) {
	                this.options.elementsContainer.removeChild(this.anchorPreview);
	                this.options.elementsContainer.removeChild(this.toolbar);
	                delete this.toolbar;
	                delete this.anchorPreview;
	            }

	            for (i = 0; i < this.elements.length; i += 1) {
	                this.elements[i].removeAttribute('contentEditable');
	                this.elements[i].removeAttribute('data-medium-element');
	            }

	            this.commands.forEach(function (extension) {
	                if (typeof extension.deactivate === 'function') {
	                    extension.deactivate();
	                }
	            }.bind(this));

	            this.removeAllEvents();
	        },

	        bindPaste: function () {
	            var i, self = this;
	            this.pasteWrapper = function (e) {
	                pasteHandler.handlePaste(this, e, self.options);
	            };
	            for (i = 0; i < this.elements.length; i += 1) {
	                this.on(this.elements[i], 'paste', this.pasteWrapper);
	            }
	            return this;
	        },

	        setPlaceholders: function () {
	            if (!this.options.disablePlaceholders && this.elements && this.elements.length) {
	                this.elements.forEach(function (el) {
	                    this.activatePlaceholder(el);
	                    this.on(el, 'blur', this.placeholderWrapper.bind(this));
	                    this.on(el, 'keypress', this.placeholderWrapper.bind(this));
	                }.bind(this));
	            }

	            return this;
	        },

	        cleanPaste: function (text) {
	            pasteHandler.cleanPaste(text, this.options);
	        },

	        pasteHTML: function (html) {
	            pasteHandler.pasteHTML(html, this.options.ownerDocument);
	        }
	    };

	}());

	    return MediumEditor;
	}()));


/***/ },

/***/ 1056:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DragDropActionCreators = __webpack_require__(500),
	    DragOperationStore = __webpack_require__(358),
	    NativeDragItemTypes = __webpack_require__(502),
	    EnterLeaveMonitor = __webpack_require__(504),
	    isFileDragDropEvent = __webpack_require__(506),
	    configureDataTransfer = __webpack_require__(1064),
	    shallowEqual = __webpack_require__(46),
	    isWebkit = __webpack_require__(1071);

	// Store global state for browser-specific fixes and workarounds
	var _monitor = new EnterLeaveMonitor(),
	    _currentDragTarget,
	    _currentComponent,
	    _initialDragTargetRect,
	    _dragTargetRectDidChange,
	    _currentDropEffect;

	function getElementRect(el) {
	  var rect = el.getBoundingClientRect();
	  // Copy so object doesn't get reused
	  return { top: rect.top, left: rect.left, width: rect.width, height: rect.height };
	}

	function checkIfCurrentDragTargetRectChanged() {
	  if (!_dragTargetRectDidChange) {
	    var currentRect = getElementRect(_currentDragTarget);
	    _dragTargetRectDidChange = !shallowEqual(_initialDragTargetRect, currentRect);
	  }

	  return _dragTargetRectDidChange;
	}

	function triggerDragEndIfDragSourceWasRemovedFromDOM() {
	  if (!_currentComponent || document.body.contains(_currentDragTarget)) {
	    return;
	  }

	  var type = DragOperationStore.getDraggedItemType();
	  _currentComponent.handleDragEnd(type, null);
	}

	function preventDefaultFileDropAction(e) {
	  if (isFileDragDropEvent(e)) {
	    e.preventDefault();
	  }
	}

	function handleTopDragEnter(e) {
	  // IE requires this to not show a nodrag icon over the container
	  e.preventDefault();

	  var isFirstEnter = _monitor.enter(e.target);
	  if (isFirstEnter && isFileDragDropEvent(e)) {
	    DragDropActionCreators.startDragging(NativeDragItemTypes.FILE, null);
	  }
	}

	function handleTopDragOver(e) {
	  preventDefaultFileDropAction(e);

	  var offsetFromClient = HTML5.getOffsetFromClient(_currentComponent, e);
	  DragDropActionCreators.drag(offsetFromClient);

	  // At the top level of event bubbling, use previously set drop effect and reset it.
	  if (_currentDropEffect) {
	    e.dataTransfer.dropEffect = _currentDropEffect;
	    _currentDropEffect = null;
	  }

	  if (_currentDragTarget && isWebkit() && checkIfCurrentDragTargetRectChanged()) {
	    // Prevent animating to incorrect position
	    e.preventDefault();
	  }
	}

	function handleTopDragLeave(e) {
	  preventDefaultFileDropAction(e);

	  var isLastLeave = _monitor.leave(e.target);
	  if (isLastLeave && isFileDragDropEvent(e)) {
	    DragDropActionCreators.endDragging();
	  }
	}

	function handleTopDrop(e) {
	  preventDefaultFileDropAction(e);

	  _monitor.reset();

	  if (isFileDragDropEvent(e)) {
	    DragDropActionCreators.endDragging();
	  }

	  triggerDragEndIfDragSourceWasRemovedFromDOM();
	}

	var HTML5 = {
	  setup: function setup(component) {
	    if (typeof window === "undefined") {
	      return;
	    }

	    window.addEventListener("dragenter", handleTopDragEnter);
	    window.addEventListener("dragover", handleTopDragOver);
	    window.addEventListener("dragleave", handleTopDragLeave);
	    window.addEventListener("drop", handleTopDrop);
	  },

	  teardown: function teardown(component) {
	    if (typeof window === "undefined") {
	      return;
	    }

	    window.removeEventListener("dragenter", handleTopDragEnter);
	    window.removeEventListener("dragover", handleTopDragOver);
	    window.removeEventListener("dragleave", handleTopDragLeave);
	    window.removeEventListener("drop", handleTopDrop);
	  },

	  beginDrag: function beginDrag(component, e, containerNode, dragPreview, dragAnchors, offsetFromContainer, effectsAllowed) {
	    var _e$nativeEvent = e.nativeEvent;
	    var dataTransfer = _e$nativeEvent.dataTransfer;
	    var target = _e$nativeEvent.target;
	    configureDataTransfer(dataTransfer, containerNode, dragPreview, dragAnchors, offsetFromContainer, effectsAllowed);

	    _currentComponent = component;
	    _currentDragTarget = target;
	    _initialDragTargetRect = getElementRect(target);
	    _dragTargetRectDidChange = false;

	    // Mouse event tell us that dragging has ended but `dragend` didn't fire.
	    // This may happen if source DOM was removed while dragging.

	    window.addEventListener("mousemove", triggerDragEndIfDragSourceWasRemovedFromDOM, true);
	  },

	  endDrag: function endDrag(component) {
	    _currentDragTarget = null;
	    _currentComponent = null;
	    _initialDragTargetRect = null;
	    _dragTargetRectDidChange = false;

	    window.removeEventListener("mousemove", triggerDragEndIfDragSourceWasRemovedFromDOM, true);
	  },

	  dragOver: function dragOver(component, e, dropEffect) {
	    // As event bubbles top-down, first specified effect will be used
	    if (!_currentDropEffect) {
	      _currentDropEffect = dropEffect;
	    }
	  },

	  getDragSourceProps: function getDragSourceProps(component, type) {
	    return {
	      draggable: true,
	      onDragStart: component.handleDragStart.bind(component, type),
	      onDragEnd: component.handleDragEnd.bind(component, type)
	    };
	  },

	  getDropTargetProps: function getDropTargetProps(component, types) {
	    return {
	      onDragEnter: component.handleDragEnter.bind(component, types),
	      onDragOver: component.handleDragOver.bind(component, types),
	      onDragLeave: component.handleDragLeave.bind(component, types),
	      onDrop: component.handleDrop.bind(component, types)
	    };
	  },

	  getOffsetFromClient: function getOffsetFromClient(component, e) {
	    return {
	      x: e.clientX,
	      y: e.clientY
	    };
	  }
	};

	module.exports = HTML5;

/***/ },

/***/ 1057:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	module.exports = {
	  HTML5: __webpack_require__(1056)
	};

/***/ },

/***/ 1058:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DragOperationStore = __webpack_require__(358),
	    DragOffsetStore = __webpack_require__(357);

	var DragLayerMixin = {
	  getInitialState: function getInitialState() {
	    return this.getStateForDragLayerMixin();
	  },

	  getDragLayerState: function getDragLayerState() {
	    var _state = this.state;
	    var isDragging = _state.isDragging;
	    var draggedItemType = _state.draggedItemType;
	    var draggedItem = _state.draggedItem;
	    var initialOffset = _state.initialOffset;
	    var currentOffset = _state.currentOffset;
	    return { isDragging: isDragging, draggedItemType: draggedItemType, draggedItem: draggedItem, initialOffset: initialOffset, currentOffset: currentOffset };
	  },

	  getStateForDragLayerMixin: function getStateForDragLayerMixin() {
	    var initialOffsetFromClient = DragOffsetStore.getInitialOffsetFromClient(),
	        currentOffsetFromClient = DragOffsetStore.getCurrentOffsetFromClient(),
	        initialOffsetFromContainer = DragOffsetStore.getInitialOffsetFromContainer(),
	        isDragging = false,
	        draggedItemType = null,
	        draggedItem = null,
	        initialOffset = null,
	        currentOffset = null;

	    if (initialOffsetFromClient && currentOffsetFromClient) {
	      isDragging = true;
	      draggedItemType = DragOperationStore.getDraggedItemType();
	      draggedItem = DragOperationStore.getDraggedItem();

	      initialOffset = {
	        x: initialOffsetFromClient.x - initialOffsetFromContainer.x,
	        y: initialOffsetFromClient.y - initialOffsetFromContainer.y
	      };

	      currentOffset = {
	        x: currentOffsetFromClient.x - initialOffsetFromContainer.x,
	        y: currentOffsetFromClient.y - initialOffsetFromContainer.y
	      };
	    }

	    return { isDragging: isDragging, draggedItemType: draggedItemType, draggedItem: draggedItem, initialOffset: initialOffset, currentOffset: currentOffset };
	  },

	  handleStoreChangeInDragLayerMixin: function handleStoreChangeInDragLayerMixin() {
	    if (this.isMounted()) {
	      this.setState(this.getStateForDragLayerMixin());
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    DragOffsetStore.addChangeListener(this.handleStoreChangeInDragLayerMixin);
	    DragOperationStore.addChangeListener(this.handleStoreChangeInDragLayerMixin);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    DragOffsetStore.removeChangeListener(this.handleStoreChangeInDragLayerMixin);
	    DragOperationStore.removeChangeListener(this.handleStoreChangeInDragLayerMixin);
	  }
	};

	module.exports = DragLayerMixin;

/***/ },

/***/ 1059:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var getDragImageScale = __webpack_require__(1069);

	var TRANSPARENT_PIXEL_SRC = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

	var ImagePreloaderMixin = {
	  componentDidMount: function componentDidMount() {
	    this._cachedImages = {};
	    this._readyImages = {};
	    this.preloadImages();
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    this.preloadImages();
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    for (var key in this._cachedImages) {
	      this._cachedImages[key].src = TRANSPARENT_PIXEL_SRC;
	    }

	    this._cachedImages = {};
	  },

	  hasPreloadedImage: function hasPreloadedImage(url) {
	    return !!this._readyImages[url];
	  },

	  getPreloadedImage: function getPreloadedImage(url) {
	    if (this.hasPreloadedImage(url)) {
	      return this._cachedImages[url];
	    }
	  },

	  preloadImages: function preloadImages() {
	    var urls = this.getImageUrlsToPreload();
	    urls.forEach(this.preloadImage);
	  },

	  preloadImage: function preloadImage(url) {
	    var _this = this;
	    if (!url || this._cachedImages[url]) {
	      return;
	    }

	    var img = new Image();
	    img.onload = function () {
	      if (_this.isMounted()) {
	        _this._readyImages[url] = true;
	      }
	    };
	    img.onerror = function () {
	      if (_this.isMounted()) {
	        delete _this._cachedImages[url];
	      }
	    };
	    img.src = url;

	    this._cachedImages[url] = img;
	  },

	  getDragImageScale: getDragImageScale
	};

	module.exports = ImagePreloaderMixin;

/***/ },

/***/ 1060:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var invariant = __webpack_require__(11),
	    noop = __webpack_require__(234);

	var DefaultDragSource = {
	  canDrag: function canDrag() {
	    return true;
	  },

	  beginDrag: function beginDrag() {
	    invariant(false, "Drag source must contain a method called beginDrag. See https://github.com/gaearon/react-dnd#drag-source-api");
	  },

	  endDrag: noop
	};

	module.exports = DefaultDragSource;

/***/ },

/***/ 1061:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var noop = __webpack_require__(234);

	var DefaultDropTarget = {
	  canDrop: function canDrop() {
	    return true;
	  },

	  getDropEffect: function getDropEffect(component, allowedEffects) {
	    return allowedEffects[0];
	  },

	  enter: noop,
	  over: noop,
	  leave: noop,
	  acceptDrop: noop
	};

	module.exports = DefaultDropTarget;

/***/ },

/***/ 1062:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DragOffsetStore = __webpack_require__(357);

	var DragDropContext = {
	  getCurrentOffsetDelta: function getCurrentOffsetDelta() {
	    var initialOffset = DragOffsetStore.getInitialOffsetFromClient(),
	        currentOffset = DragOffsetStore.getCurrentOffsetFromClient();

	    return {
	      x: currentOffset.x - initialOffset.x,
	      y: currentOffset.y - initialOffset.y
	    };
	  }
	};

	module.exports = DragDropContext;

/***/ },

/***/ 1063:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var noop = __webpack_require__(234);

	var LegacyDefaultDropTarget = {
	  canDrop: function canDrop() {
	    return true;
	  },

	  getDropEffect: function getDropEffect(allowedEffects) {
	    return allowedEffects[0];
	  },

	  enter: noop,
	  over: noop,
	  leave: noop,
	  acceptDrop: noop
	};

	module.exports = LegacyDefaultDropTarget;

/***/ },

/***/ 1064:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var shouldUseDragPreview = __webpack_require__(1072),
	    getDragImageOffset = __webpack_require__(1068),
	    getBrowserEffectAllowed = __webpack_require__(1067);

	function configureDataTransfer(dataTransfer, containerNode, dragPreview, dragAnchors, offsetFromContainer, effectsAllowed) {
	  try {
	    // Firefox won't drag without setting data
	    dataTransfer.setData("application/json", {});
	  } catch (err) {}

	  if (shouldUseDragPreview(dragPreview) && dataTransfer.setDragImage) {
	    var dragOffset = getDragImageOffset(containerNode, dragPreview, dragAnchors, offsetFromContainer);
	    dataTransfer.setDragImage(dragPreview, dragOffset.x, dragOffset.y);
	  }

	  dataTransfer.effectAllowed = getBrowserEffectAllowed(effectsAllowed);
	}

	module.exports = configureDataTransfer;
	// IE doesn't support MIME types in setData

/***/ },

/***/ 1065:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DragDropActionCreators = __webpack_require__(500),
	    DragOperationStore = __webpack_require__(358),
	    DragDropContext = __webpack_require__(1062),
	    EnterLeaveMonitor = __webpack_require__(504),
	    DropEffects = __webpack_require__(355),
	    DefaultDragSource = __webpack_require__(1060),
	    DefaultDropTarget = __webpack_require__(1061),
	    LegacyDefaultDropTarget = __webpack_require__(1063),
	    isFileDragDropEvent = __webpack_require__(506),
	    invariant = __webpack_require__(11),
	    warning = __webpack_require__(26),
	    assign = __webpack_require__(15),
	    defaults = __webpack_require__(1041),
	    isArray = __webpack_require__(102),
	    isObject = __webpack_require__(104),
	    noop = __webpack_require__(234);

	function checkValidType(component, type) {
	  invariant(type && typeof type === "string", "Expected item type to be a non-empty string. See %s", component.constructor.displayName);
	}

	function checkDragSourceDefined(component, type) {
	  var displayName = component.constructor.displayName;

	  invariant(component._dragSources[type], "There is no drag source for \"%s\" registered in %s. " + "Have you forgotten to register it? " + "See configureDragDrop in %s", type, displayName, displayName);
	}

	function checkDropTargetDefined(component, type) {
	  var displayName = component.constructor.displayName;

	  invariant(component._dropTargets[type], "There is no drop target for \"%s\" registered in %s. " + "Have you forgotten to register it? " + "See configureDragDrop in %s", type, displayName, displayName);
	}

	function callDragDropLifecycle(func, component) {
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }

	  if (component.constructor._legacyConfigureDragDrop) {
	    return func.apply(component, rest);
	  }

	  return func.call.apply(func, [null, component].concat(rest));
	}

	function createDragDropMixin(backend) {
	  var refs = 0;

	  function useBackend(component) {
	    if (refs === 0) {
	      backend.setup(component);
	    }
	    refs++;
	  }

	  function unuseBackend(component) {
	    refs--;
	    if (refs === 0) {
	      backend.teardown(component);
	    }
	  }

	  /**
	   * Use this mixin to define drag sources and drop targets.
	   */
	  return {
	    getInitialState: function getInitialState() {
	      var state = {
	        ownDraggedItemType: null,
	        currentDropEffect: null
	      };

	      return assign(state, this.getStateForDragDropMixin());
	    },

	    getActiveDropTargetType: function getActiveDropTargetType() {
	      var _state = this.state;
	      var draggedItemType = _state.draggedItemType;
	      var draggedItem = _state.draggedItem;
	      var ownDraggedItemType = _state.ownDraggedItemType;
	      var dropTarget = this._dropTargets[draggedItemType];

	      if (!dropTarget) {
	        return null;
	      }

	      if (draggedItemType === ownDraggedItemType) {
	        return null;
	      }

	      var canDrop = dropTarget.canDrop;
	      return callDragDropLifecycle(canDrop, this, draggedItem) ? draggedItemType : null;
	    },

	    isAnyDropTargetActive: function isAnyDropTargetActive(types) {
	      return types.indexOf(this.getActiveDropTargetType()) > -1;
	    },

	    getStateForDragDropMixin: function getStateForDragDropMixin() {
	      return {
	        draggedItem: DragOperationStore.getDraggedItem(),
	        draggedItemType: DragOperationStore.getDraggedItemType()
	      };
	    },

	    getDragState: function getDragState(type) {
	      checkValidType(this, type);
	      checkDragSourceDefined(this, type);

	      return {
	        isDragging: this.state.ownDraggedItemType === type
	      };
	    },

	    getDropState: function getDropState(type) {
	      checkValidType(this, type);
	      checkDropTargetDefined(this, type);

	      var isDragging = this.getActiveDropTargetType() === type,
	          isHovering = !!this.state.currentDropEffect;

	      return {
	        isDragging: isDragging,
	        isHovering: isDragging && isHovering
	      };
	    },

	    componentWillMount: function componentWillMount() {
	      this._monitor = new EnterLeaveMonitor();
	      this._dragSources = {};
	      this._dropTargets = {};

	      if (this.configureDragDrop) {
	        warning(this.constructor._legacyConfigureDragDrop, "%s declares configureDragDrop as an instance method, which is deprecated and will be removed in next version. " + "Move configureDragDrop to statics and change all methods inside it to accept component as first parameter instead of using \"this\".", this.constructor.displayName);

	        this.constructor._legacyConfigureDragDrop = true;
	        this.configureDragDrop(this.registerDragDropItemTypeHandlers);
	      } else if (this.constructor.configureDragDrop) {
	        this.constructor.configureDragDrop(this.registerDragDropItemTypeHandlers, DragDropContext);
	      } else {
	        invariant(this.constructor.configureDragDrop, "%s must implement static configureDragDrop(register, context) to use DragDropMixin", this.constructor.displayName);
	      }
	    },

	    componentDidMount: function componentDidMount() {
	      useBackend(this);
	      DragOperationStore.addChangeListener(this.handleStoreChangeInDragDropMixin);
	    },

	    componentWillUnmount: function componentWillUnmount() {
	      unuseBackend(this);
	      DragOperationStore.removeChangeListener(this.handleStoreChangeInDragDropMixin);
	    },

	    registerDragDropItemTypeHandlers: function registerDragDropItemTypeHandlers(type, handlers) {
	      checkValidType(this, type);

	      var dragSource = handlers.dragSource;
	      var dropTarget = handlers.dropTarget;


	      if (dragSource) {
	        invariant(!this._dragSources[type], "Drag source for %s specified twice. See configureDragDrop in %s", type, this.constructor.displayName);

	        this._dragSources[type] = defaults(dragSource, DefaultDragSource);
	      }

	      if (dropTarget) {
	        invariant(!this._dropTargets[type], "Drop target for %s specified twice. See configureDragDrop in %s", type, this.constructor.displayName);

	        this._dropTargets[type] = defaults(dropTarget, this.constructor._legacyConfigureDragDrop ? LegacyDefaultDropTarget : DefaultDropTarget);
	      }
	    },

	    handleStoreChangeInDragDropMixin: function handleStoreChangeInDragDropMixin() {
	      if (this.isMounted()) {
	        this.setState(this.getStateForDragDropMixin());
	      }
	    },

	    dragSourceFor: function dragSourceFor(type) {
	      checkValidType(this, type);
	      checkDragSourceDefined(this, type);

	      return backend.getDragSourceProps(this, type);
	    },

	    handleDragStart: function handleDragStart(type, e) {
	      var _this = this;
	      var _dragSources$type = this._dragSources[type];
	      var canDrag = _dragSources$type.canDrag;
	      var beginDrag = _dragSources$type.beginDrag;


	      if (!callDragDropLifecycle(canDrag, this, e)) {
	        e.preventDefault();
	        return;
	      }

	      var _callDragDropLifecycle = callDragDropLifecycle(beginDrag, this, e);

	      var item = _callDragDropLifecycle.item;
	      var dragPreview = _callDragDropLifecycle.dragPreview;
	      var dragAnchors = _callDragDropLifecycle.dragAnchors;
	      var effectsAllowed = _callDragDropLifecycle.effectsAllowed;
	      var containerNode = this.getDOMNode();
	      var containerRect = containerNode.getBoundingClientRect();
	      var offsetFromClient = backend.getOffsetFromClient(this, e);
	      var offsetFromContainer;

	      offsetFromContainer = {
	        x: offsetFromClient.x - containerRect.left,
	        y: offsetFromClient.y - containerRect.top
	      };

	      if (!effectsAllowed) {
	        // Move is a sensible default drag effect.
	        // Browser shows a drag preview anyway so we usually don't want "+" icon.
	        effectsAllowed = [DropEffects.MOVE];
	      }

	      invariant(isArray(effectsAllowed) && effectsAllowed.length > 0, "Expected effectsAllowed to be non-empty array");
	      invariant(isObject(item), "Expected return value of beginDrag to contain \"item\" object");

	      backend.beginDrag(this, e, containerNode, dragPreview, dragAnchors, offsetFromContainer, effectsAllowed);
	      DragDropActionCreators.startDragging(type, item, effectsAllowed, offsetFromClient, offsetFromContainer);

	      // Delay setting own state by a tick so `getDragState(type).isDragging`
	      // doesn't return `true` yet. Otherwise browser will capture dragged state
	      // as the element screenshot.

	      setTimeout(function () {
	        if (_this.isMounted() && DragOperationStore.getDraggedItem() === item) {
	          _this.setState({
	            ownDraggedItemType: type
	          });
	        }
	      });
	    },

	    handleDragEnd: function handleDragEnd(type, e) {
	      backend.endDrag(this);

	      var endDrag = this._dragSources[type].endDrag;
	      var effect = DragOperationStore.getDropEffect();

	      DragDropActionCreators.endDragging();

	      // Note: this method may be invoked even *after* component was unmounted
	      // This happens if source node was removed from DOM while dragging.

	      if (this.isMounted()) {
	        this.setState({
	          ownDraggedItemType: null
	        });
	      }

	      callDragDropLifecycle(endDrag, this, effect, e);
	    },

	    dropTargetFor: function dropTargetFor() {
	      var _this = this;
	      for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
	        types[_key] = arguments[_key];
	      }

	      types.forEach(function (type) {
	        checkValidType(_this, type);
	        checkDropTargetDefined(_this, type);
	      });

	      return backend.getDropTargetProps(this, types);
	    },

	    handleDragEnter: function handleDragEnter(types, e) {
	      if (!this.isAnyDropTargetActive(types)) {
	        return;
	      }

	      if (!this._monitor.enter(e.target)) {
	        return;
	      }

	      // IE requires this to trigger dragOver events
	      e.preventDefault();

	      var _dropTargets$state$draggedItemType = this._dropTargets[this.state.draggedItemType];
	      var enter = _dropTargets$state$draggedItemType.enter;
	      var getDropEffect = _dropTargets$state$draggedItemType.getDropEffect;
	      var effectsAllowed = DragOperationStore.getEffectsAllowed();

	      if (isFileDragDropEvent(e)) {
	        // Use Copy drop effect for dragging files.
	        // Because browser gives no drag preview, "+" icon is useful.
	        effectsAllowed = [DropEffects.COPY];
	      }

	      var dropEffect = callDragDropLifecycle(getDropEffect, this, effectsAllowed);
	      if (dropEffect) {
	        invariant(effectsAllowed.indexOf(dropEffect) > -1, "Effect %s supplied by drop target is not one of the effects allowed by drag source: %s", dropEffect, effectsAllowed.join(", "));
	      }

	      this.setState({
	        currentDropEffect: dropEffect
	      });

	      callDragDropLifecycle(enter, this, this.state.draggedItem, e);
	    },

	    handleDragOver: function handleDragOver(types, e) {
	      if (!this.isAnyDropTargetActive(types)) {
	        return;
	      }

	      e.preventDefault();

	      var _dropTargets$state$draggedItemType = this._dropTargets[this.state.draggedItemType];
	      var over = _dropTargets$state$draggedItemType.over;
	      var getDropEffect = _dropTargets$state$draggedItemType.getDropEffect;
	      callDragDropLifecycle(over, this, this.state.draggedItem, e);

	      // Don't use `none` because this will prevent browser from firing `dragend`
	      backend.dragOver(this, e, this.state.currentDropEffect || "move");
	    },

	    handleDragLeave: function handleDragLeave(types, e) {
	      if (!this.isAnyDropTargetActive(types)) {
	        return;
	      }

	      if (!this._monitor.leave(e.target)) {
	        return;
	      }

	      this.setState({
	        currentDropEffect: null
	      });

	      var leave = this._dropTargets[this.state.draggedItemType].leave;
	      callDragDropLifecycle(leave, this, this.state.draggedItem, e);
	    },

	    handleDrop: function handleDrop(types, e) {
	      if (!this.isAnyDropTargetActive(types)) {
	        return;
	      }

	      e.preventDefault();

	      var item = this.state.draggedItem;
	      var acceptDrop = this._dropTargets[this.state.draggedItemType].acceptDrop;
	      var currentDropEffect = this.state.currentDropEffect;
	      var isHandled = !!DragOperationStore.getDropEffect();

	      if (isFileDragDropEvent(e)) {
	        // We don't know file list until the `drop` event,
	        // so we couldn't put `item` into the store.
	        item = {
	          files: Array.prototype.slice.call(e.dataTransfer.files)
	        };
	      }

	      this._monitor.reset();

	      if (!isHandled) {
	        DragDropActionCreators.recordDrop(currentDropEffect);
	      }

	      this.setState({
	        currentDropEffect: null
	      });

	      callDragDropLifecycle(acceptDrop, this, item, e, isHandled, DragOperationStore.getDropEffect());
	    }
	  };
	}

	module.exports = createDragDropMixin;

/***/ },

/***/ 1066:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	function endsWith(str, suffix) {
	  return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}

	module.exports = endsWith;

/***/ },

/***/ 1067:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var DropEffects = __webpack_require__(355);

	function getBrowserEffectAllowed(effectsAllowed) {
	  var allowCopy = effectsAllowed.indexOf(DropEffects.COPY) > -1,
	      allowMove = effectsAllowed.indexOf(DropEffects.MOVE) > -1,
	      allowLink = effectsAllowed.indexOf(DropEffects.LINK) > -1;

	  if (allowCopy && allowMove && allowLink) {
	    return "all";
	  } else if (allowCopy && allowMove) {
	    return "copyMove";
	  } else if (allowLink && allowMove) {
	    return "linkMove";
	  } else if (allowCopy && allowLink) {
	    return "copyLink";
	  } else if (allowCopy) {
	    return "copy";
	  } else if (allowMove) {
	    return "move";
	  } else if (allowLink) {
	    return "link";
	  } else {
	    return "none";
	  }
	}

	module.exports = getBrowserEffectAllowed;

/***/ },

/***/ 1068:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var HorizontalDragAnchors = __webpack_require__(501),
	    VerticalDragAnchors = __webpack_require__(503),
	    isSafari = __webpack_require__(359);

	/**
	 * Returns offset to be used as arguments for `dataTransfer.setDragImage(dragImage, x, y)`.
	 * Attempts to work around browser differences, especially on high-DPI screens.
	 */
	function getDragImageOffset(containerNode, dragPreview, dragAnchors, offsetFromContainer) {
	  dragAnchors = dragAnchors || {};

	  var containerWidth = containerNode.offsetWidth;
	  var containerHeight = containerNode.offsetHeight;
	  var isImage = dragPreview instanceof Image;
	  var previewWidth = isImage ? dragPreview.width : containerWidth;
	  var previewHeight = isImage ? dragPreview.height : containerHeight;
	  var horizontalAnchor = dragAnchors.horizontal || HorizontalDragAnchors.CENTER;
	  var verticalAnchor = dragAnchors.vertical || VerticalDragAnchors.CENTER;var x = offsetFromContainer.x;
	  var y = offsetFromContainer.y;


	  // Work around @2x coordinate discrepancies in browsers
	  if (isSafari()) {
	    previewHeight /= window.devicePixelRatio;
	    previewWidth /= window.devicePixelRatio;
	  }

	  switch (horizontalAnchor) {
	    case HorizontalDragAnchors.LEFT:
	      break;
	    case HorizontalDragAnchors.CENTER:
	      x *= previewWidth / containerWidth;
	      break;
	    case HorizontalDragAnchors.RIGHT:
	      x = previewWidth - previewWidth * (1 - x / containerWidth);
	      break;
	  }

	  switch (verticalAnchor) {
	    case VerticalDragAnchors.TOP:
	      break;
	    case VerticalDragAnchors.CENTER:
	      y *= previewHeight / containerHeight;
	      break;
	    case VerticalDragAnchors.BOTTOM:
	      y = previewHeight - previewHeight * (1 - y / containerHeight);
	      break;
	  }

	  // Work around Safari 8 positioning bug
	  if (isSafari()) {
	    // We'll have to wait for @3x to see if this is entirely correct
	    y += (window.devicePixelRatio - 1) * previewHeight;
	  }

	  return {
	    x: x,
	    y: y
	  };
	}

	module.exports = getDragImageOffset;

/***/ },

/***/ 1069:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var isFirefox = __webpack_require__(1070),
	    isSafari = __webpack_require__(359);

	function getDragImageScale() {
	  if (isFirefox() || isSafari()) {
	    return window.devicePixelRatio;
	  } else {
	    return 1;
	  }
	}

	module.exports = getDragImageScale;

/***/ },

/***/ 1070:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	function isFirefox() {
	  return /firefox/i.test(navigator.userAgent);
	}

	module.exports = isFirefox;

/***/ },

/***/ 1071:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	function isWebkit() {
	  return "WebkitAppearance" in document.documentElement.style;
	}

	module.exports = isWebkit;

/***/ },

/***/ 1072:
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var isSafari = __webpack_require__(359),
	    endsWith = __webpack_require__(1066);

	function shouldUseDragPreview(dragPreview) {
	  if (!dragPreview) {
	    return false;
	  }

	  if (isSafari() && dragPreview instanceof Image && endsWith(dragPreview.src, ".gif")) {
	    // GIFs crash Safari
	    return false;
	  }

	  return true;
	}

	module.exports = shouldUseDragPreview;

/***/ }

});


/** WEBPACK FOOTER **
 ** 1.chunk.464563a57913d095d065.js
 **/